// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23696868%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27><polyline points=%276 9 12 15 18 9%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Meeting Kiosk — bundled CSS
   Ported from Anthropic Claude Design package:
     publicinput-frontend-public-design-system/project/kiosk/Meeting check-in kiosk.html
     publicinput-frontend-public-design-system/project/colors_and_type.css
   Scoped under .meeting-kiosk-shell on the App root so styles can't leak
   into other pages on the same hostname. Fonts come from Google Fonts CDN
   loaded in Views/MeetingKiosk/Index.cshtml — no @font-face here.
   ============================================================ */

/* ---------- Design tokens (variables only) ----------
   Scoped to .meeting-kiosk-shell (not :root) deliberately:
   1. Avoids leaking design-system variable names into the host page.
   2. Avoids webpack's postcss-root-to-host transformer (which rewrites
      ":root" -> ":host" for ShadowDOM consumers); that transform breaks
      these tokens when the bundle is loaded into a normal document head
      via style-loader, which is what happens for Kiosk modules. */
.meeting-kiosk-shell {
  /* -- Brand colors (web) — from Colors.pdf -------------------- */
  --pi-blue: #0395ff; /* Primary action / links / nav fill */
  --pi-blue-soft: #84d0f7; /* Highlight, soft tabs, secondary fills */
  --pi-blue-pale: #dbf1ff; /* Tinted card background — the workhorse */
  --pi-orange: #ff7c1d; /* Brand accent / callouts */
  --pi-orange-soft: #f6a572;
  --pi-orange-pale: #ffdec7;
  --pi-ink: #333; /* Primary text / display */

  /* -- UI-support colors --------------------------------------- */
  --pi-gray-700: #696868; /* Secondary text */
  --pi-gray-500: #8997a1; /* Tertiary / muted / disabled label */
  --pi-gray-300: #c4cdd4; /* Borders, separators */
  --pi-gray-200: #eaedef; /* Disabled fill */
  --pi-gray-100: #f5f8fa; /* Subtle row alternation */
  --pi-teal: #44c5e2; /* Map/chart accent */
  --pi-teal-deep: #07afaa; /* Status / chart accent */
  --pi-white: #fff;
  --pi-footer-bg: #2b2b2b; /* Footer charcoal */
  --pi-utility-bg: #3d3d3d; /* Utility menu chip */

  /* -- Semantic role tokens ------------------------------------ */
  --color-bg: var(--pi-white);
  --color-bg-tinted: #f8fafb; /* off-white card background (per design feedback) */
  --color-bg-subtle: var(--pi-gray-100);
  --color-fg: var(--pi-ink);
  --color-fg-muted: var(--pi-gray-700);
  --color-fg-subtle: var(--pi-gray-500);
  --color-border: var(--pi-gray-300);
  --color-border-soft: var(--pi-gray-200);
  --color-link: var(--pi-blue);
  --color-action: var(--pi-blue);
  --color-action-fg: var(--pi-white);
  --color-accent: var(--pi-orange);
  --color-success: var(--pi-teal-deep);

  /* -- Type ---------------------------------------------------- */
  --font-display: "Montserrat", system-ui, -apple-system, "Segoe UI", sans-serif;
  --font-body: "Libre Franklin", system-ui, -apple-system, "Segoe UI",
    sans-serif;

  /* Scale — exact px values from Typography.pdf */
  --fs-h1: 42px;
  --fs-h2: 32px;
  --fs-h3: 24px;
  --fs-h4: 18px;
  --fs-overline: 14px;
  --fs-body-lg: 18px;
  --fs-body: 16px;
  --fs-body-sm: 14px;
  --lh-display: 1.5; /* 150% per spec */
  --lh-body: 1.5; /* 24/16 */
  --lh-body-sm: 1.43; /* 20/14 */
  --lh-body-lg: 1.67; /* 30/18 */
  --fw-regular: 400;
  --fw-semibold: 600;
  --fw-bold: 700;

  /* -- Radii --------------------------------------------------- */
  --radius-sm: 4px;
  --radius-md: 6px; /* inputs */
  --radius-lg: 8px; /* buttons */
  --radius-xl: 12px; /* cards, hero, large containers */
  --radius-pill: 9999px;

  /* -- Spacing scale ------------------------------------------- */
  --space-1: 4px;
  --space-2: 8px;
  --space-3: 12px;
  --space-4: 16px;
  --space-5: 20px;
  --space-6: 24px;
  --space-7: 32px;
  --space-8: 40px;
  --space-9: 56px;
  --space-10: 80px;

  /* -- Layout -------------------------------------------------- */
  --container-md: 960px;
  --container-lg: 1140px; /* per Figma annotation */
  --container-xl: 1200px;
  --sidebar-w: 360px;
  --nav-strip-h: 56px;

  /* -- Shadows (mostly unused — system relies on tinted bg) ---- */
  --shadow-popover: 0 2px 8px rgba(0, 0, 0, 0.08);
  --shadow-overlay: 0 8px 24px rgba(0, 0, 0, 0.12);

  /* -- Motion -------------------------------------------------- */
  --motion-fast: 120ms ease-out;
  --motion-base: 180ms ease-out;
  --motion-slow: 240ms ease-out;

  /* -- Baseline shell styles -----------------------------------
     Merged into the variable-token block (rather than a separate
     .meeting-kiosk-shell rule) to satisfy stylelint's
     no-duplicate-selectors. See the comment further below for the
     intent. */
  background: var(--pi-white);
  font-family: var(--font-body);
  color: var(--pi-ink);
  overflow: hidden;
}

/* ---------- Kiosk styles (from design HTML) ---------- */

/* ===========================================================
   KIOSK CHROME
   Fluid responsive — fills any viewport. Designed primarily for
   a portrait 43–55" display mounted by chamber doors, but adapts
   cleanly to tablet portrait/landscape and laptop screens.
   Content sections are capped at ~1100px so they don't sprawl on
   wide monitors.

   .meeting-kiosk-shell wraps the React mount. It only sets baseline
   font/color/background so the inner .kiosk (which keeps its own
   position:fixed;inset:0) owns the viewport without double-fixed-
   positioning weirdness. We deliberately do NOT restyle html/body
   from this bundle — those rules from the design's source would
   leak to any host page that ever mounts this bundle alongside
   other content.

   Baseline declarations live in the variable-token block at the
   top of this file (see line 18) — stylelint's no-duplicate-selectors
   rule means we can have exactly one \`.meeting-kiosk-shell\` rule.
   =========================================================== */

/* Modern box-sizing reset, scoped to the kiosk shell so it can't leak.
   Without this, inputs declared \`width: 100%\` overflow their flex container
   by the sum of padding+border — that was the root cause of C1's clipping. */
.meeting-kiosk-shell,
.meeting-kiosk-shell *,
.meeting-kiosk-shell *::before,
.meeting-kiosk-shell *::after {
  box-sizing: border-box;
}

/* The kiosk surface — fills the viewport. */
.kiosk {
  position: fixed;
  inset: 0;
  /* iPad Safari sizes a fixed inset:0 box to the LAYOUT viewport, which stays tall while the
     toolbars are on screen — so the action bar lands below the fold and the page scrolls to
     reach it. svh is the smallest viewport, so the bar is reachable in either toolbar state.
     The vh line is the fallback for engines without svh. */
  height: 100vh;
  height: 100svh;
  display: flex;
  flex-direction: column;
  background: var(--pi-white);
  overflow: hidden;
}

.kiosk > .stage {
  flex: 1;
  min-height: 0;
}

.kiosk > .topbar,
.kiosk > .progress,
.kiosk > .actionbar {
  flex: 0 0 auto;
}

/* ---------- Top bar ---------- */
/* Every string in this bar is translatable and can arrive several times longer than its
   English source, so nothing here may size itself from its content alone. */
.topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 18px 32px;
  background: var(--pi-white);
  border-bottom: 1px solid var(--pi-gray-200);
}

.agency {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}

.agency .seal,
.agency .seal-img {
  flex: 0 0 auto;
}

.agency .seal {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--pi-blue-pale);
  display: grid;
  place-items: center;
  font-family: var(--font-display);
  font-weight: 700;
  color: var(--pi-blue);
  font-size: 16px;
  letter-spacing: 0.05em;
}

/* Real customer logo (when LogoImageId is set on the Customer row).
     object-fit:contain keeps a wide brand mark from getting cropped to a
     circle; the white background avoids dark transparent PNGs blending in. */
.agency .seal-img {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  background: var(--pi-white);
  border: 1px solid var(--pi-gray-200);
  -o-object-fit: contain;
     object-fit: contain;
  padding: 4px;
  box-sizing: border-box;
}

/* 1.2 was tight enough that Devanagari, Burmese and Arabic ascenders were clipped by the
   clamp and collided with the line below. Scripts with stacked marks need the headroom. */
.agency .text {
  line-height: 1.5;
  min-width: 0;
}

.agency .text .org {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 18px;
  line-height: 1.6;
  color: var(--pi-ink);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  overflow-wrap: anywhere;
}

.agency .text .meta {
  font-size: 14px;
  color: var(--pi-gray-700);
  letter-spacing: 0.02em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* The time is the one string here that is never translated, so it never wraps. Capping the
   width keeps a long translated date from crowding out the agency name beside it. */
.topbar .clock {
  flex: 0 0 auto;
  max-width: 40%;
  text-align: right;
  white-space: nowrap;
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 22px;
  color: var(--pi-ink);
  font-variant-numeric: tabular-nums;
}

.topbar .clock .date {
  display: block;
  font-size: 13px;
  font-weight: 400;
  font-family: var(--font-body);
  color: var(--pi-gray-700);
  letter-spacing: 0.04em;
  text-transform: uppercase;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* AB#9427: screen-reader-only utility. The kiosk page has no layout (see
   Views/MeetingKiosk/Index.cshtml) so bootstrap's .sr-only isn't loaded here
   — used on the progress strip to announce "Step X of Y" to assistive tech
   without a visible label (the numbered pills are the sighted-user cue). */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* ---------- Progress strip ---------- */
/* Wrapping rather than a fixed height: step labels are translated, and clipping them to one
   row cut them mid-word and dropped the later steps entirely. */
.progress {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px 16px;
  padding: 8px 32px;
  min-height: 56px;
  background: var(--pi-gray-100);
  border-bottom: 1px solid var(--pi-gray-200);
}

.progress .steps {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 8px;
  flex: 1 1 auto;
  min-width: 0;
}

.progress .step {
  flex: 0 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 14px;
  border-radius: var(--radius-pill);
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 14px;
  color: var(--pi-gray-500);
  background: transparent;
}

/* A label is shown in full or not at all — never as a fragment. A translation that does not fit
   on one line wraps onto the next and the pill grows; where even that is too tall, the
   short-screen and phone rules below drop the inactive labels to bare numbers instead. */
.progress .step .step-label {
  min-width: 0;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.progress .step .num {
  flex: 0 0 auto;
  width: 28px;
  height: 28px;
  overflow: hidden;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: var(--pi-gray-200);
  color: var(--pi-gray-700);
  font-size: 14px;
  font-weight: 700;
}

.progress .step.done {
  color: var(--pi-blue);
}

.progress .step.done .num {
  background: var(--pi-blue-pale);
  color: var(--pi-blue);
}

.progress .step.done .num::after {
  content: "✓";
}

.progress .step.done .num span {
  display: none;
}

.progress .step.active {
  color: var(--pi-ink);
  background: var(--pi-white);
  box-shadow: inset 0 0 0 1px var(--pi-gray-300);
}

.progress .step.active .num {
  background: var(--pi-blue);
  color: var(--pi-white);
}

/* The help / switch-language trigger renders in the progress bar and again on Done, so it is
   styled unscoped -- scoping it to .progress left the Done bar with a bare browser button. */
.help {
  flex: 0 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  border-radius: var(--radius-lg);
  background: var(--pi-white);
  border: 1px solid var(--pi-gray-300);
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 14px;
  line-height: 1.5;
  color: var(--pi-ink);
  cursor: pointer;
  white-space: nowrap;
}

.help > span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.help svg {
  flex: 0 0 auto;
  color: var(--pi-blue);
}

/* ---------- Stage (screen container) ---------- */
.stage {
  position: relative;
  overflow: hidden;
  transition: opacity 0.25s ease;
}

.stage.mk-retranslating {
  opacity: 0;
  transition: opacity 0.05s ease;
}

.screen {
  position: absolute;
  inset: 0;
  display: none;
  overflow: hidden;
}

.screen.active {
  display: flex;
}

/* ---------- Loading / error shells ---------- */
.kiosk-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 28px;
}

.kiosk-loading-spinner {
  display: flex;
  gap: 12px;
}

.kiosk-loading-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: var(--pi-blue);
  animation: kioskDotPulse 1.4s ease-in-out infinite both;
}

.kiosk-loading-dot:nth-child(2) {
  animation-delay: 0.16s;
}

.kiosk-loading-dot:nth-child(3) {
  animation-delay: 0.32s;
}

@keyframes kioskDotPulse {
  0%,
  80%,
  100% {
    opacity: 0.25;
    transform: scale(0.7);
  }

  40% {
    opacity: 1;
    transform: scale(1);
  }
}

.kiosk-loading-text {
  font-family: var(--font-body);
  font-size: var(--fs-body-lg);
  color: var(--color-fg-muted);
  margin: 0;
}

.error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
  padding: var(--space-8);
}

.error h2 {
  font-family: var(--font-display);
  font-size: var(--fs-h3);
  color: var(--color-fg);
  margin: 0 0 var(--space-3) 0;
}

.error p {
  font-family: var(--font-body);
  font-size: var(--fs-body);
  color: var(--color-fg-muted);
  margin: 0 0 var(--space-2) 0;
}

/* ---------- Bottom action bar ---------- */
.actionbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* Home-indicator iPads overlay the bottom edge; without the inset the buttons sit under it. */
  padding: 18px 32px calc(18px + env(safe-area-inset-bottom, 0px));
  background: var(--pi-white);
  border-top: 1px solid var(--pi-gray-200);
  gap: 16px;
  min-height: 96px;
}

.actionbar .summary {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 18px;
  color: var(--pi-ink);
}

.actionbar .summary .count {
  color: var(--pi-blue);
  font-weight: 700;
}

.actionbar .summary .sub {
  display: block;
  font-family: var(--font-body);
  font-weight: 400;
  font-size: 14px;
  color: var(--pi-gray-700);
  margin-top: 2px;
}

.actions {
  display: flex;
  gap: 12px;
  align-items: center;
}

/* ---------- Buttons (kiosk-scale) ---------- */
.btn {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border: 0;
  cursor: pointer;
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 18px;
  padding: 18px 28px;
  min-height: 64px;
  border-radius: var(--radius-lg);
  display: inline-flex;
  align-items: center;
  gap: 10px;
  transition: background var(--motion-base), color var(--motion-base),
    transform var(--motion-fast);
  background: var(--pi-white);
  color: var(--pi-ink);
  box-shadow: inset 0 0 0 1px var(--pi-gray-300);
}

.btn:hover {
  background: var(--pi-gray-100);
}

.btn:active {
  transform: translateY(1px);
}

.btn.primary {
  background: var(--pi-blue);
  color: var(--pi-white);
  box-shadow: none;
}

.btn.primary:hover {
  background: #0277cc;
}

.btn.primary:disabled {
  background: var(--pi-gray-200);
  color: var(--pi-gray-500);
  cursor: not-allowed;
}

.btn.ghost {
  /* Quieter color so primary CTA wins the eye at kiosk-viewing distance.
       See P3. */
  background: transparent;
  color: var(--pi-gray-700);
  box-shadow: none;
}

.btn.ghost:hover {
  background: var(--pi-gray-100);
}

.btn.lg {
  font-size: 22px;
  padding: 22px 34px;
  min-height: 80px;
}

.btn.xl {
  font-size: 26px;
  padding: 26px 44px;
  min-height: 96px;
}

/* ===========================================================
     SCREEN 1 — WELCOME
     =========================================================== */
.welcome {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  /* Double-halo: top + bottom blue-pale radial bleeds so a tall portrait
       kiosk viewport doesn't dead-end into flat white below the hero block.
       Plus a faint dot grid for civic-design atmosphere. See H1. */
  background: radial-gradient(
      ellipse 80% 40% at 50% 0%,
      var(--pi-blue-pale) 0%,
      transparent 70%
    ),
    radial-gradient(
      ellipse 80% 35% at 50% 100%,
      rgba(219, 241, 255, 0.55) 0%,
      transparent 65%
    ),
    radial-gradient(
        circle at 1px 1px,
        rgba(3, 149, 255, 0.06) 1px,
        transparent 1px
      )
      0 0 / 32px 32px,
    var(--pi-white);
  text-align: center;
}

/* The only scrolling region; the action buttons below it are pinned. */
.welcome-scroll {
  flex: 1;
  min-height: 0;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: safe center;
  gap: clamp(16px, 3vh, 40px);
  padding: clamp(20px, 4vh, 72px) clamp(32px, 5vw, 64px);
}

.welcome .pre {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--pi-blue);
  margin: 0;

  /* Pill chip treatment for the pre-header — gives it visual weight against
       the large hero h1, and reads as a deliberate label not a forgotten p tag. */
  padding: 8px 18px;
  background: var(--pi-blue-pale);
  border-radius: var(--radius-pill);
  display: inline-block;
}

.welcome h1 {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: clamp(32px, min(5vw, 7vh), 60px);
  line-height: 1.05;
  color: var(--pi-ink);
  margin: 0;
  max-width: 900px;
  text-wrap: balance;
  letter-spacing: -0.01em;
}

.welcome p {
  font-size: clamp(16px, min(1.6vw, 2.6vh), 21px);
  line-height: 1.5;
  color: var(--pi-gray-700);
  max-width: 640px;
  margin: 0;
}

/* AB#9415 council review: admin-authored CKEditor HTML (KioskMode.Content)
   renders here via dangerouslySetInnerHTML. Without scoping, any heading tag
   an admin's rich text happens to contain would inherit \`.welcome h1\`'s
   40-60px page-title styling via the plain descendant selector above,
   producing a second full-size page heading and breaking the WCAG 2.1 AA
   heading outline for screen-reader navigation. Cap headings and give
   common CKEditor output (paragraphs, lists, links) sane kiosk-scale
   defaults instead of falling back to bare user-agent styling. */
.kiosk-opening-content,
.kiosk-confirmation-content {
  max-width: 640px;
  font-size: clamp(17px, 1.6vw, 21px);
  line-height: 1.5;
  color: var(--pi-gray-700);
}

.kiosk-opening-content h1,
.kiosk-opening-content h2,
.kiosk-opening-content h3,
.kiosk-opening-content h4,
.kiosk-opening-content h5,
.kiosk-opening-content h6,
.kiosk-confirmation-content h1,
.kiosk-confirmation-content h2,
.kiosk-confirmation-content h3,
.kiosk-confirmation-content h4,
.kiosk-confirmation-content h5,
.kiosk-confirmation-content h6 {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: clamp(20px, 2vw, 26px);
  line-height: 1.2;
  color: var(--pi-ink);
  margin: 0 0 8px;
}

.kiosk-opening-content p,
.kiosk-confirmation-content p {
  margin: 0 0 8px;
}

.kiosk-opening-content ul,
.kiosk-opening-content ol,
.kiosk-confirmation-content ul,
.kiosk-confirmation-content ol {
  margin: 0 0 8px;
  padding-left: 1.25em;
  text-align: left;
}

.kiosk-opening-content a,
.kiosk-confirmation-content a {
  color: var(--pi-blue);
}

.welcome .meeting-card {
  display: inline-flex;
  flex-direction: column;
  align-items: center;

  /* Stronger card: larger, white-with-border so it sits on the halo background
       rather than dissolving into it; tinted "when" pill carries the brand color. */
  background: var(--pi-white);
  border: 1px solid var(--pi-blue-pale);
  border-radius: var(--radius-xl);
  padding: 28px 44px;
  max-width: 640px;
  box-shadow: 0 4px 24px rgba(3, 149, 255, 0.08);
}

.welcome .meeting-card .when {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 13px;
  color: var(--pi-blue);
  letter-spacing: 0.14em;
  margin-bottom: 10px;
  text-transform: uppercase;
}

.welcome .meeting-card .title {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: clamp(22px, 2.2vw, 28px);
  color: var(--pi-ink);
  line-height: 1.2;
  text-wrap: balance;
}

.welcome .meeting-card .where {
  font-size: 16px;
  color: var(--pi-gray-700);
  margin-top: 10px;
}

/* LanguagePicker renders on Welcome, Lookup and the Done bar, so the pill bar is styled
   unscoped -- scoping it to .welcome left the lookup screen with bare browser buttons. */
.lang {
  display: flex;

  /* AB#9443: wrap + center so a meeting with several in-person languages
     doesn't overflow the pill bar horizontally on the opening screen. */
  flex-wrap: wrap;
  justify-content: center;
  gap: 6px;
  background: var(--pi-white);
  border: 1px solid var(--pi-gray-300);
  border-radius: var(--radius-xl);
  padding: 5px;
}

.lang button {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border: 0;
  cursor: pointer;
  padding: 8px 16px;
  min-height: 40px;
  border-radius: var(--radius-pill);
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 14px;
  color: var(--pi-gray-700);
  background: transparent;
}

.lang button.on {
  background: var(--pi-blue);
  color: var(--pi-white);
}

.welcome .lang {
  margin-top: 8px;
}

.welcome-actions {
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  /* Home-indicator iPads overlay the bottom edge; without the inset the buttons sit under it. */
  padding: 18px 32px calc(18px + env(safe-area-inset-bottom, 0px));
  background: var(--pi-white);
  border-top: 1px solid var(--pi-gray-200);
}

/* Secondary CTA: outline-with-brand-stroke. A 1px gray border vanishes at
     kiosk viewing distance; a 2.5px blue stroke + blue text reads as a
     deliberate alternative-path affordance and contrasts the filled primary. */
.welcome-actions .btn:not(.primary) {
  background: var(--pi-white);
  box-shadow: inset 0 0 0 2.5px var(--pi-blue);
  color: var(--pi-blue);
}

.welcome-actions .btn:not(.primary):hover {
  background: var(--pi-blue-pale);
  box-shadow: inset 0 0 0 2.5px var(--pi-blue);
}

/* Stack the action buttons on narrow screens. */
@media (max-width: 640px) {
  .welcome-actions {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
  }
}

/* Tablets in landscape. Design floor is 744px tall -- iPad Mini (AB#9885). */
@media (max-height: 950px) {
  .welcome-scroll {
    gap: clamp(10px, 1.8vh, 40px);
    padding: clamp(12px, 2vh, 72px) clamp(32px, 5vw, 64px);
  }

  .welcome h1 {
    font-size: clamp(26px, min(5vw, 5.2vh), 60px);
  }

  .welcome p {
    font-size: clamp(15px, min(1.6vw, 2.2vh), 21px);
  }

  .welcome .meeting-card {
    padding: clamp(12px, 2vh, 28px) clamp(24px, 3.5vw, 44px);
  }

  .welcome .meeting-card .when {
    margin-bottom: 6px;
  }

  .welcome .meeting-card .where {
    margin-top: 6px;
  }

  .welcome .capacity-chip {
    padding: 7px 20px;
  }

  .welcome .lang button {
    padding: 8px 16px;
  }

  .welcome-actions {
    padding: 12px 32px calc(12px + env(safe-area-inset-bottom, 0px));
  }

  .welcome-actions .btn.xl {
    font-size: 22px;
    padding: 16px 34px;
    min-height: 68px;
  }

  .welcome-actions .btn.lg {
    font-size: 19px;
    padding: 14px 26px;
    min-height: 60px;
  }
}

/* ---- Capacity chips (Welcome screen): attendee and speaker share one look ---- */
.welcome .capacity-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  border-radius: 40px;
  font-size: clamp(14px, 1.3vw, 16px);
  font-weight: 600;
  font-family: var(--font-display);
}

.welcome .capacity-chip.open {
  background: var(--pi-blue-pale);
  color: var(--pi-blue);
}

.welcome .capacity-chip.low {
  background: var(--pi-orange-pale);
  color: var(--pi-orange);
}

.welcome .capacity-chip.full {
  background: #fee2e2;
  color: #b91c1c;
}

.welcome .capacity-full-cta {
  font-size: clamp(16px, 1.5vw, 18px);
  color: var(--pi-gray-700);
  text-align: center;
  margin: 0;
  max-width: 480px;
}


.field-required,
.field-optional {
  font-weight: 400;
  font-size: 0.85em;
  color: var(--pi-gray-500);
  margin-left: 4px;
}

.field-required {
  color: var(--pi-orange);
}

.advance-blocked-reason {
  color: var(--pi-orange);
  font-size: clamp(14px, 1.2vw, 16px);
  font-weight: 600;
  margin-right: 12px;
}

.submit-error {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  max-width: 420px;
  margin-right: 16px;
  padding: 10px 18px;
  border-radius: var(--radius-md);
  background: #fee2e2;
  color: #b91c1c;
  font-family: var(--font-display);
  font-size: clamp(14px, 1.2vw, 16px);
  font-weight: 600;
  line-height: 1.35;
}

/* ===========================================================
     SCREEN — LOOKUP (find a previous registration)
     =========================================================== */
.lookup {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  /* Halo + dot-grid atmosphere — same treatment as Welcome/Info/Review so
       no screen reads as "empty canvas + form." */
  background: radial-gradient(
      ellipse 80% 30% at 50% 0%,
      var(--pi-blue-pale) 0%,
      transparent 70%
    ),
    radial-gradient(
      ellipse 80% 30% at 50% 100%,
      rgba(219, 241, 255, 0.45) 0%,
      transparent 65%
    ),
    radial-gradient(
        circle at 1px 1px,
        rgba(3, 149, 255, 0.04) 1px,
        transparent 1px
      )
      0 0 / 32px 32px,
    var(--pi-white);
}

.lookup-head {
  /* flex-shrink:0 because .lookup is a flex column where .lookup-results
       is the only grow/shrink target. Without it, an aggressive viewport
       shrink could compress the headline + subhead. */
  flex-shrink: 0;
  padding: 24px 48px 8px;
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
}

.lookup-head h2 {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: clamp(28px, 3.4vw, 40px);
  line-height: 1.1;
  margin: 0 0 10px;
  color: var(--pi-ink);
  text-wrap: balance;
}

.lookup-head .sub {
  font-size: clamp(15px, 1.4vw, 18px);
  color: var(--pi-gray-700);
  margin: 0;
  max-width: 640px;
}

.lookup-search {
  position: relative;
  margin: 12px auto 4px;
  padding: 0 48px;
  max-width: 900px;
  width: 100%;
  box-sizing: border-box;
}

.lookup-search input {
  width: 100%;
  font-family: var(--font-body);
  font-size: clamp(22px, 2.4vw, 32px);
  padding: 28px 28px 28px 88px;
  min-height: 96px;
  border: 2px solid var(--pi-gray-300);
  border-radius: var(--radius-lg);
  background: var(--pi-white);
  color: var(--pi-ink);
  box-sizing: border-box;
}

.lookup-search svg {
  position: absolute;
  left: 78px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--pi-gray-500);
  width: 32px;
  height: 32px;
}

.lookup-search input:focus {
  outline: none;
  border-color: var(--pi-blue);
  box-shadow: 0 0 0 4px rgba(3, 149, 255, 0.18);
}

.lookup-search .clear {
  position: absolute;
  right: 62px;
  top: 50%;
  transform: translateY(-50%);
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: 0;
  background: var(--pi-gray-200);
  color: var(--pi-gray-700);
  cursor: pointer;
  font-size: 28px;
  font-weight: 700;
  display: grid;
  place-items: center;
}

/* ---------------------------------------------------------------------------
   New exact-match lookup form (replaces the single-input .lookup-search
   above). Per LAC 5/18 security ask: name + (email OR phone) before any
   data hydrates. The .lookup-search styles above stay in place for now —
   harmless if dropped from JSX, kept around in case a downstream consumer
   still expects them.
   --------------------------------------------------------------------------- */
.lookup-form {
  /* PR 5 follow-up (5/20): explicit flex-shrink:0 so the form doesn't get
       squeezed when the .lookup-results sibling hosts a no-match hint or
       a match row. The form always renders at its natural height; the
       results region is the only flex-grow child of .lookup. */
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 12px;
  margin: 12px auto 8px;
  padding: 0 48px;
  max-width: 720px;
  width: 100%;
  box-sizing: border-box;
}

.lookup-form .field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.lookup-form .field label {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 16px;
  color: var(--pi-ink);
}

.lookup-form .field input {
  font-family: var(--font-body);
  font-size: 20px;

  /* Tighter vertical rhythm (was 20px / 72px) so three optional fields
       fit comfortably on a kiosk-class portrait viewport without forcing
       the .lookup-results below the fold. Still ≥ 56px which satisfies
       the touch-target minimum for kiosk-glove fingers. */
  padding: 14px 20px;
  min-height: 56px;
  border: 2px solid var(--pi-gray-300);
  border-radius: var(--radius-lg);
  background: var(--pi-white);
  color: var(--pi-ink);
  box-sizing: border-box;
}

.lookup-form .field input:focus {
  outline: none;
  border-color: var(--pi-blue);
  box-shadow: 0 0 0 4px rgba(3, 149, 255, 0.18);
}

.lookup-form .field-hint {
  margin: 0;
  font-size: 14px;
  color: var(--pi-gray-700);
}

.lookup-verifier-toggle {
  display: flex;
  gap: 12px;
  background: var(--pi-gray-100);
  padding: 6px;
  border-radius: var(--radius-lg);
  width: -moz-fit-content;
  width: fit-content;
}

.lookup-verifier {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border: 0;
  background: transparent;
  font-family: var(--font-body);
  font-size: 18px;
  font-weight: 600;
  color: var(--pi-gray-700);
  padding: 14px 28px;
  border-radius: var(--radius-md);
  cursor: pointer;
  min-width: 120px;
  transition: background var(--motion-fast), color var(--motion-fast);
}

.lookup-verifier:hover {
  color: var(--pi-ink);
}

.lookup-verifier.on {
  background: var(--pi-white);
  color: var(--pi-blue);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.lookup-actions {
  display: flex;
  justify-content: stretch;
  margin-top: 8px;
}

.lookup-actions .btn {
  width: 100%;
}

.lookup-results {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0 48px;
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;

  /* Flex column so an empty-state .hint can margin:auto to center vertically
       in the unused result area. See H6. */
  display: flex;
  flex-direction: column;
}

.lookup-results .hint {
  text-align: center;
  padding: 40px 20px;
  color: var(--pi-gray-700);

  /* Center the empty-state hint vertically inside the results area when
       there are no matches yet — kills the ~1000px dead-space void. */
  margin: auto;
}

.lookup-results .hint .hint-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: var(--pi-gray-100);
  color: var(--pi-gray-500);
  display: grid;
  place-items: center;
  margin: 0 auto 20px;
}

.lookup-results .hint .big {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 24px;
  color: var(--pi-ink);
  margin: 0 0 8px;
}

.lookup-disambiguation-hint {
  /* Shown above the result rows when a name matches more than one
     registrant (duplicate names on a name-only kiosk — AB#9331). Mirrors
     the .lookup-head .sub subhead tokens so it reads as guidance, not an
     error, and sits flush with the rows below it. */
  font-size: clamp(15px, 1.4vw, 18px);
  color: var(--pi-gray-700);
  margin: 0 0 12px;
}

.lookup-row {
  /* \`appearance: none\` strips the native <button> styling; the explicit
     1px border below replaces the default UA border (so no need to first
     zero it out). */
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  cursor: pointer;
  display: grid;
  grid-template-columns: 72px 1fr auto;
  gap: 22px;
  align-items: center;
  width: 100%;
  text-align: left;
  padding: 24px 28px;
  background: var(--pi-white);
  border: 1px solid var(--pi-gray-200);
  border-radius: var(--radius-xl);
  margin-bottom: 12px;
  transition: background var(--motion-base), border-color var(--motion-base),
    transform var(--motion-fast);
}

.lookup-row:hover {
  background: var(--pi-gray-100);
  border-color: var(--pi-gray-300);
}

.lookup-row:active {
  transform: scale(0.99);
}

.lookup-row .avatar {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: var(--pi-blue-pale);
  color: var(--pi-blue);
  display: grid;
  place-items: center;
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 28px;
  letter-spacing: 0.04em;
}

.lookup-row .who .name {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 26px;
  color: var(--pi-ink);
  margin-bottom: 6px;
}

.lookup-row .who .meta {
  font-size: 17px;
  color: var(--pi-gray-700);
}

.lookup-row > svg {
  color: var(--pi-gray-500);
  width: 32px;
  height: 32px;
}

.lookup-row:hover > svg {
  color: var(--pi-blue);
}

.lookup-foot {
  /* PR 5 follow-up: flex-shrink:0 pins the foot to the bottom of the
       .lookup column regardless of how tall the .lookup-results middle
       region grows. Without this, a tall no-match hint could push the
       Back / Start-new CTAs off the bottom edge of the viewport. */
  flex-shrink: 0;
  border-top: 1px solid var(--pi-gray-200);
  padding: 20px 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  background: var(--pi-white);
  flex-wrap: wrap;
}

.lookup-priv {
  margin: 0;
  font-size: 14px;
  color: var(--pi-gray-700);
}

.linkish {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border: 0;
  background: transparent;
  color: var(--pi-blue);
  cursor: pointer;
  font: inherit;
  font-weight: 600;
  padding: 0;
}

.linkish:hover {
  text-decoration: underline;
}

/* Returning-user banner on the Review screen */
.returning-banner {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  background: rgba(7, 175, 170, 0.1);
  border: 1px solid rgba(7, 175, 170, 0.35);
  border-radius: var(--radius-lg);
  padding: 16px 20px;
  margin-bottom: 20px;
  font-size: 17px;
  color: var(--pi-ink);
}

.returning-banner .dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #07afaa;
  flex-shrink: 0;
  margin-top: 6px;
  box-shadow: 0 0 0 4px rgba(7, 175, 170, 0.25);
}

.returning-banner strong {
  color: #057e7a;
}

/* ===========================================================
     SCREEN 2 — YOUR INFO
     =========================================================== */

/* .info-stage wraps .info to paint atmosphere across the full stage area.
     Without it, .info (max-width: 980px) leaves the side bands flat-white and
     the bottom band feels dead. The atmosphere matches the Welcome screen's
     halo + dot-grid for visual continuity. */
.info-stage {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  background: radial-gradient(
      ellipse 80% 30% at 50% 0%,
      var(--pi-blue-pale) 0%,
      transparent 70%
    ),
    radial-gradient(
      ellipse 80% 30% at 50% 100%,
      rgba(219, 241, 255, 0.45) 0%,
      transparent 65%
    ),
    radial-gradient(
        circle at 1px 1px,
        rgba(3, 149, 255, 0.04) 1px,
        transparent 1px
      )
      0 0 / 32px 32px,
    var(--pi-white);
  overflow: auto;
}

.info {
  display: flex;
  flex-direction: column;
  padding: 56px 64px;
  gap: 36px;
  width: 100%;
  max-width: 980px;
  margin: 0 auto;
  box-sizing: border-box;
}

.info .lead h2 {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 48px;
  line-height: 1.1;
  margin: 0 0 14px;
  color: var(--pi-ink);
  text-wrap: balance;
}

.info .lead p {
  font-size: 22px;
  line-height: 1.5;
  color: var(--pi-gray-700);
  margin: 0 0 22px;
  max-width: 720px;
}

.info .lead .tip {
  background: var(--pi-blue-pale);
  border-radius: var(--radius-xl);
  padding: 18px 22px;
  display: flex;
  gap: 14px;
  align-items: flex-start;
  max-width: 720px;
}

.info .lead .tip .icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--pi-blue);
  color: var(--pi-white);
  display: grid;
  place-items: center;
  flex-shrink: 0;
  font-family: var(--font-display);
  font-weight: 700;
}

.info .lead .tip p {
  font-size: 16px;
  color: var(--pi-ink);
  margin: 0;
}

.info .form {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.info .field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info .field label {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 18px;
  color: var(--pi-ink);
}

/* Scoped to text-like inputs only — without :not(...) this also grabbed
     <input type="checkbox"> and stretched it to min-height:72px with 20px padding.
     The SMS consent surrogate checkbox is styled separately below. */
.info .field input:not([type="checkbox"]):not([type="radio"]) {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  font-family: var(--font-body);
  font-size: 24px;
  padding: 20px 22px;
  min-height: 72px;
  border: 1px solid var(--pi-gray-300);
  border-radius: var(--radius-lg);
  background: var(--pi-white);
  color: var(--pi-ink);
  width: 100%;
  transition: border-color var(--motion-base), box-shadow var(--motion-base);
}

.info .field input:not([type="checkbox"]):not([type="radio"]):focus {
  outline: none;
  border-color: var(--pi-blue);
  box-shadow: 0 0 0 4px rgba(3, 149, 255, 0.18);
}

.info .field-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

/* Conditional "required" affordances. Used by the phone field when the
     user picks Virtual attendance (need a phone to be dialed in) and any
     future field that flips between optional and required based on form
     state. We mark with a red asterisk + small hint below the input. */
.info .field label .req-mark {
  color: #d0353c;
  font-weight: 700;
  margin-left: 2px;
}

.info .field .field-hint {
  margin: 8px 0 0;
  font-size: 14px;
  line-height: 1.4;
  color: var(--pi-gray-700);
  font-style: italic;
}

/* Customer-configured custom-field <select>. Matches the .info .field input
     visual so multi-type form rendering looks consistent. */
.info .field .custom-field-select {
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none;
  font-family: var(--font-body);
  font-size: 24px;
  padding: 20px 22px;
  min-height: 72px;
  border: 1px solid var(--pi-gray-300);
  border-radius: var(--radius-lg);
  background: var(--pi-white);
  color: var(--pi-ink);
  width: 100%;
  box-sizing: border-box;
  transition: border-color var(--motion-base), box-shadow var(--motion-base);

  /* Native disclosure arrow on the right (chevron via background SVG). */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 18px center;
  padding-right: 56px;
}

.info .field .custom-field-select:focus {
  outline: none;
  border-color: var(--pi-blue);
  box-shadow: 0 0 0 4px rgba(3, 149, 255, 0.18);
}

/* ---------- Interpreter request section ---------- */
.interpreter-section {
  border: 1px solid var(--pi-gray-200);
  border-radius: var(--radius-xl);
  padding: var(--space-6);
  margin-top: var(--space-4);
}

.interpreter-legend {
  font-family: var(--font-body);
  font-size: var(--fs-body-lg);
  font-weight: var(--fw-semibold);
  color: var(--color-fg);
  padding: 0 var(--space-2);
}

.interpreter-toggle {
  display: flex;
  gap: 12px;
  margin-top: var(--space-3);
}

.interpreter-option {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 16px 20px;
  border: 2px solid var(--pi-gray-300);
  border-radius: var(--radius-lg);
  font-family: var(--font-body);
  font-size: 20px;
  font-weight: var(--fw-semibold);
  color: var(--color-fg);
  cursor: pointer;
  transition: border-color var(--motion-base), background var(--motion-base);
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.interpreter-option input[type="radio"] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.interpreter-option.active {
  border-color: var(--pi-blue);
  background: var(--pi-blue-pale);
  color: var(--pi-blue);
}

.interpreter-language-field {
  margin-top: var(--space-4);
}

.field-hint-static {
  display: block;
  font-family: var(--font-body);
  font-size: var(--fs-body-sm);
  color: var(--color-fg-subtle);
  margin-top: var(--space-2);
}

.info .attend {
  display: flex;
  gap: 12px;
}

.info .attend label {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 20px 22px;
  min-height: 72px;
  border: 1px solid var(--pi-gray-300);
  border-radius: var(--radius-lg);
  background: var(--pi-white);
  cursor: pointer;
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 20px;
  color: var(--pi-ink);
}

.info .attend label.on {
  border-color: var(--pi-blue);
  background: var(--pi-blue-pale);
  box-shadow: inset 0 0 0 1px var(--pi-blue);
}

.info .attend .radio {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 2px solid var(--pi-gray-500);
  display: grid;
  place-items: center;
  flex-shrink: 0;
}

.info .attend label.on .radio {
  border-color: var(--pi-blue);
}

.info .attend label.on .radio::after {
  content: "";
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: var(--pi-blue);
}

/* ---------- SMS consent row ---------- */
.sms-consent {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 12px;
  padding: 14px 16px;
  background: var(--pi-gray-100);
  border-radius: var(--radius-lg);
  transition: opacity var(--motion-base);
}

.sms-consent.muted {
  opacity: 0.6;
}

.sms-consent label {
  flex: 1;
  display: flex;
  gap: 12px;
  align-items: flex-start;
  cursor: pointer;
  font-size: 16px;
  color: var(--pi-ink);
  line-height: 1.4;
}

/* Surrogate checkbox: native accent-color only paints the *checked* state,
     so unchecked checkboxes vary across browsers/DPI scales and read as
     unstyled blocks. We render our own box and check glyph via :checked::after.
     See H5. */
.sms-consent input[type="checkbox"],
.review .opt input[type="checkbox"] {
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none;
  width: 28px;
  height: 28px;
  margin: 1px 0 0;
  border: 2px solid var(--pi-gray-500);
  border-radius: 6px;
  background: var(--pi-white);
  cursor: pointer;
  flex-shrink: 0;
  display: grid;
  place-items: center;
  transition: background var(--motion-fast), border-color var(--motion-fast);
}

.sms-consent input[type="checkbox"]:checked,
.review .opt input[type="checkbox"]:checked {
  background: var(--pi-blue);
  border-color: var(--pi-blue);
}

.sms-consent input[type="checkbox"]:checked::after,
.review .opt input[type="checkbox"]:checked::after {
  content: "\\2713"; /* ✓ */
  color: var(--pi-white);
  font-weight: 700;
  font-size: 20px;
  line-height: 1;
}

.sms-consent input[type="checkbox"]:focus-visible,
.review .opt input[type="checkbox"]:focus-visible {
  outline: none;
  box-shadow: 0 0 0 4px rgba(3, 149, 255, 0.18);
}

.sms-consent input:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.sms-consent .sms-copy {
  flex: 1;
}

.sms-consent .info-btn {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border: 0;
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--pi-white);
  color: var(--pi-blue);
  display: grid;
  place-items: center;
  flex-shrink: 0;
  box-shadow: inset 0 0 0 1px var(--pi-gray-300);
}

.sms-consent .info-btn:hover {
  background: var(--pi-blue-pale);
}

.field-hint {
  display: block;
  margin-top: 6px;
  font-size: 14px;
  color: #c0392b;
}

.info-sheet {
  max-width: 720px;
}

/* ---------- Language picker sheet ---------------------------------------
     Opened from the topbar Translate button when the kiosk admin has enabled
     2+ languages (KioskMode.LanguageCodesCsv). Renders each enabled language
     as a tall touch-friendly tile showing the native autoglossonym (big) +
     the English name (small, secondary). Tapping a tile drives the Google
     Translate widget through applyTranslateLanguage(). */
.langs-sheet {
  max-width: 640px;
  padding-bottom: 32px;
}

.langs-sheet .langs-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  overflow-y: auto;
  margin-top: 4px;
}
@media (max-width: 480px) {
  .langs-sheet .langs-grid {
    grid-template-columns: 1fr;
  }
}

.lang-row {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border: 0;
  cursor: pointer;
  background: var(--pi-white);
  box-shadow: inset 0 0 0 1px var(--pi-gray-300);
  border-radius: var(--radius-lg);
  padding: 18px 20px;
  min-height: 88px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 4px;
  text-align: left;
  transition: background var(--motion-fast), box-shadow var(--motion-fast);
}

.lang-row:hover {
  background: var(--pi-gray-100);
}

.lang-row:active {
  transform: scale(0.99);
}

.lang-row.on {
  background: var(--pi-blue-pale);
  box-shadow: inset 0 0 0 2px var(--pi-blue);
}

.lang-row .lang-native {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 22px;
  color: var(--pi-ink);
  line-height: 1.1;
}

.lang-row.on .lang-native {
  color: var(--pi-blue);
}

.lang-row .lang-english {
  font-family: var(--font-body);
  font-size: 14px;
  color: var(--pi-gray-700);
  font-weight: 400;
  letter-spacing: 0.02em;
}

/* Google Translate widget polish: the auto-injected top bar is iframe-only
     and breaks our viewport-locked layout — kill it. The hidden combo + its
     parent host stay invisible since we drive translation programmatically. */
body > .skiptranslate,
body > iframe.goog-te-banner-frame {
  display: none !important;
}

/* A spinner that never resolves would sit in the corner of a kiosk left running (AB#9884). */
.goog-te-spinner-pos,
.goog-te-balloon-frame,
#goog-gt-tt,
.goog-tooltip,
.goog-text-highlight {
  display: none !important;
  box-shadow: none !important;
  background: none !important;
}

body {
  top: 0 !important;
} /* the widget tries to add \`top:40px\` for its banner */
#google_translate_element {
  position: absolute !important;
  left: -9999px !important;
  top: 0 !important;
  width: 0;
  height: 0;
  overflow: hidden;
}

.info-body p,
.info-body li {
  font-size: 17px;
  line-height: 1.5;
  color: var(--pi-ink);
}

.info-body p {
  margin: 0 0 14px;
}

.info-body ul {
  margin: 0 0 16px;
  padding-left: 20px;
}

.info-body li {
  margin-bottom: 8px;
}

.info-body .link-row {
  color: var(--pi-gray-700);
  font-size: 15px;
}

.info-body a {
  color: var(--pi-blue);
  text-decoration: underline;
  font-weight: 600;
}

.info-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
}

/* ===========================================================
     SCREEN 3 — AGENDA PICKER (the key screen)
     Portrait layout: stacked vertically.
       ┌── search-row ────────────────┐
       ├── filters ───────────────────┤
       ├── list (scrolls) ────────────┤
       └── picks-peek (sticky CTA) ───┘
     Keypad + selections live in bottom-sheets.
     On wide-landscape (≥1100px landscape) the list and chrome
     center at max-width so items don't stretch absurdly wide.
     =========================================================== */
.picker {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--pi-white);
  position: relative;
}

.picker .search-row,
.picker .filters,
.picker .list,
.picker .picks-peek {
  width: 100%;
  max-width: 1100px;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
}

.picker .search-row {
  display: flex;
  gap: 14px;
  padding: 24px 32px 12px;
  align-items: center;
}

.picker .search {
  flex: 1;
  min-width: 0;
  position: relative;

  /* min-width:0 is critical — without it the flex item refuses to shrink
       below the input's intrinsic width and the .jump-btn gets pushed past
       the right edge of the search-row. See design-review C1. */
}

.picker .search svg {
  position: absolute;
  left: 22px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--pi-gray-500);
}

.picker .search input {
  width: 100%;
  box-sizing: border-box; /* without this, padding+border push width past 100% and the .jump-btn gets cut off — see C1 */
  font-family: var(--font-body);
  font-size: 26px;
  padding: 22px 22px 22px 64px;
  min-height: 76px;
  border: 1px solid var(--pi-gray-300);
  border-radius: var(--radius-lg);
  background: var(--pi-white);
  color: var(--pi-ink);
}

.picker .search input::-moz-placeholder {
  color: var(--pi-gray-500);
}

.picker .search input::placeholder {
  color: var(--pi-gray-500);
}

.picker .search input:focus {
  outline: none;
  border-color: var(--pi-blue);
  box-shadow: 0 0 0 4px rgba(3, 149, 255, 0.18);
}

.picker .search .clear {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 0;
  background: var(--pi-gray-200);
  color: var(--pi-gray-700);
  cursor: pointer;
  font-size: 22px;
  font-weight: 700;
  display: grid;
  place-items: center;
}

.picker .jump-btn {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 22px 26px;
  min-height: 76px;
  border-radius: var(--radius-lg);
  background: var(--pi-white);
  border: 1px solid var(--pi-gray-300);
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 20px;
  color: var(--pi-ink);
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0; /* paired with .picker .search { min-width:0 } — see C1 */
}

.picker .jump-btn:hover {
  background: var(--pi-gray-100);
}

.picker .jump-btn svg {
  color: var(--pi-blue);
}

.picker .filters {
  display: flex;
  gap: 10px;
  padding: 4px 32px 14px;
}

.picker .filter {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border: 0;
  cursor: pointer;
  padding: 14px 24px;
  min-height: 56px;
  border-radius: var(--radius-pill);
  background: var(--pi-white);
  box-shadow: inset 0 0 0 1px var(--pi-gray-300);
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 17px;
  color: var(--pi-gray-700);
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.picker .filter .pill {
  background: var(--pi-gray-200);
  color: var(--pi-gray-700);
  border-radius: var(--radius-pill);
  padding: 2px 12px;
  font-size: 14px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.picker .filter.on {
  background: var(--pi-blue-pale);
  color: var(--pi-blue);
  box-shadow: inset 0 0 0 1px var(--pi-blue);
}

.picker .filter.on .pill {
  background: var(--pi-blue);
  color: var(--pi-white);
}

.picker .filter:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* List */
.picker .list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;

  /* \`touch-action: pan-y\` tells the browser explicitly that this region is a
       vertical pan target. Without it, some embedded WebView kiosks (notably
       the chamber kiosk per LAC 5/18 feedback) drop the native swipe gesture
       in favor of generic touchstart event interception, which forces users
       onto the scrollbar thumb. \`pinch-zoom\` is kept allowed so accessibility
       gestures still work. */
  touch-action: pan-y pinch-zoom;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  padding: 4px 32px 8px;
  scroll-behavior: smooth;

  /* position:relative makes this the offsetParent of .item, so the
       Jump-to-# scroll math (el.offsetTop relative to listRef.current)
       resolves to the in-list scroll offset, not the in-.picker offset. */
  position: relative;
}

/* ---------------------------------------------------------------------------
   Side-rail page-up / page-down buttons (LAC 5/18 ask, Pulido item 2).
   Anchored to the right edge of the picker, vertically centered on the list.
   Hidden on narrow viewports (< 900px) — at phone-width the rail would
   overlap content and the fat scrollbar + native swipe are enough.
   --------------------------------------------------------------------------- */
.picker .list-nav {
  display: none;
}

@media (min-width: 900px) {
  .picker .list-nav {
    display: flex;
    flex-direction: column;
    gap: 24px;
    position: absolute;

    /* Anchor below the search-row + filters (~152px combined) so the up arrow
         doesn't crash into the Jump-to-# button. The bottom anchor leaves
         space for the picks-peek strip that overlays the list at the bottom. */
    top: 168px;
    bottom: 120px;

    /* PR 5 follow-up (5/20): the .picker .list is centered with
         max-width: 1100px, so its scrollbar lives at \`50% + 550px\` of
         the picker on any viewport wide enough to honor the max-width.
         Anchoring the rail with \`right: 24px\` of .picker put the buttons
         hundreds of pixels OUTSIDE the scrollbar on wide displays.
         The calc below pins the rail's right edge 12px past the centered
         list's right edge — so the buttons sit just outside the
         scrollbar in a tight visual cluster. On viewports < 1100px the
         calc resolves negative and the \`max()\` falls back to a flat
         right:16px so we don't push the rail off-screen. */
    right: max(16px, calc(50% - 550px - 12px - 88px));
    justify-content: center;
    pointer-events: none;
    z-index: 4;
  }

  .picker .list-nav-btn {
    pointer-events: auto;
    width: 88px;
    height: 88px;
    border-radius: 50%;
    border: 2px solid var(--pi-blue);
    background: var(--pi-white);
    color: var(--pi-blue);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);
    transition: background var(--motion-fast), transform var(--motion-fast),
      box-shadow var(--motion-fast), opacity var(--motion-fast);
  }

  .picker .list-nav-btn:hover {
    background: var(--pi-blue-pale);
  }

  .picker .list-nav-btn:active {
    transform: scale(0.94);
    background: var(--pi-blue);
    color: var(--pi-white);
  }

  .picker .list-nav-btn:disabled {
    opacity: 0.35;
    cursor: not-allowed;
    box-shadow: none;
  }

  .picker .list-nav-btn:focus-visible {
    outline: 3px solid var(--pi-blue);
    outline-offset: 3px;
  }
}

/* Very wide viewports keep the same scrollbar-hugging anchor — no further
   shift needed since the calc above already tracks the centered list edge.
   This block stays for the slightly bumped button size. */
@media (min-width: 1400px) {
  .picker .list-nav {
    /* Same anchor as above; explicit redeclaration keeps the new 96px
         buttons aligned with the (now wider) calc lookup. */
    right: max(16px, calc(50% - 550px - 12px - 96px));
  }

  .picker .list-nav-btn {
    width: 96px;
    height: 96px;
  }
}

/* Fat scrollbar — much easier to grab on a touch display. */
.picker .list::-webkit-scrollbar {
  width: 22px;
}

.picker .list::-webkit-scrollbar-track {
  background: var(--pi-gray-100);
  border-radius: var(--radius-pill);
}

.picker .list::-webkit-scrollbar-thumb {
  background: var(--pi-gray-300);
  border-radius: var(--radius-pill);
  border: 4px solid var(--pi-gray-100);
}

.picker .list::-webkit-scrollbar-thumb:hover {
  background: var(--pi-gray-500);
}

.group-head {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--pi-gray-700);
  padding: 20px 6px 10px;
  position: sticky;
  top: 0;
  background: linear-gradient(
    to bottom,
    var(--pi-white) 78%,
    rgba(255, 255, 255, 0)
  );
  z-index: 1;
}

.item {
  display: flex;
  flex-direction: column;
  padding: 20px 22px;
  border-radius: var(--radius-xl);
  background: var(--pi-white);
  border: 1px solid var(--pi-gray-200);
  margin-bottom: 12px;
  transition: background var(--motion-base), border-color var(--motion-base);
}

.item.flash {
  animation: itemFlash 1.2s ease-out;
}
@keyframes itemFlash {
  0% {
    background: var(--pi-blue-pale);
    border-color: var(--pi-blue);
  }

  100% {
    background: var(--pi-white);
    border-color: var(--pi-gray-200);
  }
}

.item.selected.for {
  background: rgba(7, 175, 170, 0.07);
  border-color: #07afaa;
}

.item.selected.against {
  background: rgba(208, 53, 60, 0.06);
  border-color: #d0353c;
}

.item.selected.neutral {
  background: var(--pi-gray-100);
  border-color: var(--pi-gray-500);
}

/* "Closed for sign-up" treatment. AgendaItemStatus.AllowSpeakerRegistration=false
     on the server resolves to acceptingSpeakers=false on the item — the row gets
     dimmed, the num cell loses its tint, and stance buttons go non-interactive.
     Title stays readable so the kiosk attendee can see what items are currently
     active / completed without confusion. */
.item.locked {
  background: var(--pi-gray-100);
  border-color: var(--pi-gray-200);
  opacity: 0.78;
}

.item.locked .num {
  background: var(--pi-gray-200);
  color: var(--pi-gray-500);
}

.item.locked .title {
  color: var(--pi-gray-700);
}

/* PR 5: badge moves inside .title-wrap (under the title) and gains a Lock
     icon. The pill is now compact with an inline icon — better scannability
     than the old corner-floated rectangle. */
.locked-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  align-self: flex-start;
  padding: 5px 10px;
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--pi-gray-700);
  background: var(--pi-gray-200);
  border-radius: var(--radius-pill);
  white-space: nowrap;
}

/* Title + closed-badge stack vertically; we don't want the badge collapsing
     to the right of a long title. .item-head is a 2-col grid (num + content)
     and .title-wrap is the right-column flex column. */
.item .title-wrap {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

/* PR 5: locked items REPLACE the three stance buttons with this explanatory
     note. Pattern matches the design 5/20 — a dashed border + grey body
     reads as "informational, not a control" while still leaving room in the
     card height so adjacent items don't reflow when the lock state flips
     mid-meeting. */
.item .locked-note {
  font-size: 15px;
  color: var(--pi-gray-700);
  background: var(--pi-white);
  border: 1px dashed var(--pi-gray-300);
  border-radius: var(--radius-md);
  padding: 12px 16px;
}

/* AB#8889: shown under the (disabled) stance buttons when the user is at their
   per-person item limit and this item isn't already selected. */
.item .limit-note {
  margin-top: 8px;
  font-size: 13px;
  color: var(--pi-gray-700);
}

/* AB#11358: per-section item limit, shown under the section heading. */
.section-limit-note {
  padding: 0 6px 10px;
  font-size: 13px;
  color: var(--pi-gray-700);
}

/* Disabled stance buttons: greyed out, no hover, cursor change. */
.stance:disabled,
.stance[aria-disabled="true"] {
  cursor: not-allowed;
  opacity: 0.45;
  color: var(--pi-gray-500);
  box-shadow: inset 0 0 0 1.5px var(--pi-gray-200);
  background: var(--pi-white);
}

.stance:disabled:hover,
.stance[aria-disabled="true"]:hover {
  background: var(--pi-white);
}

.stance:disabled:active,
.stance[aria-disabled="true"]:active {
  transform: none;
}

.item .item-head {
  display: grid;
  grid-template-columns: fit-content(140px) 1fr;
  gap: 18px;
  align-items: center;
  margin-bottom: 16px;
}

.item .num {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 32px;
  color: var(--pi-ink);
  text-align: center;
  background: var(--pi-gray-100);
  border-radius: var(--radius-md);
  padding: 12px 8px;
  font-variant-numeric: tabular-nums;
  min-width: 56px;
  overflow-wrap: break-word;
}

.item.selected .num {
  background: var(--pi-white);
  color: var(--pi-blue);
}

.item .title {
  /* Per source design: 400-weight reads cleaner on long government-motion
       titles at kiosk distance. See P6. */
  font-family: var(--font-body);
  font-weight: 400;
  font-size: 22px;
  line-height: 1.4;
  color: var(--pi-ink);
  margin: 0;
  text-wrap: pretty;
}

.item .stances {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.stance {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border: 0;
  cursor: pointer;
  padding: 16px 12px;
  min-height: 76px;
  border-radius: var(--radius-lg);
  background: var(--pi-white);
  box-shadow: inset 0 0 0 1.5px var(--pi-gray-300);
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 17px;
  color: var(--pi-ink);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: background var(--motion-fast), color var(--motion-fast),
    box-shadow var(--motion-fast), transform var(--motion-fast);
  line-height: 1.1;
}

.stance:hover {
  background: var(--pi-gray-100);
}

.stance:active {
  transform: scale(0.98);
}

.stance .icon {
  display: grid;
  place-items: center;
}

.stance.on.for {
  /* Darkened from #07afaa to meet WCAG 2.1 AA text contrast — white text on the
     brand teal was ~2.7:1; #0a7d78 is ~5:1. Public-facing government kiosk. */
  background: #0a7d78;
  color: var(--pi-white);
  box-shadow: inset 0 0 0 1.5px #0a7d78;
}

.stance.on.against {
  background: #d0353c;
  color: var(--pi-white);
  box-shadow: inset 0 0 0 1.5px #d0353c;
}

.stance.on.neutral {
  background: var(--pi-gray-700);
  color: var(--pi-white);
  box-shadow: inset 0 0 0 1.5px var(--pi-gray-700);
}

.item .stances.solo {
  grid-template-columns: 1fr;
}

.stance.signup.on {
  /* Same AA-contrast darkened teal as .stance.on.for — this is the primary
     affirmative control in no-disposition mode, so legibility matters most here. */
  background: #0a7d78;
  color: var(--pi-white);
  box-shadow: inset 0 0 0 1.5px #0a7d78;
}

/* ---------- Picks peek (sticky bottom of picker list) ---------- */
.picks-peek {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 32px;
  background: var(--pi-gray-100);
  border-top: 1px solid var(--pi-gray-200);
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 18px;
  color: var(--pi-gray-700);
  text-align: left;
  min-height: 80px;
}

.picks-peek:disabled {
  cursor: default;
}

.picks-peek.active {
  color: var(--pi-ink);
  background: var(--pi-blue-pale);
}

.picks-peek .label {
  flex: 1;
}

.picks-peek .dots {
  display: flex;
  gap: 6px;
}

.picks-peek .dots .dot {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  color: var(--pi-white);
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 16px;
  font-variant-numeric: tabular-nums;
}

.picks-peek .dots .dot.for {
  background: #07afaa;
}

.picks-peek .dots .dot.against {
  background: #d0353c;
}

.picks-peek .dots .dot.neutral {
  background: var(--pi-gray-700);
}

.picks-peek .dots .dot.total {
  background: var(--pi-gray-700);
}

/* ---------- Bottom sheets ---------- */
.sheet-scrim {
  position: fixed;
  inset: 0;
  background: rgba(20, 24, 28, 0.5);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 100;
  animation: scrimIn var(--motion-base) ease-out;
}
@keyframes scrimIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.sheet {
  width: 100%;
  background: var(--pi-white);
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  padding: 24px 32px 32px;
  box-shadow: 0 -20px 60px rgba(0, 0, 0, 0.2);
  animation: sheetIn 320ms cubic-bezier(0.2, 0.8, 0.2, 1);
  max-height: 85%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
@keyframes sheetIn {
  from {
    transform: translateY(40px);
    opacity: 0.4;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* AB#9443: center the language picker as a modal (only its scrim gets this;
   Help/SMS stay bottom sheets). */
.sheet-scrim-centered {
  align-items: center;
  padding: 24px;
}

.sheet-scrim-centered .sheet {
  border-radius: 24px;
}

.sheet-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}

.sheet-head h3 {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 26px;
  margin: 0;
  color: var(--pi-ink);
}

.sheet-close {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border: 0;
  cursor: pointer;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: var(--pi-gray-100);
  color: var(--pi-ink);
  font-size: 28px;
  font-weight: 700;
  display: grid;
  place-items: center;
}

.sheet-sub {
  color: var(--pi-gray-700);
  font-size: 18px;
  margin: 6px 0 18px;
}

.jump-sheet {
  padding-bottom: 40px;
}

.jumpdisplay {
  background: var(--pi-gray-100);
  border-radius: var(--radius-lg);
  padding: 22px 18px;
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 56px;
  color: var(--pi-ink);
  text-align: center;
  margin-bottom: 18px;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.08em;
}

.jumpdisplay.empty {
  color: var(--pi-gray-300);
}

.keypad {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.keypad button {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border: 0;
  cursor: pointer;
  min-height: 88px;
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 32px;
  color: var(--pi-ink);
  background: var(--pi-white);
  border-radius: var(--radius-lg);
  box-shadow: inset 0 0 0 1px var(--pi-gray-300);
}

.keypad button:hover {
  background: var(--pi-gray-100);
}

.keypad button:active {
  transform: scale(0.97);
}

.keypad button.go {
  background: var(--pi-blue);
  color: var(--pi-white);
  box-shadow: none;
  font-size: 22px;
}

.keypad button.go:disabled {
  background: var(--pi-gray-200);
  color: var(--pi-gray-500);
  cursor: not-allowed;
}

.keypad button.del {
  color: var(--pi-gray-700);
  font-size: 26px;
}

/* PR 5: dash key on the number-pad lives in the bottom-left slot (where the
     old "Go" lived) so the muscle-memory of "bottom row = secondary actions"
     stays consistent across modes. Brand color signals it's a special key
     vs. plain digit. */
.keypad button.keypad-alt {
  font-size: 26px;
  color: var(--pi-blue);
}

/* 123 / Letters mode toggle. A pill-shaped segmented control above the
     keypad. The active segment gets the brand fill so the current mode is
     unambiguous; the abc-glyph badge gives the Letters segment a visual
     anchor when shrunk on narrow viewports. */
.jump-mode {
  display: flex;
  background: var(--pi-gray-100);
  border-radius: var(--radius-pill);
  padding: 4px;
  margin: 14px auto;
  max-width: 380px;
}

.jump-mode button {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border: 0;
  cursor: pointer;
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 18px;
  min-height: 52px;
  border-radius: var(--radius-pill);
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 15px;
  color: var(--pi-gray-700);
  background: transparent;
}

.jump-mode button.on {
  background: var(--pi-blue);
  color: var(--pi-white);
  box-shadow: 0 2px 6px rgba(3, 149, 255, 0.25);
}

.jump-mode .abc-glyph {
  font-family: var(--font-display);
  font-weight: 800;
  font-size: 12px;
  letter-spacing: 0.04em;
  background: rgba(255, 255, 255, 0.18);
  padding: 2px 6px;
  border-radius: 4px;
}

.jump-mode button:not(.on) .abc-glyph {
  background: var(--pi-gray-200);
  color: var(--pi-gray-700);
}

/* Letter keypad — 7-column grid (A-G / H-N / O-U / V-Z + dash + ⌫). Smaller
     buttons than .keypad because there are 28 cells; still ≥48px tall to
     satisfy the kiosk touch-target minimum. */
.keypad-abc {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px;
}

.keypad-abc button {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border: 0;
  cursor: pointer;
  min-height: 56px;
  border-radius: var(--radius-md);
  background: var(--pi-white);
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 20px;
  color: var(--pi-ink);
  box-shadow: inset 0 0 0 1px var(--pi-gray-300);
}

.keypad-abc button:hover {
  background: var(--pi-gray-100);
}

.keypad-abc button:active {
  transform: scale(0.96);
}

.keypad-abc button.del {
  color: var(--pi-gray-700);
  font-size: 20px;
}

.keypad-abc button.keypad-alt {
  color: var(--pi-blue);
  font-size: 22px;
}

/* Jump-foot — Clear + Find item buttons. Each .btn flexes equally so the
     two halves balance regardless of label length. The Find item button
     stays disabled until at least one character is typed; visual disabled
     state comes from the existing .btn.primary:disabled cascade. */
.jump-foot {
  display: flex;
  gap: 10px;
  margin-top: 18px;
}

.jump-foot .btn {
  flex: 1;
  justify-content: center;
}

.picks-sheet {
  padding-bottom: 24px;
}

.basket {
  overflow-y: auto;
  margin-top: 8px;
}

.basket .empty {
  background: var(--pi-gray-100);
  border-radius: var(--radius-lg);
  padding: 28px;
  text-align: center;
  color: var(--pi-gray-700);
  font-size: 17px;
}

.chip {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 18px;
  background: var(--pi-white);
  border: 1px solid var(--pi-gray-200);
  border-radius: var(--radius-lg);
  margin-bottom: 10px;
  font-size: 17px;
  color: var(--pi-ink);
}

.chip .n {
  font-family: var(--font-display);
  font-weight: 700;
  color: var(--pi-blue);
  min-width: 44px;
  font-size: 18px;
}

.chip .dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  flex-shrink: 0;
}

.chip .dot.for {
  background: #07afaa;
}

.chip .dot.against {
  background: #d0353c;
}

.chip .dot.neutral {
  background: var(--pi-gray-700);
}

.chip .dot.total {
  background: var(--pi-gray-500);
}

/* Two-line clamp so long government-motion titles read in the basket
     instead of being cut off mid-word at ~50 chars. See H3. */
.chip .label {
  flex: 1;
  min-width: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.35;
}

.chip .x {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border: 0;
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--pi-gray-200);
  color: var(--pi-gray-700);
  font-weight: 700;
  font-size: 20px;
  flex-shrink: 0;
}

/* Empty / no-results */
.empty-state {
  text-align: center;
  padding: 80px 20px;
  color: var(--pi-gray-700);
}

.empty-state .big {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 24px;
  color: var(--pi-ink);
  margin: 0 0 8px;
}

/* ===========================================================
     SCREEN 4 — REVIEW
     =========================================================== */
.review {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  /* Same halo + dot-grid atmosphere as Welcome/Info so the dead space below
       the items list reads as intentional negative space, not abandoned canvas. */
  background: radial-gradient(
      ellipse 80% 30% at 50% 0%,
      var(--pi-blue-pale) 0%,
      transparent 70%
    ),
    radial-gradient(
      ellipse 80% 30% at 50% 100%,
      rgba(219, 241, 255, 0.45) 0%,
      transparent 65%
    ),
    radial-gradient(
        circle at 1px 1px,
        rgba(3, 149, 255, 0.04) 1px,
        transparent 1px
      )
      0 0 / 32px 32px,
    var(--pi-white);
}

.review .main {
  padding: 40px 48px 16px;
  overflow: auto;
  flex: 1;
  min-height: 0;
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  box-sizing: border-box;
}

.review h2 {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 42px;
  margin: 0 0 10px;
}

.review .lede {
  font-size: 20px;
  color: var(--pi-gray-700);
  margin: 0 0 28px;
  max-width: 720px;
}

.review .who {
  background: var(--pi-blue-pale);
  border-radius: var(--radius-xl);
  padding: 22px 26px;
  margin-bottom: 28px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 18px 36px;
}

.review .who .field-label {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--pi-blue);
  margin-bottom: 4px;
}

.review .who .field-val {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 20px;
  color: var(--pi-ink);
}

/* Masked PII row — the value is PERMANENTLY masked. No reveal toggle, no
     "tap to show" button. A kiosk is a public-facing terminal; any unmask
     affordance lets a shoulder-surfer harvest the contact info of whoever
     just hydrated their registration via Lookup. If the legitimate user needs
     to verify or change their address, they tap Back to the Your Info screen
     where the inputs remain editable in clear text. */
.review .who .field-val.masked-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: nowrap;
}

.review .who .masked-val {
  /* tabular-nums keeps the bullet-mask + last-4 phone digits aligned */
  font-variant-numeric: tabular-nums;
  word-break: break-all;
  min-width: 0;
}

/* Summary stat strip — horizontal */
.review .stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 24px;
}

.stat {
  background: var(--pi-white);
  border: 1px solid var(--pi-gray-200);
  border-radius: var(--radius-xl);
  padding: 20px 22px;
}

.stat .v {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 40px;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}

.stat .v .of {
  font-size: 20px;
  color: var(--pi-gray-500);
}

.stat .l {
  font-size: 15px;
  color: var(--pi-gray-700);
  margin-top: 8px;
  font-family: var(--font-display);
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.stat.for .v {
  color: #07afaa;
}

.stat.against .v {
  color: #d0353c;
}

.stat.neutral .v {
  color: var(--pi-gray-700);
}

.review .selections h3 {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 22px;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.review .who-head,
.review .selections-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
  flex-wrap: wrap;
}

.review .who-head h3 {
  font-family: var(--font-display);
  font-size: clamp(18px, 1.6vw, 22px);
  color: var(--pi-ink);
  margin: 0;
}

.edit-step-btn {
  background: var(--pi-white);
  color: var(--pi-blue);
  box-shadow: inset 0 0 0 2px var(--pi-blue);
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 16px;
  padding: 12px 20px;
  min-height: 52px;
  border-radius: var(--radius-lg);
  display: inline-flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: background var(--motion-base);
}

.edit-step-btn:hover {
  background: var(--pi-blue-pale);
}

.edit-step-btn:active {
  transform: translateY(1px);
}

/* Bigger CTA inside the empty-state when there are no picks yet — gives
     the user an unmissable doorway back into the picker. */
.review .review-empty {
  background: var(--pi-blue-pale);
  border: 1px dashed var(--pi-blue);
  border-radius: var(--radius-xl);
  padding: 28px 24px;
  text-align: center;
  margin-bottom: 8px;
}

.review .review-empty .big {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 22px;
  color: var(--pi-ink);
  margin: 0 0 8px;
}

.review .review-empty p {
  font-size: 16px;
  color: var(--pi-gray-700);
  margin: 0 auto 20px;
  max-width: 520px;
  line-height: 1.5;
}

.review .review-empty .btn {
  margin: 0 auto;
}

.review .row {
  display: grid;
  grid-template-columns: fit-content(140px) 1fr auto;
  gap: 18px;
  align-items: center;
  background: var(--pi-white);
  border: 1px solid var(--pi-gray-200);
  border-radius: var(--radius-lg);
  padding: 16px 18px;
  margin-bottom: 10px;
}

.review .row .num {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 24px;
  text-align: center;
  background: var(--pi-gray-100);
  border-radius: var(--radius-md);
  padding: 8px 6px;
  min-width: 56px;
  overflow-wrap: break-word;
}

.review .row .title {
  font-size: 18px;
  color: var(--pi-ink);
}

.review .row .badge {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 14px;
  padding: 8px 16px;
  border-radius: var(--radius-pill);
  color: var(--pi-white);
  letter-spacing: 0.04em;
  text-transform: uppercase;
  min-width: 110px;
  text-align: center;
}

.review .row .badge.for {
  background: #07afaa;
}

.review .row .badge.against {
  background: #d0353c;
}

.review .row .badge.neutral {
  background: var(--pi-gray-700);
}

.review .opt {
  background: var(--pi-gray-100);
  border-radius: var(--radius-xl);
  padding: 18px 22px;
  margin-top: 28px;
}

/* Settles the review screen when the items list is short. See H4. */
.review-tail {
  margin: 28px 0 64px;
  text-align: center;
  color: var(--pi-gray-700);
  font-size: 15px;
  letter-spacing: 0.04em;
  font-family: var(--font-display);
  font-weight: 500;
}

.review-tail strong {
  color: var(--pi-blue);
  font-weight: 700;
}

.review .opt label {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  cursor: pointer;
  font-size: 17px;
  color: var(--pi-ink);
}

/* .review .opt input[type="checkbox"] is styled by the shared surrogate-checkbox
     rule above (see H5). The duplicate badge rules from a copy-paste have been
     removed — the canonical .review .row .badge.* rules sit a few lines up. */

.done-translate-bar {
  display: flex;
  justify-content: flex-end;
  padding: 8px 24px;
}

/* ===========================================================
     SCREEN 5 — DONE
     =========================================================== */
.confirmation {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  justify-content: safe center;
  overflow-y: auto;
  text-align: center;
  padding: 48px;
  background: radial-gradient(
    ellipse at 50% 0%,
    var(--pi-blue-pale) 0%,
    transparent 60%
  );
}

.confirmation .check {
  flex-shrink: 0;
  width: 120px;
  height: 120px;

  /* flex-shrink:0 — .confirmation is a flex column. Without this, when the
     Done content overflows the stage (long agenda-item lists, or the taller
     wrapped copy of a translated language like Spanish), the flex column
     shrinks this fixed-height circle on the vertical axis while its 120px
     width is preserved on the cross axis — collapsing the circle into a wide
     ellipse. Locking flex-shrink keeps it perfectly round at any content
     height. */
  flex-shrink: 0;
  border-radius: 50%;
  background: #07afaa;
  color: var(--pi-white);
  display: grid;
  place-items: center;
  margin: 0 auto 28px;
  box-shadow: 0 12px 36px rgba(7, 175, 170, 0.3);
}

.confirmation h1 {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 48px;
  margin: 0 0 12px;
}

.confirmation .number {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 22px;
  color: var(--pi-blue);
  margin-bottom: 8px;
  letter-spacing: 0.08em;
}

.confirmation p {
  font-size: 20px;
  color: var(--pi-gray-700);
  max-width: 640px;
  margin: 0 auto 32px;
}

/* Race-condition soft notice on Done — items that closed for sign-up between
     Picker render and server processing. Amber tint to read as "heads up" not
     "error", since the user's other selections all went through. */
.dropped-notice {
  background: #fff7e6;
  border: 1px solid #ff7c1d;
  border-radius: var(--radius-xl);
  padding: 18px 22px;
  margin: 0 auto 28px;
  max-width: 640px;
  text-align: left;
  color: var(--pi-ink);
}

.dropped-notice .dropped-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  font-family: var(--font-display);
  font-size: 16px;
  color: var(--pi-ink);
}

.dropped-notice .dropped-head svg {
  color: var(--pi-orange);
  flex-shrink: 0;
}

.dropped-notice p {
  font-size: 15px;
  color: var(--pi-gray-700);
  margin: 0 0 10px;
  max-width: none;
}

.dropped-notice ul {
  margin: 0;
  padding-left: 22px;
  font-size: 15px;
  line-height: 1.5;
  color: var(--pi-ink);
}

.dropped-notice ul li {
  margin-bottom: 4px;
}

.kiosk-notice {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #fff7e6;
  border: 1px solid #ff7c1d;
  border-radius: var(--radius-xl);
  padding: 14px 16px;
  margin: 12px 20px 0;
  color: var(--pi-ink);
}

.kiosk-notice-body {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  flex: 1;
  font-size: 15px;
  line-height: 1.45;
}

.kiosk-notice-body svg {
  color: var(--pi-orange);
  flex-shrink: 0;
  margin-top: 1px;
}

.kiosk-notice-close {
  flex-shrink: 0;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 24px;
  line-height: 1;
  color: var(--pi-gray-700);
  padding: 0 4px;
}

/* Matches the Review screen's .stat tiles: the count is the headline, the label supports it.
   flex-shrink:0 for the same reason as .check -- .confirmation is a flex column. */
.speaking-summary {
  flex-shrink: 0;
  margin: 0 0 32px;
  padding: 20px 32px;
  min-width: 240px;
  max-width: 100%;
  background: var(--pi-white);
  border: 1px solid var(--pi-gray-200);
  border-radius: var(--radius-xl);
  text-align: center;
}

.speaking-summary dt {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 15px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--pi-gray-700);
}

.speaking-summary dd {
  display: flex;
  align-items: baseline;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
  margin: 8px 0 0;
}

.speaking-summary .count {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 40px;
  line-height: 1;
  color: var(--pi-ink);
  font-variant-numeric: tabular-nums;
}

.speaking-summary .unit {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 20px;
  color: var(--pi-gray-700);
}

/* ---------- Tweaks (font scale) ---------- */
body.fs-comfortable .picker .item .title {
  font-size: 24px;
}

body.fs-comfortable .item .num {
  font-size: 34px;
}

body.fs-large .picker .item .title {
  font-size: 26px;
}

body.fs-large .item .num {
  font-size: 36px;
}

body.fs-large .stance {
  font-size: 19px;
  min-height: 84px;
}

body.fs-large .picker .search input {
  font-size: 28px;
}

/* ===========================================================
     RESPONSIVE — tablet, laptop, narrow phones
     Below 900px wide we tighten chrome paddings and fonts.
     Below 600px (small tablets / phones in portrait) we collapse
     to a phone-friendly density.
     =========================================================== */
@media (max-width: 900px) {
  .topbar {
    padding: 14px 20px;
  }

  .agency .seal {
    width: 40px;
    height: 40px;
    font-size: 14px;
  }

  .agency .text .org {
    font-size: 16px;
  }

  .agency .text .meta {
    font-size: 12px;
  }

  .topbar .clock {
    font-size: 18px;
  }

  .topbar .clock .date {
    font-size: 11px;
  }

  .progress {
    padding: 6px 16px;
    min-height: 52px;
    gap: 8px 10px;
  }

  .progress .step {
    font-size: 13px;
    padding: 6px 10px;
    gap: 8px;
  }

  .progress .step .num {
    width: 24px;
    height: 24px;
    font-size: 12px;
  }

  .progress .help {
    padding: 6px 10px;
    font-size: 12px;
  }

  .welcome-scroll {
    padding: 32px 24px;
  }

  .welcome h1 {
    font-size: 36px;
  }

  .welcome p {
    font-size: 18px;
  }

  .welcome .meeting-card {
    padding: 18px 22px;
  }

  .welcome .meeting-card .title {
    font-size: 22px;
  }

  .info {
    padding: 32px 24px;
    gap: 24px;
  }

  .info .lead h2 {
    font-size: 32px;
  }

  .info .lead p {
    font-size: 17px;
  }

  .info .field input {
    font-size: 20px;
    min-height: 60px;
    padding: 16px 18px;
  }

  .info .attend label {
    font-size: 17px;
    min-height: 60px;
    padding: 16px 18px;
  }

  .picker .search-row {
    padding: 16px 20px 8px;
  }

  .picker .filters {
    padding: 4px 20px 10px;
  }

  .picker .list {
    padding: 4px 20px 8px;
  }

  .picker .search input {
    font-size: 20px;
    min-height: 60px;
    padding: 16px 16px 16px 52px;
  }

  .picker .search svg {
    left: 16px;
  }

  .picker .jump-btn {
    font-size: 16px;
    padding: 16px 18px;
    min-height: 60px;
  }

  .picker .jump-btn span {
    display: none;
  }

  .item {
    padding: 16px 16px;
  }

  .item .item-head {
    grid-template-columns: fit-content(110px) 1fr;
    gap: 14px;
    margin-bottom: 12px;
  }

  .item .num {
    font-size: 24px;
    padding: 8px 6px;
    min-width: 44px;
  }

  .item .title {
    font-size: 18px;
  }

  .stance {
    font-size: 14px;
    min-height: 60px;
    padding: 10px 8px;
    gap: 6px;
  }

  .picks-peek {
    padding: 14px 20px;
    min-height: 64px;
    font-size: 15px;
  }

  .picks-peek .dots .dot {
    width: 32px;
    height: 32px;
    font-size: 14px;
  }

  .actionbar {
    padding: 14px 20px;
    min-height: 80px;
    gap: 10px;
  }

  .actionbar .summary {
    font-size: 15px;
  }

  .actionbar .summary .sub {
    font-size: 12px;
  }

  .btn {
    font-size: 16px;
    padding: 14px 20px;
    min-height: 56px;
  }

  .btn.lg {
    font-size: 18px;
    padding: 16px 24px;
    min-height: 60px;
  }

  .btn.xl {
    font-size: 20px;
    padding: 20px 30px;
    min-height: 72px;
  }

  .review .main {
    padding: 28px 24px 12px;
  }

  .review h2 {
    font-size: 30px;
  }

  .review .lede {
    font-size: 16px;
  }

  .review .who {
    padding: 16px 18px;
    gap: 12px 20px;
  }

  .review .who .field-val {
    font-size: 16px;
  }

  .stat .v {
    font-size: 30px;
  }

  .review .row .num {
    font-size: 20px;
    min-width: 44px;
  }

  .review .row .title {
    font-size: 15px;
  }

  .review .row {
    grid-template-columns: fit-content(100px) 1fr auto;
    gap: 12px;
    padding: 12px 14px;
  }

  .review .row .badge {
    font-size: 11px;
    padding: 6px 12px;
    min-width: 88px;
  }

  .confirmation {
    padding: 32px 24px;
  }

  .confirmation h1 {
    font-size: 32px;
  }

  .confirmation p {
    font-size: 16px;
  }

  .confirmation .check {
    width: 88px;
    height: 88px;
  }

  .confirmation .check svg {
    width: 48px;
    height: 48px;
  }

  .speaking-summary {
    min-width: 0;
    margin-bottom: 24px;
    padding: 16px 24px;
  }

  .speaking-summary .count {
    font-size: 32px;
  }

  .speaking-summary .unit {
    font-size: 17px;
  }

  .sheet {
    padding: 18px 22px 24px;
  }

  .sheet-head h3 {
    font-size: 22px;
  }

  .jumpdisplay {
    font-size: 44px;
    padding: 18px 14px;
  }

  .keypad button {
    font-size: 26px;
    min-height: 72px;
  }

  .keypad button.go {
    font-size: 18px;
  }

  /* PR 5: alphabet keypad shrinks to 6 columns on phones so all 28 keys
       still fit without the buttons collapsing below the 48px touch min. */
  .keypad-abc {
    grid-template-columns: repeat(6, 1fr);
  }

  .keypad-abc button {
    min-height: 48px;
    font-size: 18px;
  }

  .jump-mode button {
    font-size: 14px;
    min-height: 44px;
  }
}

/* Progress strip collapses to step-of-N on phones */
@media (max-width: 560px) {
  .progress .step:not(.active) .step-label {
    display: none;
  }

  .progress .step.active {
    flex: 1 1 auto;
  }

  .progress .help {
    padding: 6px 8px;
  }

  .progress .help > span {
    display: none;
  }

  .info .field-row {
    grid-template-columns: 1fr;
  }

  .info .attend {
    flex-direction: column;
  }

  .item .stances {
    gap: 6px;
  }

  .stance {
    font-size: 13px;
    padding: 8px 6px;
    min-height: 56px;
  }

  .stance .icon svg {
    width: 18px;
    height: 18px;
  }

  .review .who {
    grid-template-columns: 1fr;
  }

  .review .row {
    grid-template-columns: 48px 1fr;
    row-gap: 10px;
  }

  .review .row .badge {
    grid-column: 1 / -1;
    min-width: 0;
    justify-self: start;
  }
}

/* When the kiosk is short (laptop landscape ≤720px tall),
     reduce vertical padding so the picker list still has room. */
@media (max-height: 720px) {
  .topbar {
    padding: 10px 24px;
  }

  .progress {
    min-height: 44px;
    padding-block: 4px;
  }

  /* There is no vertical room to wrap labels here, so the inactive ones become numbers
     rather than being cut in half. */
  .progress .step:not(.active) .step-label {
    display: none;
  }

  .progress .step.active {
    flex: 1 1 auto;
  }

  .welcome-scroll {
    padding: 24px;
  }

  .welcome h1 {
    font-size: 32px;
    margin-bottom: 10px;
  }

  .welcome p {
    font-size: 16px;
    margin-bottom: 18px;
  }

  .welcome .meeting-card {
    margin-bottom: 20px;
    padding: 14px 20px;
  }

  .welcome .lang {
    margin-top: 18px;
  }

  .info {
    padding: 16px 32px;
    gap: 12px;
  }

  .info .lead h2 {
    font-size: 28px;
    margin-bottom: 4px;
  }

  .info .lead p {
    font-size: 15px;
    margin-bottom: 8px;
  }

  .info .form {
    gap: 10px;
  }

  .info .field {
    gap: 4px;
  }

  .info .field label {
    font-size: 15px;
  }

  .info .field input:not([type="checkbox"]):not([type="radio"]) {
    font-size: 18px;
    min-height: 44px;
    padding: 10px 14px;
  }

  .info .field .custom-field-select {
    font-size: 18px;
    min-height: 44px;
    padding: 10px 14px;
  }

  .sms-consent {
    padding: 6px 0;
  }

  .sms-consent .sms-copy {
    font-size: 14px;
  }

  .interpreter-section {
    padding: var(--space-3);
    margin-top: var(--space-2);
  }

  .interpreter-legend {
    font-size: var(--fs-body);
  }

  .interpreter-option {
    padding: 10px 16px;
    font-size: 16px;
  }

  .interpreter-toggle {
    margin-top: var(--space-2);
  }

  .actionbar {
    min-height: 60px;
    padding: 10px 24px;
  }

  .picker .search-row {
    padding-top: 14px;
    padding-bottom: 8px;
  }

  .picker .filters {
    padding-bottom: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./Scripts/Modules/Kiosk/MeetingKiosk/styles/meeting-kiosk.css"],"names":[],"mappings":"AAAA;;;;;;;;iEAQiE;;AAEjE;;;;;;kEAMkE;AAClE;EACE,iEAAiE;EACjE,kBAAkB,EAAE,sCAAsC;EAC1D,uBAAuB,EAAE,0CAA0C;EACnE,uBAAuB,EAAE,2CAA2C;EACpE,oBAAoB,EAAE,4BAA4B;EAClD,yBAAyB;EACzB,yBAAyB;EACzB,cAAc,EAAE,2BAA2B;;EAE3C,iEAAiE;EACjE,sBAAsB,EAAE,mBAAmB;EAC3C,sBAAsB,EAAE,sCAAsC;EAC9D,sBAAsB,EAAE,wBAAwB;EAChD,sBAAsB,EAAE,kBAAkB;EAC1C,sBAAsB,EAAE,2BAA2B;EACnD,kBAAkB,EAAE,qBAAqB;EACzC,uBAAuB,EAAE,0BAA0B;EACnD,gBAAgB;EAChB,uBAAuB,EAAE,oBAAoB;EAC7C,wBAAwB,EAAE,sBAAsB;;EAEhD,iEAAiE;EACjE,2BAA2B;EAC3B,0BAA0B,EAAE,oDAAoD;EAChF,qCAAqC;EACrC,yBAAyB;EACzB,oCAAoC;EACpC,qCAAqC;EACrC,kCAAkC;EAClC,uCAAuC;EACvC,4BAA4B;EAC5B,8BAA8B;EAC9B,kCAAkC;EAClC,gCAAgC;EAChC,oCAAoC;;EAEpC,iEAAiE;EACjE,8EAA8E;EAC9E;cACY;;EAEZ,gDAAgD;EAChD,aAAa;EACb,aAAa;EACb,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB,EAAE,kBAAkB;EACrC,cAAc,EAAE,UAAU;EAC1B,kBAAkB,EAAE,UAAU;EAC9B,kBAAkB,EAAE,UAAU;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;;EAEd,iEAAiE;EACjE,gBAAgB;EAChB,gBAAgB,EAAE,WAAW;EAC7B,gBAAgB,EAAE,YAAY;EAC9B,iBAAiB,EAAE,kCAAkC;EACrD,qBAAqB;;EAErB,iEAAiE;EACjE,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,gBAAgB;;EAEhB,iEAAiE;EACjE,qBAAqB;EACrB,sBAAsB,EAAE,yBAAyB;EACjD,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;;EAEnB,iEAAiE;EACjE,+CAA+C;EAC/C,gDAAgD;;EAEhD,iEAAiE;EACjE,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;;EAE7B;;;;cAIY;EACZ,2BAA2B;EAC3B,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,0DAA0D;;AAE1D;;;;;;;;;;;;;;;;;;;gEAmBgE;;AAEhE;;6EAE6E;AAC7E;;;;EAIE,sBAAsB;AACxB;;AAEA,4CAA4C;AAC5C;EACE,eAAe;EACf,QAAQ;EACR;;;2DAGyD;EACzD,aAAa;EACb,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;AACf;;AAEA;;;EAGE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;4EAC4E;AAC5E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,sBAAsB;AACxB;;AAEA;;6EAE6E;AAC7E;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,oCAAoC;EACpC,sBAAmB;KAAnB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;0FAC0F;AAC1F;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;oFACoF;AACpF;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;2EAG2E;AAC3E;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,yCAAyC;AACzC;gEACgE;AAChE;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,iCAAiC;EACjC,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;;yFAEyF;AACzF;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;6FAC6F;AAC7F;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;EAC3B,oCAAoC;EACpC,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;;;IAGE,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,8FAA8F;EAC9F,gEAAgE;EAChE,2BAA2B;EAC3B,wCAAwC;EACxC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT;gCAC8B;EAC9B,2BAA2B;EAC3B,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE;gBACc;EACd,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;kEAEkE;AAClE;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;;EAEhB;;mEAEiE;EACjE;;;;;;;;;;;;;;;;mBAgBiB;EACjB,kBAAkB;AACpB;;AAEA,uEAAuE;AACvE;EACE,OAAO;EACP,aAAa;EACb,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;EAC5B,2BAA2B;EAC3B,sDAAsD;AACxD;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,SAAS;;EAET;kFACgF;EAChF,iBAAiB;EACjB,+BAA+B;EAC/B,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,2CAA2C;EAC3C,iBAAiB;EACjB,oBAAoB;EACpB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;AACX;;AAEA;;;;;;;iEAOiE;AACjE;;EAEE,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;EAYE,gCAAgC;EAChC,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;;;EAIE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;;EAEnB;oFACkF;EAClF,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,mCAAmC;EACnC,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;yFACyF;AACzF;EACE,aAAa;;EAEb;wEACsE;EACtE,eAAe;EACf,uBAAuB;EACvB,QAAQ;EACR,2BAA2B;EAC3B,oCAAoC;EACpC,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,8FAA8F;EAC9F,gEAAgE;EAChE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;;+EAE+E;AAC/E;EACE,2BAA2B;EAC3B,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA,gDAAgD;AAChD;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;EACb;AACF;;AAEA,6EAA6E;AAC7E;EACE;IACE,6BAA6B;IAC7B,sDAAsD;EACxD;;EAEA;IACE,6CAA6C;EAC/C;;EAEA;IACE,+CAA+C;EACjD;;EAEA;IACE,wDAAwD;EAC1D;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gEAAgE;EAClE;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA,mFAAmF;AACnF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;;AAGA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;kEAEkE;AAClE;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;;EAEhB;kDACgD;EAChD;;;;;;;;;;;;;;;;mBAgBiB;AACnB;;AAEA;EACE;;sDAEoD;EACpD,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,mCAAmC;EACnC,4BAA4B;EAC5B,gBAAgB;EAChB,oCAAoC;EACpC,+BAA+B;EAC/B,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;;;gFAMgF;AAChF;EACE;;;+DAG6D;EAC7D,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,SAAS;EACT,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;;EAEf;;;0DAGwD;EACxD,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,+BAA+B;EAC/B,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,YAAY;EACZ,+BAA+B;EAC/B,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,mEAAmE;AACrE;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,sBAAsB;;EAEtB;2CACyC;EACzC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;;EAEzB;sEACoE;EACpE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE;;;oDAGkD;EAClD,mCAAmC;EACnC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE;;oBAEkB;EAClB,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,oCAAoC;EACpC,+BAA+B;EAC/B,mBAAmB;EACnB;gCAC8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;;;mEAGiE;EACjE,cAAc;EACd,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,kCAAkC;EAClC,yCAAyC;EACzC,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;;kEAEkE;;AAElE;;;6CAG6C;AAC7C;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB;;;;;;;;;;;;;;;;mBAgBiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;;qEAEqE;AACrE;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,+BAA+B;EAC/B,2BAA2B;EAC3B,oBAAoB;EACpB,WAAW;EACX,0EAA0E;AAC5E;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;;uEAGuE;AACvE;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;4DAC4D;AAC5D;EACE,qBAAgB;OAAhB,gBAAgB;EAChB,wBAAwB;EACxB,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,+BAA+B;EAC/B,2BAA2B;EAC3B,oBAAoB;EACpB,WAAW;EACX,sBAAsB;EACtB,0EAA0E;;EAE1E,uEAAuE;EACvE,yDAA4Q;EAC5Q,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA,sDAAsD;AACtD;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,+BAA+B;EAC/B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,+BAA+B;EAC/B,6BAA6B;EAC7B,eAAe;EACf,+BAA+B;EAC/B,sBAAsB;EACtB,eAAe;EACf,0EAA0E;EAC1E,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,+BAA+B;EAC/B,2BAA2B;EAC3B,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,OAAO;EACP,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;;cAGc;AACd;;EAEE,qBAAgB;OAAhB,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,oCAAoC;EACpC,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,0EAA0E;AAC5E;;AAEA;;EAEE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;;EAEE,gBAAgB,EAAE,MAAM;EACxB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;yDAKyD;AACzD;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,2BAA2B;EAC3B,8CAA8C;EAC9C,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,wEAAwE;AAC1E;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;8EAE8E;AAC9E;;EAEE,wBAAwB;AAC1B;;AAEA,6FAA6F;AAC7F;;;;;EAKE,wBAAwB;EACxB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB,EAAE,sDAAsD;AACxD;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,iBAAiB;EACjB,QAAQ;EACR,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;;;;;;;;;kEAUkE;AAClE;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;;;;EAIE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,kBAAkB;;EAElB;;gEAE8D;AAChE;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,sBAAsB,EAAE,8FAA8F;EACtH,6BAA6B;EAC7B,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,oCAAoC;EACpC,+BAA+B;EAC/B,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAFA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,2BAA2B;EAC3B,oCAAoC;EACpC,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,cAAc,EAAE,yDAAyD;AAC3E;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,2BAA2B;EAC3B,8CAA8C;EAC9C,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,iCAAiC;EACjC,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;;EAEhB;;;;;6BAK2B;EAC3B,8BAA8B;EAC9B,iCAAiC;EACjC,4BAA4B;EAC5B,qBAAqB;EACrB,uBAAuB;;EAEvB;;0EAEwE;EACxE,kBAAkB;AACpB;;AAEA;;;;;gFAKgF;AAChF;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;;IAElB;;+EAE2E;IAC3E,UAAU;IACV,aAAa;;IAEb;;;;;;;;;2DASuD;IACvD,iDAAiD;IACjD,uBAAuB;IACvB,oBAAoB;IACpB,UAAU;EACZ;;EAEA;IACE,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;IAChC,2BAA2B;IAC3B,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,0CAA0C;IAC1C;+DAC2D;EAC7D;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,iCAAiC;IACjC,mBAAmB;EACrB;AACF;;AAEA;;0DAE0D;AAC1D;EACE;IACE;4DACwD;IACxD,iDAAiD;EACnD;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,4DAA4D;AAC5D;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,MAAM;EACN;;;;GAIC;EACD,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,+BAA+B;EAC/B,2BAA2B;EAC3B,oCAAoC;EACpC,mBAAmB;EACnB,0EAA0E;AAC5E;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE;IACE,+BAA+B;IAC/B,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;IAC3B,gCAAgC;EAClC;AACF;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;;;;4CAI4C;AAC5C;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;6CAE6C;AAC7C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,8BAA8B;EAC9B,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;;uDAEuD;AACvD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;;;;mBAImB;AACnB;EACE,eAAe;EACf,yBAAyB;EACzB,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;gEACgE;AAChE;EACE,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA,uEAAuE;AACvE;EACE,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA,kEAAkE;AAClE;;EAEE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,gDAAgD;EAChD,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6CAA6C;EAC7C,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,8BAA8B;EAC9B,+BAA+B;EAC/B,iBAAiB;EACjB,kCAAkC;EAClC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE;0CACwC;EACxC,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,2BAA2B;EAC3B,gDAAgD;EAChD,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT;+DAC6D;EAC7D,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;8EAC4E;EAC5E,mBAAmB;EACnB,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;mFACiF;EACjF,mBAAmB;EACnB,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA,oEAAoE;AACpE;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,8BAA8B;EAC9B,wCAAwC;EACxC,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,8CAA8C;AAChD;AACA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,uBAAuB;EACvB,2CAA2C;EAC3C,uDAAuD;EACvD,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE;IACE,2BAA2B;IAC3B,YAAY;EACd;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;kCACkC;AAClC;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,2BAA2B;EAC3B,+BAA+B;EAC/B,8CAA8C;AAChD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;;uBAGuB;AACvB;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;;;8CAG8C;AAC9C;EACE,aAAa;EACb,8BAA8B;EAC9B,iCAAiC;EACjC,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,OAAO;EACP,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;8CAE8C;AAC9C;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,2BAA2B;EAC3B,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;;mEAGmE;AACnE;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,oCAAoC;EACpC,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;8DAC8D;AAC9D;EACE,OAAO;EACP,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;;kEAEkE;AAClE;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;;EAEhB;kFACgF;EAChF;;;;;;;;;;;;;;;;mBAgBiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,OAAO;EACP,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;;;;;sDAKsD;AACtD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,qEAAqE;EACrE,kCAAkC;EAClC,qBAAqB;EACrB,YAAY;AACd;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;EACnC,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,0CAA0C;EAC1C,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;2DAC2D;AAC3D;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kDAAkD;EAClD,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,oCAAoC;EACpC,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;EACjC,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,oEAAoE;AACpE;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,sBAAsB;EACtB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;;8EAE8E;;AAE9E;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;kEAEkE;AAClE;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb;;;;GAIC;AACH;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;;EAEb;;;;;;cAMY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;mEAEmE;AACnE;EACE,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,OAAO;EACP,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,cAAc;AAChB;;AAEA;mFACmF;AACnF;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,oCAAoC;EACpC,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA,8CAA8C;AAC9C;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;kEAKkE;AAClE;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,4BAA4B;EAC9B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,6CAA6C;IAC7C,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kDAAkD;IAClD,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;2EACyE;EACzE;IACE,qCAAqC;EACvC;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,oDAAoD;AACpD;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,+BAA+B;IAC/B,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;EACrB;AACF;;AAEA;iEACiE;AACjE;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;qCACmC;EACnC;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* ============================================================\r\n   Meeting Kiosk — bundled CSS\r\n   Ported from Anthropic Claude Design package:\r\n     publicinput-frontend-public-design-system/project/kiosk/Meeting check-in kiosk.html\r\n     publicinput-frontend-public-design-system/project/colors_and_type.css\r\n   Scoped under .meeting-kiosk-shell on the App root so styles can't leak\r\n   into other pages on the same hostname. Fonts come from Google Fonts CDN\r\n   loaded in Views/MeetingKiosk/Index.cshtml — no @font-face here.\r\n   ============================================================ */\r\n\r\n/* ---------- Design tokens (variables only) ----------\r\n   Scoped to .meeting-kiosk-shell (not :root) deliberately:\r\n   1. Avoids leaking design-system variable names into the host page.\r\n   2. Avoids webpack's postcss-root-to-host transformer (which rewrites\r\n      \":root\" -> \":host\" for ShadowDOM consumers); that transform breaks\r\n      these tokens when the bundle is loaded into a normal document head\r\n      via style-loader, which is what happens for Kiosk modules. */\r\n.meeting-kiosk-shell {\r\n  /* -- Brand colors (web) — from Colors.pdf -------------------- */\r\n  --pi-blue: #0395ff; /* Primary action / links / nav fill */\r\n  --pi-blue-soft: #84d0f7; /* Highlight, soft tabs, secondary fills */\r\n  --pi-blue-pale: #dbf1ff; /* Tinted card background — the workhorse */\r\n  --pi-orange: #ff7c1d; /* Brand accent / callouts */\r\n  --pi-orange-soft: #f6a572;\r\n  --pi-orange-pale: #ffdec7;\r\n  --pi-ink: #333; /* Primary text / display */\r\n\r\n  /* -- UI-support colors --------------------------------------- */\r\n  --pi-gray-700: #696868; /* Secondary text */\r\n  --pi-gray-500: #8997a1; /* Tertiary / muted / disabled label */\r\n  --pi-gray-300: #c4cdd4; /* Borders, separators */\r\n  --pi-gray-200: #eaedef; /* Disabled fill */\r\n  --pi-gray-100: #f5f8fa; /* Subtle row alternation */\r\n  --pi-teal: #44c5e2; /* Map/chart accent */\r\n  --pi-teal-deep: #07afaa; /* Status / chart accent */\r\n  --pi-white: #fff;\r\n  --pi-footer-bg: #2b2b2b; /* Footer charcoal */\r\n  --pi-utility-bg: #3d3d3d; /* Utility menu chip */\r\n\r\n  /* -- Semantic role tokens ------------------------------------ */\r\n  --color-bg: var(--pi-white);\r\n  --color-bg-tinted: #f8fafb; /* off-white card background (per design feedback) */\r\n  --color-bg-subtle: var(--pi-gray-100);\r\n  --color-fg: var(--pi-ink);\r\n  --color-fg-muted: var(--pi-gray-700);\r\n  --color-fg-subtle: var(--pi-gray-500);\r\n  --color-border: var(--pi-gray-300);\r\n  --color-border-soft: var(--pi-gray-200);\r\n  --color-link: var(--pi-blue);\r\n  --color-action: var(--pi-blue);\r\n  --color-action-fg: var(--pi-white);\r\n  --color-accent: var(--pi-orange);\r\n  --color-success: var(--pi-teal-deep);\r\n\r\n  /* -- Type ---------------------------------------------------- */\r\n  --font-display: \"Montserrat\", system-ui, -apple-system, \"Segoe UI\", sans-serif;\r\n  --font-body: \"Libre Franklin\", system-ui, -apple-system, \"Segoe UI\",\r\n    sans-serif;\r\n\r\n  /* Scale — exact px values from Typography.pdf */\r\n  --fs-h1: 42px;\r\n  --fs-h2: 32px;\r\n  --fs-h3: 24px;\r\n  --fs-h4: 18px;\r\n  --fs-overline: 14px;\r\n  --fs-body-lg: 18px;\r\n  --fs-body: 16px;\r\n  --fs-body-sm: 14px;\r\n  --lh-display: 1.5; /* 150% per spec */\r\n  --lh-body: 1.5; /* 24/16 */\r\n  --lh-body-sm: 1.43; /* 20/14 */\r\n  --lh-body-lg: 1.67; /* 30/18 */\r\n  --fw-regular: 400;\r\n  --fw-semibold: 600;\r\n  --fw-bold: 700;\r\n\r\n  /* -- Radii --------------------------------------------------- */\r\n  --radius-sm: 4px;\r\n  --radius-md: 6px; /* inputs */\r\n  --radius-lg: 8px; /* buttons */\r\n  --radius-xl: 12px; /* cards, hero, large containers */\r\n  --radius-pill: 9999px;\r\n\r\n  /* -- Spacing scale ------------------------------------------- */\r\n  --space-1: 4px;\r\n  --space-2: 8px;\r\n  --space-3: 12px;\r\n  --space-4: 16px;\r\n  --space-5: 20px;\r\n  --space-6: 24px;\r\n  --space-7: 32px;\r\n  --space-8: 40px;\r\n  --space-9: 56px;\r\n  --space-10: 80px;\r\n\r\n  /* -- Layout -------------------------------------------------- */\r\n  --container-md: 960px;\r\n  --container-lg: 1140px; /* per Figma annotation */\r\n  --container-xl: 1200px;\r\n  --sidebar-w: 360px;\r\n  --nav-strip-h: 56px;\r\n\r\n  /* -- Shadows (mostly unused — system relies on tinted bg) ---- */\r\n  --shadow-popover: 0 2px 8px rgba(0, 0, 0, 0.08);\r\n  --shadow-overlay: 0 8px 24px rgba(0, 0, 0, 0.12);\r\n\r\n  /* -- Motion -------------------------------------------------- */\r\n  --motion-fast: 120ms ease-out;\r\n  --motion-base: 180ms ease-out;\r\n  --motion-slow: 240ms ease-out;\r\n\r\n  /* -- Baseline shell styles -----------------------------------\r\n     Merged into the variable-token block (rather than a separate\r\n     .meeting-kiosk-shell rule) to satisfy stylelint's\r\n     no-duplicate-selectors. See the comment further below for the\r\n     intent. */\r\n  background: var(--pi-white);\r\n  font-family: var(--font-body);\r\n  color: var(--pi-ink);\r\n  overflow: hidden;\r\n}\r\n\r\n/* ---------- Kiosk styles (from design HTML) ---------- */\r\n\r\n/* ===========================================================\r\n   KIOSK CHROME\r\n   Fluid responsive — fills any viewport. Designed primarily for\r\n   a portrait 43–55\" display mounted by chamber doors, but adapts\r\n   cleanly to tablet portrait/landscape and laptop screens.\r\n   Content sections are capped at ~1100px so they don't sprawl on\r\n   wide monitors.\r\n\r\n   .meeting-kiosk-shell wraps the React mount. It only sets baseline\r\n   font/color/background so the inner .kiosk (which keeps its own\r\n   position:fixed;inset:0) owns the viewport without double-fixed-\r\n   positioning weirdness. We deliberately do NOT restyle html/body\r\n   from this bundle — those rules from the design's source would\r\n   leak to any host page that ever mounts this bundle alongside\r\n   other content.\r\n\r\n   Baseline declarations live in the variable-token block at the\r\n   top of this file (see line 18) — stylelint's no-duplicate-selectors\r\n   rule means we can have exactly one `.meeting-kiosk-shell` rule.\r\n   =========================================================== */\r\n\r\n/* Modern box-sizing reset, scoped to the kiosk shell so it can't leak.\r\n   Without this, inputs declared `width: 100%` overflow their flex container\r\n   by the sum of padding+border — that was the root cause of C1's clipping. */\r\n.meeting-kiosk-shell,\r\n.meeting-kiosk-shell *,\r\n.meeting-kiosk-shell *::before,\r\n.meeting-kiosk-shell *::after {\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* The kiosk surface — fills the viewport. */\r\n.kiosk {\r\n  position: fixed;\r\n  inset: 0;\r\n  /* iPad Safari sizes a fixed inset:0 box to the LAYOUT viewport, which stays tall while the\r\n     toolbars are on screen — so the action bar lands below the fold and the page scrolls to\r\n     reach it. svh is the smallest viewport, so the bar is reachable in either toolbar state.\r\n     The vh line is the fallback for engines without svh. */\r\n  height: 100vh;\r\n  height: 100svh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: var(--pi-white);\r\n  overflow: hidden;\r\n}\r\n\r\n.kiosk > .stage {\r\n  flex: 1;\r\n  min-height: 0;\r\n}\r\n\r\n.kiosk > .topbar,\r\n.kiosk > .progress,\r\n.kiosk > .actionbar {\r\n  flex: 0 0 auto;\r\n}\r\n\r\n/* ---------- Top bar ---------- */\r\n/* Every string in this bar is translatable and can arrive several times longer than its\r\n   English source, so nothing here may size itself from its content alone. */\r\n.topbar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 20px;\r\n  padding: 18px 32px;\r\n  background: var(--pi-white);\r\n  border-bottom: 1px solid var(--pi-gray-200);\r\n}\r\n\r\n.agency {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 14px;\r\n  min-width: 0;\r\n}\r\n\r\n.agency .seal,\r\n.agency .seal-img {\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.agency .seal {\r\n  width: 48px;\r\n  height: 48px;\r\n  border-radius: 50%;\r\n  background: var(--pi-blue-pale);\r\n  display: grid;\r\n  place-items: center;\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  color: var(--pi-blue);\r\n  font-size: 16px;\r\n  letter-spacing: 0.05em;\r\n}\r\n\r\n/* Real customer logo (when LogoImageId is set on the Customer row).\r\n     object-fit:contain keeps a wide brand mark from getting cropped to a\r\n     circle; the white background avoids dark transparent PNGs blending in. */\r\n.agency .seal-img {\r\n  width: 56px;\r\n  height: 56px;\r\n  border-radius: 12px;\r\n  background: var(--pi-white);\r\n  border: 1px solid var(--pi-gray-200);\r\n  object-fit: contain;\r\n  padding: 4px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* 1.2 was tight enough that Devanagari, Burmese and Arabic ascenders were clipped by the\r\n   clamp and collided with the line below. Scripts with stacked marks need the headroom. */\r\n.agency .text {\r\n  line-height: 1.5;\r\n  min-width: 0;\r\n}\r\n\r\n.agency .text .org {\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: 18px;\r\n  line-height: 1.6;\r\n  color: var(--pi-ink);\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n  overflow-wrap: anywhere;\r\n}\r\n\r\n.agency .text .meta {\r\n  font-size: 14px;\r\n  color: var(--pi-gray-700);\r\n  letter-spacing: 0.02em;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n/* The time is the one string here that is never translated, so it never wraps. Capping the\r\n   width keeps a long translated date from crowding out the agency name beside it. */\r\n.topbar .clock {\r\n  flex: 0 0 auto;\r\n  max-width: 40%;\r\n  text-align: right;\r\n  white-space: nowrap;\r\n  font-family: var(--font-display);\r\n  font-weight: 600;\r\n  font-size: 22px;\r\n  color: var(--pi-ink);\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.topbar .clock .date {\r\n  display: block;\r\n  font-size: 13px;\r\n  font-weight: 400;\r\n  font-family: var(--font-body);\r\n  color: var(--pi-gray-700);\r\n  letter-spacing: 0.04em;\r\n  text-transform: uppercase;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n/* AB#9427: screen-reader-only utility. The kiosk page has no layout (see\r\n   Views/MeetingKiosk/Index.cshtml) so bootstrap's .sr-only isn't loaded here\r\n   — used on the progress strip to announce \"Step X of Y\" to assistive tech\r\n   without a visible label (the numbered pills are the sighted-user cue). */\r\n.sr-only {\r\n  position: absolute;\r\n  width: 1px;\r\n  height: 1px;\r\n  padding: 0;\r\n  margin: -1px;\r\n  overflow: hidden;\r\n  clip: rect(0, 0, 0, 0);\r\n  white-space: nowrap;\r\n  border: 0;\r\n}\r\n\r\n/* ---------- Progress strip ---------- */\r\n/* Wrapping rather than a fixed height: step labels are translated, and clipping them to one\r\n   row cut them mid-word and dropped the later steps entirely. */\r\n.progress {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: 10px 16px;\r\n  padding: 8px 32px;\r\n  min-height: 56px;\r\n  background: var(--pi-gray-100);\r\n  border-bottom: 1px solid var(--pi-gray-200);\r\n}\r\n\r\n.progress .steps {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 6px 8px;\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n}\r\n\r\n.progress .step {\r\n  flex: 0 1 auto;\r\n  min-width: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 6px 14px;\r\n  border-radius: var(--radius-pill);\r\n  font-family: var(--font-display);\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  color: var(--pi-gray-500);\r\n  background: transparent;\r\n}\r\n\r\n/* A label is shown in full or not at all — never as a fragment. A translation that does not fit\r\n   on one line wraps onto the next and the pill grows; where even that is too tall, the\r\n   short-screen and phone rules below drop the inactive labels to bare numbers instead. */\r\n.progress .step .step-label {\r\n  min-width: 0;\r\n  line-height: 1.5;\r\n  overflow-wrap: anywhere;\r\n}\r\n\r\n.progress .step .num {\r\n  flex: 0 0 auto;\r\n  width: 28px;\r\n  height: 28px;\r\n  overflow: hidden;\r\n  border-radius: 50%;\r\n  display: grid;\r\n  place-items: center;\r\n  background: var(--pi-gray-200);\r\n  color: var(--pi-gray-700);\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n}\r\n\r\n.progress .step.done {\r\n  color: var(--pi-blue);\r\n}\r\n\r\n.progress .step.done .num {\r\n  background: var(--pi-blue-pale);\r\n  color: var(--pi-blue);\r\n}\r\n\r\n.progress .step.done .num::after {\r\n  content: \"✓\";\r\n}\r\n\r\n.progress .step.done .num span {\r\n  display: none;\r\n}\r\n\r\n.progress .step.active {\r\n  color: var(--pi-ink);\r\n  background: var(--pi-white);\r\n  box-shadow: inset 0 0 0 1px var(--pi-gray-300);\r\n}\r\n\r\n.progress .step.active .num {\r\n  background: var(--pi-blue);\r\n  color: var(--pi-white);\r\n}\r\n\r\n/* The help / switch-language trigger renders in the progress bar and again on Done, so it is\r\n   styled unscoped -- scoping it to .progress left the Done bar with a bare browser button. */\r\n.help {\r\n  flex: 0 1 auto;\r\n  min-width: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 8px 14px;\r\n  border-radius: var(--radius-lg);\r\n  background: var(--pi-white);\r\n  border: 1px solid var(--pi-gray-300);\r\n  font-family: var(--font-display);\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n  color: var(--pi-ink);\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n}\r\n\r\n.help > span {\r\n  min-width: 0;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.help svg {\r\n  flex: 0 0 auto;\r\n  color: var(--pi-blue);\r\n}\r\n\r\n/* ---------- Stage (screen container) ---------- */\r\n.stage {\r\n  position: relative;\r\n  overflow: hidden;\r\n  transition: opacity 0.25s ease;\r\n}\r\n\r\n.stage.mk-retranslating {\r\n  opacity: 0;\r\n  transition: opacity 0.05s ease;\r\n}\r\n\r\n.screen {\r\n  position: absolute;\r\n  inset: 0;\r\n  display: none;\r\n  overflow: hidden;\r\n}\r\n\r\n.screen.active {\r\n  display: flex;\r\n}\r\n\r\n/* ---------- Loading / error shells ---------- */\r\n.kiosk-loading {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 100%;\r\n  gap: 28px;\r\n}\r\n\r\n.kiosk-loading-spinner {\r\n  display: flex;\r\n  gap: 12px;\r\n}\r\n\r\n.kiosk-loading-dot {\r\n  width: 14px;\r\n  height: 14px;\r\n  border-radius: 50%;\r\n  background: var(--pi-blue);\r\n  animation: kioskDotPulse 1.4s ease-in-out infinite both;\r\n}\r\n\r\n.kiosk-loading-dot:nth-child(2) {\r\n  animation-delay: 0.16s;\r\n}\r\n\r\n.kiosk-loading-dot:nth-child(3) {\r\n  animation-delay: 0.32s;\r\n}\r\n\r\n@keyframes kioskDotPulse {\r\n  0%,\r\n  80%,\r\n  100% {\r\n    opacity: 0.25;\r\n    transform: scale(0.7);\r\n  }\r\n\r\n  40% {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n.kiosk-loading-text {\r\n  font-family: var(--font-body);\r\n  font-size: var(--fs-body-lg);\r\n  color: var(--color-fg-muted);\r\n  margin: 0;\r\n}\r\n\r\n.error {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 100%;\r\n  text-align: center;\r\n  padding: var(--space-8);\r\n}\r\n\r\n.error h2 {\r\n  font-family: var(--font-display);\r\n  font-size: var(--fs-h3);\r\n  color: var(--color-fg);\r\n  margin: 0 0 var(--space-3) 0;\r\n}\r\n\r\n.error p {\r\n  font-family: var(--font-body);\r\n  font-size: var(--fs-body);\r\n  color: var(--color-fg-muted);\r\n  margin: 0 0 var(--space-2) 0;\r\n}\r\n\r\n/* ---------- Bottom action bar ---------- */\r\n.actionbar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  /* Home-indicator iPads overlay the bottom edge; without the inset the buttons sit under it. */\r\n  padding: 18px 32px calc(18px + env(safe-area-inset-bottom, 0px));\r\n  background: var(--pi-white);\r\n  border-top: 1px solid var(--pi-gray-200);\r\n  gap: 16px;\r\n  min-height: 96px;\r\n}\r\n\r\n.actionbar .summary {\r\n  font-family: var(--font-display);\r\n  font-weight: 600;\r\n  font-size: 18px;\r\n  color: var(--pi-ink);\r\n}\r\n\r\n.actionbar .summary .count {\r\n  color: var(--pi-blue);\r\n  font-weight: 700;\r\n}\r\n\r\n.actionbar .summary .sub {\r\n  display: block;\r\n  font-family: var(--font-body);\r\n  font-weight: 400;\r\n  font-size: 14px;\r\n  color: var(--pi-gray-700);\r\n  margin-top: 2px;\r\n}\r\n\r\n.actions {\r\n  display: flex;\r\n  gap: 12px;\r\n  align-items: center;\r\n}\r\n\r\n/* ---------- Buttons (kiosk-scale) ---------- */\r\n.btn {\r\n  appearance: none;\r\n  border: 0;\r\n  cursor: pointer;\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: 18px;\r\n  padding: 18px 28px;\r\n  min-height: 64px;\r\n  border-radius: var(--radius-lg);\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  transition: background var(--motion-base), color var(--motion-base),\r\n    transform var(--motion-fast);\r\n  background: var(--pi-white);\r\n  color: var(--pi-ink);\r\n  box-shadow: inset 0 0 0 1px var(--pi-gray-300);\r\n}\r\n\r\n.btn:hover {\r\n  background: var(--pi-gray-100);\r\n}\r\n\r\n.btn:active {\r\n  transform: translateY(1px);\r\n}\r\n\r\n.btn.primary {\r\n  background: var(--pi-blue);\r\n  color: var(--pi-white);\r\n  box-shadow: none;\r\n}\r\n\r\n.btn.primary:hover {\r\n  background: #0277cc;\r\n}\r\n\r\n.btn.primary:disabled {\r\n  background: var(--pi-gray-200);\r\n  color: var(--pi-gray-500);\r\n  cursor: not-allowed;\r\n}\r\n\r\n.btn.ghost {\r\n  /* Quieter color so primary CTA wins the eye at kiosk-viewing distance.\r\n       See P3. */\r\n  background: transparent;\r\n  color: var(--pi-gray-700);\r\n  box-shadow: none;\r\n}\r\n\r\n.btn.ghost:hover {\r\n  background: var(--pi-gray-100);\r\n}\r\n\r\n.btn.lg {\r\n  font-size: 22px;\r\n  padding: 22px 34px;\r\n  min-height: 80px;\r\n}\r\n\r\n.btn.xl {\r\n  font-size: 26px;\r\n  padding: 26px 44px;\r\n  min-height: 96px;\r\n}\r\n\r\n/* ===========================================================\r\n     SCREEN 1 — WELCOME\r\n     =========================================================== */\r\n.welcome {\r\n  flex: 1;\r\n  min-height: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n\r\n  /* Double-halo: top + bottom blue-pale radial bleeds so a tall portrait\r\n       kiosk viewport doesn't dead-end into flat white below the hero block.\r\n       Plus a faint dot grid for civic-design atmosphere. See H1. */\r\n  background: radial-gradient(\r\n      ellipse 80% 40% at 50% 0%,\r\n      var(--pi-blue-pale) 0%,\r\n      transparent 70%\r\n    ),\r\n    radial-gradient(\r\n      ellipse 80% 35% at 50% 100%,\r\n      rgba(219, 241, 255, 0.55) 0%,\r\n      transparent 65%\r\n    ),\r\n    radial-gradient(\r\n        circle at 1px 1px,\r\n        rgba(3, 149, 255, 0.06) 1px,\r\n        transparent 1px\r\n      )\r\n      0 0 / 32px 32px,\r\n    var(--pi-white);\r\n  text-align: center;\r\n}\r\n\r\n/* The only scrolling region; the action buttons below it are pinned. */\r\n.welcome-scroll {\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: safe center;\r\n  gap: clamp(16px, 3vh, 40px);\r\n  padding: clamp(20px, 4vh, 72px) clamp(32px, 5vw, 64px);\r\n}\r\n\r\n.welcome .pre {\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: 14px;\r\n  letter-spacing: 0.2em;\r\n  text-transform: uppercase;\r\n  color: var(--pi-blue);\r\n  margin: 0;\r\n\r\n  /* Pill chip treatment for the pre-header — gives it visual weight against\r\n       the large hero h1, and reads as a deliberate label not a forgotten p tag. */\r\n  padding: 8px 18px;\r\n  background: var(--pi-blue-pale);\r\n  border-radius: var(--radius-pill);\r\n  display: inline-block;\r\n}\r\n\r\n.welcome h1 {\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: clamp(32px, min(5vw, 7vh), 60px);\r\n  line-height: 1.05;\r\n  color: var(--pi-ink);\r\n  margin: 0;\r\n  max-width: 900px;\r\n  text-wrap: balance;\r\n  letter-spacing: -0.01em;\r\n}\r\n\r\n.welcome p {\r\n  font-size: clamp(16px, min(1.6vw, 2.6vh), 21px);\r\n  line-height: 1.5;\r\n  color: var(--pi-gray-700);\r\n  max-width: 640px;\r\n  margin: 0;\r\n}\r\n\r\n/* AB#9415 council review: admin-authored CKEditor HTML (KioskMode.Content)\r\n   renders here via dangerouslySetInnerHTML. Without scoping, any heading tag\r\n   an admin's rich text happens to contain would inherit `.welcome h1`'s\r\n   40-60px page-title styling via the plain descendant selector above,\r\n   producing a second full-size page heading and breaking the WCAG 2.1 AA\r\n   heading outline for screen-reader navigation. Cap headings and give\r\n   common CKEditor output (paragraphs, lists, links) sane kiosk-scale\r\n   defaults instead of falling back to bare user-agent styling. */\r\n.kiosk-opening-content,\r\n.kiosk-confirmation-content {\r\n  max-width: 640px;\r\n  font-size: clamp(17px, 1.6vw, 21px);\r\n  line-height: 1.5;\r\n  color: var(--pi-gray-700);\r\n}\r\n\r\n.kiosk-opening-content h1,\r\n.kiosk-opening-content h2,\r\n.kiosk-opening-content h3,\r\n.kiosk-opening-content h4,\r\n.kiosk-opening-content h5,\r\n.kiosk-opening-content h6,\r\n.kiosk-confirmation-content h1,\r\n.kiosk-confirmation-content h2,\r\n.kiosk-confirmation-content h3,\r\n.kiosk-confirmation-content h4,\r\n.kiosk-confirmation-content h5,\r\n.kiosk-confirmation-content h6 {\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: clamp(20px, 2vw, 26px);\r\n  line-height: 1.2;\r\n  color: var(--pi-ink);\r\n  margin: 0 0 8px;\r\n}\r\n\r\n.kiosk-opening-content p,\r\n.kiosk-confirmation-content p {\r\n  margin: 0 0 8px;\r\n}\r\n\r\n.kiosk-opening-content ul,\r\n.kiosk-opening-content ol,\r\n.kiosk-confirmation-content ul,\r\n.kiosk-confirmation-content ol {\r\n  margin: 0 0 8px;\r\n  padding-left: 1.25em;\r\n  text-align: left;\r\n}\r\n\r\n.kiosk-opening-content a,\r\n.kiosk-confirmation-content a {\r\n  color: var(--pi-blue);\r\n}\r\n\r\n.welcome .meeting-card {\r\n  display: inline-flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n\r\n  /* Stronger card: larger, white-with-border so it sits on the halo background\r\n       rather than dissolving into it; tinted \"when\" pill carries the brand color. */\r\n  background: var(--pi-white);\r\n  border: 1px solid var(--pi-blue-pale);\r\n  border-radius: var(--radius-xl);\r\n  padding: 28px 44px;\r\n  max-width: 640px;\r\n  box-shadow: 0 4px 24px rgba(3, 149, 255, 0.08);\r\n}\r\n\r\n.welcome .meeting-card .when {\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: 13px;\r\n  color: var(--pi-blue);\r\n  letter-spacing: 0.14em;\r\n  margin-bottom: 10px;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.welcome .meeting-card .title {\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: clamp(22px, 2.2vw, 28px);\r\n  color: var(--pi-ink);\r\n  line-height: 1.2;\r\n  text-wrap: balance;\r\n}\r\n\r\n.welcome .meeting-card .where {\r\n  font-size: 16px;\r\n  color: var(--pi-gray-700);\r\n  margin-top: 10px;\r\n}\r\n\r\n/* LanguagePicker renders on Welcome, Lookup and the Done bar, so the pill bar is styled\r\n   unscoped -- scoping it to .welcome left the lookup screen with bare browser buttons. */\r\n.lang {\r\n  display: flex;\r\n\r\n  /* AB#9443: wrap + center so a meeting with several in-person languages\r\n     doesn't overflow the pill bar horizontally on the opening screen. */\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  background: var(--pi-white);\r\n  border: 1px solid var(--pi-gray-300);\r\n  border-radius: var(--radius-xl);\r\n  padding: 5px;\r\n}\r\n\r\n.lang button {\r\n  appearance: none;\r\n  border: 0;\r\n  cursor: pointer;\r\n  padding: 8px 16px;\r\n  min-height: 40px;\r\n  border-radius: var(--radius-pill);\r\n  font-family: var(--font-display);\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  color: var(--pi-gray-700);\r\n  background: transparent;\r\n}\r\n\r\n.lang button.on {\r\n  background: var(--pi-blue);\r\n  color: var(--pi-white);\r\n}\r\n\r\n.welcome .lang {\r\n  margin-top: 8px;\r\n}\r\n\r\n.welcome-actions {\r\n  flex: 0 0 auto;\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 16px;\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n  align-items: center;\r\n  /* Home-indicator iPads overlay the bottom edge; without the inset the buttons sit under it. */\r\n  padding: 18px 32px calc(18px + env(safe-area-inset-bottom, 0px));\r\n  background: var(--pi-white);\r\n  border-top: 1px solid var(--pi-gray-200);\r\n}\r\n\r\n/* Secondary CTA: outline-with-brand-stroke. A 1px gray border vanishes at\r\n     kiosk viewing distance; a 2.5px blue stroke + blue text reads as a\r\n     deliberate alternative-path affordance and contrasts the filled primary. */\r\n.welcome-actions .btn:not(.primary) {\r\n  background: var(--pi-white);\r\n  box-shadow: inset 0 0 0 2.5px var(--pi-blue);\r\n  color: var(--pi-blue);\r\n}\r\n\r\n.welcome-actions .btn:not(.primary):hover {\r\n  background: var(--pi-blue-pale);\r\n  box-shadow: inset 0 0 0 2.5px var(--pi-blue);\r\n}\r\n\r\n/* Stack the action buttons on narrow screens. */\r\n@media (max-width: 640px) {\r\n  .welcome-actions {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n/* Tablets in landscape. Design floor is 744px tall -- iPad Mini (AB#9885). */\r\n@media (max-height: 950px) {\r\n  .welcome-scroll {\r\n    gap: clamp(10px, 1.8vh, 40px);\r\n    padding: clamp(12px, 2vh, 72px) clamp(32px, 5vw, 64px);\r\n  }\r\n\r\n  .welcome h1 {\r\n    font-size: clamp(26px, min(5vw, 5.2vh), 60px);\r\n  }\r\n\r\n  .welcome p {\r\n    font-size: clamp(15px, min(1.6vw, 2.2vh), 21px);\r\n  }\r\n\r\n  .welcome .meeting-card {\r\n    padding: clamp(12px, 2vh, 28px) clamp(24px, 3.5vw, 44px);\r\n  }\r\n\r\n  .welcome .meeting-card .when {\r\n    margin-bottom: 6px;\r\n  }\r\n\r\n  .welcome .meeting-card .where {\r\n    margin-top: 6px;\r\n  }\r\n\r\n  .welcome .capacity-chip {\r\n    padding: 7px 20px;\r\n  }\r\n\r\n  .welcome .lang button {\r\n    padding: 8px 16px;\r\n  }\r\n\r\n  .welcome-actions {\r\n    padding: 12px 32px calc(12px + env(safe-area-inset-bottom, 0px));\r\n  }\r\n\r\n  .welcome-actions .btn.xl {\r\n    font-size: 22px;\r\n    padding: 16px 34px;\r\n    min-height: 68px;\r\n  }\r\n\r\n  .welcome-actions .btn.lg {\r\n    font-size: 19px;\r\n    padding: 14px 26px;\r\n    min-height: 60px;\r\n  }\r\n}\r\n\r\n/* ---- Capacity chips (Welcome screen): attendee and speaker share one look ---- */\r\n.welcome .capacity-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 10px 24px;\r\n  border-radius: 40px;\r\n  font-size: clamp(14px, 1.3vw, 16px);\r\n  font-weight: 600;\r\n  font-family: var(--font-display);\r\n}\r\n\r\n.welcome .capacity-chip.open {\r\n  background: var(--pi-blue-pale);\r\n  color: var(--pi-blue);\r\n}\r\n\r\n.welcome .capacity-chip.low {\r\n  background: var(--pi-orange-pale);\r\n  color: var(--pi-orange);\r\n}\r\n\r\n.welcome .capacity-chip.full {\r\n  background: #fee2e2;\r\n  color: #b91c1c;\r\n}\r\n\r\n.welcome .capacity-full-cta {\r\n  font-size: clamp(16px, 1.5vw, 18px);\r\n  color: var(--pi-gray-700);\r\n  text-align: center;\r\n  margin: 0;\r\n  max-width: 480px;\r\n}\r\n\r\n\r\n.field-required,\r\n.field-optional {\r\n  font-weight: 400;\r\n  font-size: 0.85em;\r\n  color: var(--pi-gray-500);\r\n  margin-left: 4px;\r\n}\r\n\r\n.field-required {\r\n  color: var(--pi-orange);\r\n}\r\n\r\n.advance-blocked-reason {\r\n  color: var(--pi-orange);\r\n  font-size: clamp(14px, 1.2vw, 16px);\r\n  font-weight: 600;\r\n  margin-right: 12px;\r\n}\r\n\r\n.submit-error {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  max-width: 420px;\r\n  margin-right: 16px;\r\n  padding: 10px 18px;\r\n  border-radius: var(--radius-md);\r\n  background: #fee2e2;\r\n  color: #b91c1c;\r\n  font-family: var(--font-display);\r\n  font-size: clamp(14px, 1.2vw, 16px);\r\n  font-weight: 600;\r\n  line-height: 1.35;\r\n}\r\n\r\n/* ===========================================================\r\n     SCREEN — LOOKUP (find a previous registration)\r\n     =========================================================== */\r\n.lookup {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n\r\n  /* Halo + dot-grid atmosphere — same treatment as Welcome/Info/Review so\r\n       no screen reads as \"empty canvas + form.\" */\r\n  background: radial-gradient(\r\n      ellipse 80% 30% at 50% 0%,\r\n      var(--pi-blue-pale) 0%,\r\n      transparent 70%\r\n    ),\r\n    radial-gradient(\r\n      ellipse 80% 30% at 50% 100%,\r\n      rgba(219, 241, 255, 0.45) 0%,\r\n      transparent 65%\r\n    ),\r\n    radial-gradient(\r\n        circle at 1px 1px,\r\n        rgba(3, 149, 255, 0.04) 1px,\r\n        transparent 1px\r\n      )\r\n      0 0 / 32px 32px,\r\n    var(--pi-white);\r\n}\r\n\r\n.lookup-head {\r\n  /* flex-shrink:0 because .lookup is a flex column where .lookup-results\r\n       is the only grow/shrink target. Without it, an aggressive viewport\r\n       shrink could compress the headline + subhead. */\r\n  flex-shrink: 0;\r\n  padding: 24px 48px 8px;\r\n  max-width: 900px;\r\n  width: 100%;\r\n  margin: 0 auto;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.lookup-head h2 {\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: clamp(28px, 3.4vw, 40px);\r\n  line-height: 1.1;\r\n  margin: 0 0 10px;\r\n  color: var(--pi-ink);\r\n  text-wrap: balance;\r\n}\r\n\r\n.lookup-head .sub {\r\n  font-size: clamp(15px, 1.4vw, 18px);\r\n  color: var(--pi-gray-700);\r\n  margin: 0;\r\n  max-width: 640px;\r\n}\r\n\r\n.lookup-search {\r\n  position: relative;\r\n  margin: 12px auto 4px;\r\n  padding: 0 48px;\r\n  max-width: 900px;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.lookup-search input {\r\n  width: 100%;\r\n  font-family: var(--font-body);\r\n  font-size: clamp(22px, 2.4vw, 32px);\r\n  padding: 28px 28px 28px 88px;\r\n  min-height: 96px;\r\n  border: 2px solid var(--pi-gray-300);\r\n  border-radius: var(--radius-lg);\r\n  background: var(--pi-white);\r\n  color: var(--pi-ink);\r\n  box-sizing: border-box;\r\n}\r\n\r\n.lookup-search svg {\r\n  position: absolute;\r\n  left: 78px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  color: var(--pi-gray-500);\r\n  width: 32px;\r\n  height: 32px;\r\n}\r\n\r\n.lookup-search input:focus {\r\n  outline: none;\r\n  border-color: var(--pi-blue);\r\n  box-shadow: 0 0 0 4px rgba(3, 149, 255, 0.18);\r\n}\r\n\r\n.lookup-search .clear {\r\n  position: absolute;\r\n  right: 62px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  width: 56px;\r\n  height: 56px;\r\n  border-radius: 50%;\r\n  border: 0;\r\n  background: var(--pi-gray-200);\r\n  color: var(--pi-gray-700);\r\n  cursor: pointer;\r\n  font-size: 28px;\r\n  font-weight: 700;\r\n  display: grid;\r\n  place-items: center;\r\n}\r\n\r\n/* ---------------------------------------------------------------------------\r\n   New exact-match lookup form (replaces the single-input .lookup-search\r\n   above). Per LAC 5/18 security ask: name + (email OR phone) before any\r\n   data hydrates. The .lookup-search styles above stay in place for now —\r\n   harmless if dropped from JSX, kept around in case a downstream consumer\r\n   still expects them.\r\n   --------------------------------------------------------------------------- */\r\n.lookup-form {\r\n  /* PR 5 follow-up (5/20): explicit flex-shrink:0 so the form doesn't get\r\n       squeezed when the .lookup-results sibling hosts a no-match hint or\r\n       a match row. The form always renders at its natural height; the\r\n       results region is the only flex-grow child of .lookup. */\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex-shrink: 0;\r\n  gap: 12px;\r\n  margin: 12px auto 8px;\r\n  padding: 0 48px;\r\n  max-width: 720px;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.lookup-form .field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.lookup-form .field label {\r\n  font-family: var(--font-display);\r\n  font-weight: 600;\r\n  font-size: 16px;\r\n  color: var(--pi-ink);\r\n}\r\n\r\n.lookup-form .field input {\r\n  font-family: var(--font-body);\r\n  font-size: 20px;\r\n\r\n  /* Tighter vertical rhythm (was 20px / 72px) so three optional fields\r\n       fit comfortably on a kiosk-class portrait viewport without forcing\r\n       the .lookup-results below the fold. Still ≥ 56px which satisfies\r\n       the touch-target minimum for kiosk-glove fingers. */\r\n  padding: 14px 20px;\r\n  min-height: 56px;\r\n  border: 2px solid var(--pi-gray-300);\r\n  border-radius: var(--radius-lg);\r\n  background: var(--pi-white);\r\n  color: var(--pi-ink);\r\n  box-sizing: border-box;\r\n}\r\n\r\n.lookup-form .field input:focus {\r\n  outline: none;\r\n  border-color: var(--pi-blue);\r\n  box-shadow: 0 0 0 4px rgba(3, 149, 255, 0.18);\r\n}\r\n\r\n.lookup-form .field-hint {\r\n  margin: 0;\r\n  font-size: 14px;\r\n  color: var(--pi-gray-700);\r\n}\r\n\r\n.lookup-verifier-toggle {\r\n  display: flex;\r\n  gap: 12px;\r\n  background: var(--pi-gray-100);\r\n  padding: 6px;\r\n  border-radius: var(--radius-lg);\r\n  width: fit-content;\r\n}\r\n\r\n.lookup-verifier {\r\n  appearance: none;\r\n  border: 0;\r\n  background: transparent;\r\n  font-family: var(--font-body);\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  color: var(--pi-gray-700);\r\n  padding: 14px 28px;\r\n  border-radius: var(--radius-md);\r\n  cursor: pointer;\r\n  min-width: 120px;\r\n  transition: background var(--motion-fast), color var(--motion-fast);\r\n}\r\n\r\n.lookup-verifier:hover {\r\n  color: var(--pi-ink);\r\n}\r\n\r\n.lookup-verifier.on {\r\n  background: var(--pi-white);\r\n  color: var(--pi-blue);\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.lookup-actions {\r\n  display: flex;\r\n  justify-content: stretch;\r\n  margin-top: 8px;\r\n}\r\n\r\n.lookup-actions .btn {\r\n  width: 100%;\r\n}\r\n\r\n.lookup-results {\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow-y: auto;\r\n  padding: 0 48px;\r\n  max-width: 900px;\r\n  width: 100%;\r\n  margin: 0 auto;\r\n  box-sizing: border-box;\r\n\r\n  /* Flex column so an empty-state .hint can margin:auto to center vertically\r\n       in the unused result area. See H6. */\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.lookup-results .hint {\r\n  text-align: center;\r\n  padding: 40px 20px;\r\n  color: var(--pi-gray-700);\r\n\r\n  /* Center the empty-state hint vertically inside the results area when\r\n       there are no matches yet — kills the ~1000px dead-space void. */\r\n  margin: auto;\r\n}\r\n\r\n.lookup-results .hint .hint-icon {\r\n  width: 80px;\r\n  height: 80px;\r\n  border-radius: 50%;\r\n  background: var(--pi-gray-100);\r\n  color: var(--pi-gray-500);\r\n  display: grid;\r\n  place-items: center;\r\n  margin: 0 auto 20px;\r\n}\r\n\r\n.lookup-results .hint .big {\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: 24px;\r\n  color: var(--pi-ink);\r\n  margin: 0 0 8px;\r\n}\r\n\r\n.lookup-disambiguation-hint {\r\n  /* Shown above the result rows when a name matches more than one\r\n     registrant (duplicate names on a name-only kiosk — AB#9331). Mirrors\r\n     the .lookup-head .sub subhead tokens so it reads as guidance, not an\r\n     error, and sits flush with the rows below it. */\r\n  font-size: clamp(15px, 1.4vw, 18px);\r\n  color: var(--pi-gray-700);\r\n  margin: 0 0 12px;\r\n}\r\n\r\n.lookup-row {\r\n  /* `appearance: none` strips the native <button> styling; the explicit\r\n     1px border below replaces the default UA border (so no need to first\r\n     zero it out). */\r\n  appearance: none;\r\n  cursor: pointer;\r\n  display: grid;\r\n  grid-template-columns: 72px 1fr auto;\r\n  gap: 22px;\r\n  align-items: center;\r\n  width: 100%;\r\n  text-align: left;\r\n  padding: 24px 28px;\r\n  background: var(--pi-white);\r\n  border: 1px solid var(--pi-gray-200);\r\n  border-radius: var(--radius-xl);\r\n  margin-bottom: 12px;\r\n  transition: background var(--motion-base), border-color var(--motion-base),\r\n    transform var(--motion-fast);\r\n}\r\n\r\n.lookup-row:hover {\r\n  background: var(--pi-gray-100);\r\n  border-color: var(--pi-gray-300);\r\n}\r\n\r\n.lookup-row:active {\r\n  transform: scale(0.99);\r\n}\r\n\r\n.lookup-row .avatar {\r\n  width: 72px;\r\n  height: 72px;\r\n  border-radius: 50%;\r\n  background: var(--pi-blue-pale);\r\n  color: var(--pi-blue);\r\n  display: grid;\r\n  place-items: center;\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: 28px;\r\n  letter-spacing: 0.04em;\r\n}\r\n\r\n.lookup-row .who .name {\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: 26px;\r\n  color: var(--pi-ink);\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.lookup-row .who .meta {\r\n  font-size: 17px;\r\n  color: var(--pi-gray-700);\r\n}\r\n\r\n.lookup-row > svg {\r\n  color: var(--pi-gray-500);\r\n  width: 32px;\r\n  height: 32px;\r\n}\r\n\r\n.lookup-row:hover > svg {\r\n  color: var(--pi-blue);\r\n}\r\n\r\n.lookup-foot {\r\n  /* PR 5 follow-up: flex-shrink:0 pins the foot to the bottom of the\r\n       .lookup column regardless of how tall the .lookup-results middle\r\n       region grows. Without this, a tall no-match hint could push the\r\n       Back / Start-new CTAs off the bottom edge of the viewport. */\r\n  flex-shrink: 0;\r\n  border-top: 1px solid var(--pi-gray-200);\r\n  padding: 20px 48px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n  background: var(--pi-white);\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.lookup-priv {\r\n  margin: 0;\r\n  font-size: 14px;\r\n  color: var(--pi-gray-700);\r\n}\r\n\r\n.linkish {\r\n  appearance: none;\r\n  border: 0;\r\n  background: transparent;\r\n  color: var(--pi-blue);\r\n  cursor: pointer;\r\n  font: inherit;\r\n  font-weight: 600;\r\n  padding: 0;\r\n}\r\n\r\n.linkish:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Returning-user banner on the Review screen */\r\n.returning-banner {\r\n  display: flex;\r\n  gap: 14px;\r\n  align-items: flex-start;\r\n  background: rgba(7, 175, 170, 0.1);\r\n  border: 1px solid rgba(7, 175, 170, 0.35);\r\n  border-radius: var(--radius-lg);\r\n  padding: 16px 20px;\r\n  margin-bottom: 20px;\r\n  font-size: 17px;\r\n  color: var(--pi-ink);\r\n}\r\n\r\n.returning-banner .dot {\r\n  width: 14px;\r\n  height: 14px;\r\n  border-radius: 50%;\r\n  background: #07afaa;\r\n  flex-shrink: 0;\r\n  margin-top: 6px;\r\n  box-shadow: 0 0 0 4px rgba(7, 175, 170, 0.25);\r\n}\r\n\r\n.returning-banner strong {\r\n  color: #057e7a;\r\n}\r\n\r\n/* ===========================================================\r\n     SCREEN 2 — YOUR INFO\r\n     =========================================================== */\r\n\r\n/* .info-stage wraps .info to paint atmosphere across the full stage area.\r\n     Without it, .info (max-width: 980px) leaves the side bands flat-white and\r\n     the bottom band feels dead. The atmosphere matches the Welcome screen's\r\n     halo + dot-grid for visual continuity. */\r\n.info-stage {\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow-y: auto;\r\n  background: radial-gradient(\r\n      ellipse 80% 30% at 50% 0%,\r\n      var(--pi-blue-pale) 0%,\r\n      transparent 70%\r\n    ),\r\n    radial-gradient(\r\n      ellipse 80% 30% at 50% 100%,\r\n      rgba(219, 241, 255, 0.45) 0%,\r\n      transparent 65%\r\n    ),\r\n    radial-gradient(\r\n        circle at 1px 1px,\r\n        rgba(3, 149, 255, 0.04) 1px,\r\n        transparent 1px\r\n      )\r\n      0 0 / 32px 32px,\r\n    var(--pi-white);\r\n  overflow: auto;\r\n}\r\n\r\n.info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 56px 64px;\r\n  gap: 36px;\r\n  width: 100%;\r\n  max-width: 980px;\r\n  margin: 0 auto;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.info .lead h2 {\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: 48px;\r\n  line-height: 1.1;\r\n  margin: 0 0 14px;\r\n  color: var(--pi-ink);\r\n  text-wrap: balance;\r\n}\r\n\r\n.info .lead p {\r\n  font-size: 22px;\r\n  line-height: 1.5;\r\n  color: var(--pi-gray-700);\r\n  margin: 0 0 22px;\r\n  max-width: 720px;\r\n}\r\n\r\n.info .lead .tip {\r\n  background: var(--pi-blue-pale);\r\n  border-radius: var(--radius-xl);\r\n  padding: 18px 22px;\r\n  display: flex;\r\n  gap: 14px;\r\n  align-items: flex-start;\r\n  max-width: 720px;\r\n}\r\n\r\n.info .lead .tip .icon {\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: 50%;\r\n  background: var(--pi-blue);\r\n  color: var(--pi-white);\r\n  display: grid;\r\n  place-items: center;\r\n  flex-shrink: 0;\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n}\r\n\r\n.info .lead .tip p {\r\n  font-size: 16px;\r\n  color: var(--pi-ink);\r\n  margin: 0;\r\n}\r\n\r\n.info .form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 22px;\r\n}\r\n\r\n.info .field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.info .field label {\r\n  font-family: var(--font-display);\r\n  font-weight: 600;\r\n  font-size: 18px;\r\n  color: var(--pi-ink);\r\n}\r\n\r\n/* Scoped to text-like inputs only — without :not(...) this also grabbed\r\n     <input type=\"checkbox\"> and stretched it to min-height:72px with 20px padding.\r\n     The SMS consent surrogate checkbox is styled separately below. */\r\n.info .field input:not([type=\"checkbox\"]):not([type=\"radio\"]) {\r\n  appearance: none;\r\n  font-family: var(--font-body);\r\n  font-size: 24px;\r\n  padding: 20px 22px;\r\n  min-height: 72px;\r\n  border: 1px solid var(--pi-gray-300);\r\n  border-radius: var(--radius-lg);\r\n  background: var(--pi-white);\r\n  color: var(--pi-ink);\r\n  width: 100%;\r\n  transition: border-color var(--motion-base), box-shadow var(--motion-base);\r\n}\r\n\r\n.info .field input:not([type=\"checkbox\"]):not([type=\"radio\"]):focus {\r\n  outline: none;\r\n  border-color: var(--pi-blue);\r\n  box-shadow: 0 0 0 4px rgba(3, 149, 255, 0.18);\r\n}\r\n\r\n.info .field-row {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 16px;\r\n}\r\n\r\n/* Conditional \"required\" affordances. Used by the phone field when the\r\n     user picks Virtual attendance (need a phone to be dialed in) and any\r\n     future field that flips between optional and required based on form\r\n     state. We mark with a red asterisk + small hint below the input. */\r\n.info .field label .req-mark {\r\n  color: #d0353c;\r\n  font-weight: 700;\r\n  margin-left: 2px;\r\n}\r\n\r\n.info .field .field-hint {\r\n  margin: 8px 0 0;\r\n  font-size: 14px;\r\n  line-height: 1.4;\r\n  color: var(--pi-gray-700);\r\n  font-style: italic;\r\n}\r\n\r\n/* Customer-configured custom-field <select>. Matches the .info .field input\r\n     visual so multi-type form rendering looks consistent. */\r\n.info .field .custom-field-select {\r\n  appearance: none;\r\n  -webkit-appearance: none;\r\n  font-family: var(--font-body);\r\n  font-size: 24px;\r\n  padding: 20px 22px;\r\n  min-height: 72px;\r\n  border: 1px solid var(--pi-gray-300);\r\n  border-radius: var(--radius-lg);\r\n  background: var(--pi-white);\r\n  color: var(--pi-ink);\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  transition: border-color var(--motion-base), box-shadow var(--motion-base);\r\n\r\n  /* Native disclosure arrow on the right (chevron via background SVG). */\r\n  background-image: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23696868' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'/></svg>\");\r\n  background-repeat: no-repeat;\r\n  background-position: right 18px center;\r\n  padding-right: 56px;\r\n}\r\n\r\n.info .field .custom-field-select:focus {\r\n  outline: none;\r\n  border-color: var(--pi-blue);\r\n  box-shadow: 0 0 0 4px rgba(3, 149, 255, 0.18);\r\n}\r\n\r\n/* ---------- Interpreter request section ---------- */\r\n.interpreter-section {\r\n  border: 1px solid var(--pi-gray-200);\r\n  border-radius: var(--radius-xl);\r\n  padding: var(--space-6);\r\n  margin-top: var(--space-4);\r\n}\r\n\r\n.interpreter-legend {\r\n  font-family: var(--font-body);\r\n  font-size: var(--fs-body-lg);\r\n  font-weight: var(--fw-semibold);\r\n  color: var(--color-fg);\r\n  padding: 0 var(--space-2);\r\n}\r\n\r\n.interpreter-toggle {\r\n  display: flex;\r\n  gap: 12px;\r\n  margin-top: var(--space-3);\r\n}\r\n\r\n.interpreter-option {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 10px;\r\n  padding: 16px 20px;\r\n  border: 2px solid var(--pi-gray-300);\r\n  border-radius: var(--radius-lg);\r\n  font-family: var(--font-body);\r\n  font-size: 20px;\r\n  font-weight: var(--fw-semibold);\r\n  color: var(--color-fg);\r\n  cursor: pointer;\r\n  transition: border-color var(--motion-base), background var(--motion-base);\r\n  user-select: none;\r\n}\r\n\r\n.interpreter-option input[type=\"radio\"] {\r\n  position: absolute;\r\n  opacity: 0;\r\n  width: 0;\r\n  height: 0;\r\n}\r\n\r\n.interpreter-option.active {\r\n  border-color: var(--pi-blue);\r\n  background: var(--pi-blue-pale);\r\n  color: var(--pi-blue);\r\n}\r\n\r\n.interpreter-language-field {\r\n  margin-top: var(--space-4);\r\n}\r\n\r\n.field-hint-static {\r\n  display: block;\r\n  font-family: var(--font-body);\r\n  font-size: var(--fs-body-sm);\r\n  color: var(--color-fg-subtle);\r\n  margin-top: var(--space-2);\r\n}\r\n\r\n.info .attend {\r\n  display: flex;\r\n  gap: 12px;\r\n}\r\n\r\n.info .attend label {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 14px;\r\n  padding: 20px 22px;\r\n  min-height: 72px;\r\n  border: 1px solid var(--pi-gray-300);\r\n  border-radius: var(--radius-lg);\r\n  background: var(--pi-white);\r\n  cursor: pointer;\r\n  font-family: var(--font-display);\r\n  font-weight: 600;\r\n  font-size: 20px;\r\n  color: var(--pi-ink);\r\n}\r\n\r\n.info .attend label.on {\r\n  border-color: var(--pi-blue);\r\n  background: var(--pi-blue-pale);\r\n  box-shadow: inset 0 0 0 1px var(--pi-blue);\r\n}\r\n\r\n.info .attend .radio {\r\n  width: 26px;\r\n  height: 26px;\r\n  border-radius: 50%;\r\n  border: 2px solid var(--pi-gray-500);\r\n  display: grid;\r\n  place-items: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.info .attend label.on .radio {\r\n  border-color: var(--pi-blue);\r\n}\r\n\r\n.info .attend label.on .radio::after {\r\n  content: \"\";\r\n  width: 14px;\r\n  height: 14px;\r\n  border-radius: 50%;\r\n  background: var(--pi-blue);\r\n}\r\n\r\n/* ---------- SMS consent row ---------- */\r\n.sms-consent {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 8px;\r\n  margin-top: 12px;\r\n  padding: 14px 16px;\r\n  background: var(--pi-gray-100);\r\n  border-radius: var(--radius-lg);\r\n  transition: opacity var(--motion-base);\r\n}\r\n\r\n.sms-consent.muted {\r\n  opacity: 0.6;\r\n}\r\n\r\n.sms-consent label {\r\n  flex: 1;\r\n  display: flex;\r\n  gap: 12px;\r\n  align-items: flex-start;\r\n  cursor: pointer;\r\n  font-size: 16px;\r\n  color: var(--pi-ink);\r\n  line-height: 1.4;\r\n}\r\n\r\n/* Surrogate checkbox: native accent-color only paints the *checked* state,\r\n     so unchecked checkboxes vary across browsers/DPI scales and read as\r\n     unstyled blocks. We render our own box and check glyph via :checked::after.\r\n     See H5. */\r\n.sms-consent input[type=\"checkbox\"],\r\n.review .opt input[type=\"checkbox\"] {\r\n  appearance: none;\r\n  -webkit-appearance: none;\r\n  width: 28px;\r\n  height: 28px;\r\n  margin: 1px 0 0;\r\n  border: 2px solid var(--pi-gray-500);\r\n  border-radius: 6px;\r\n  background: var(--pi-white);\r\n  cursor: pointer;\r\n  flex-shrink: 0;\r\n  display: grid;\r\n  place-items: center;\r\n  transition: background var(--motion-fast), border-color var(--motion-fast);\r\n}\r\n\r\n.sms-consent input[type=\"checkbox\"]:checked,\r\n.review .opt input[type=\"checkbox\"]:checked {\r\n  background: var(--pi-blue);\r\n  border-color: var(--pi-blue);\r\n}\r\n\r\n.sms-consent input[type=\"checkbox\"]:checked::after,\r\n.review .opt input[type=\"checkbox\"]:checked::after {\r\n  content: \"\\2713\"; /* ✓ */\r\n  color: var(--pi-white);\r\n  font-weight: 700;\r\n  font-size: 20px;\r\n  line-height: 1;\r\n}\r\n\r\n.sms-consent input[type=\"checkbox\"]:focus-visible,\r\n.review .opt input[type=\"checkbox\"]:focus-visible {\r\n  outline: none;\r\n  box-shadow: 0 0 0 4px rgba(3, 149, 255, 0.18);\r\n}\r\n\r\n.sms-consent input:disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.6;\r\n}\r\n\r\n.sms-consent .sms-copy {\r\n  flex: 1;\r\n}\r\n\r\n.sms-consent .info-btn {\r\n  appearance: none;\r\n  border: 0;\r\n  cursor: pointer;\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 50%;\r\n  background: var(--pi-white);\r\n  color: var(--pi-blue);\r\n  display: grid;\r\n  place-items: center;\r\n  flex-shrink: 0;\r\n  box-shadow: inset 0 0 0 1px var(--pi-gray-300);\r\n}\r\n\r\n.sms-consent .info-btn:hover {\r\n  background: var(--pi-blue-pale);\r\n}\r\n\r\n.field-hint {\r\n  display: block;\r\n  margin-top: 6px;\r\n  font-size: 14px;\r\n  color: #c0392b;\r\n}\r\n\r\n.info-sheet {\r\n  max-width: 720px;\r\n}\r\n\r\n/* ---------- Language picker sheet ---------------------------------------\r\n     Opened from the topbar Translate button when the kiosk admin has enabled\r\n     2+ languages (KioskMode.LanguageCodesCsv). Renders each enabled language\r\n     as a tall touch-friendly tile showing the native autoglossonym (big) +\r\n     the English name (small, secondary). Tapping a tile drives the Google\r\n     Translate widget through applyTranslateLanguage(). */\r\n.langs-sheet {\r\n  max-width: 640px;\r\n  padding-bottom: 32px;\r\n}\r\n\r\n.langs-sheet .langs-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  gap: 12px;\r\n  overflow-y: auto;\r\n  margin-top: 4px;\r\n}\r\n@media (max-width: 480px) {\r\n  .langs-sheet .langs-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n.lang-row {\r\n  appearance: none;\r\n  border: 0;\r\n  cursor: pointer;\r\n  background: var(--pi-white);\r\n  box-shadow: inset 0 0 0 1px var(--pi-gray-300);\r\n  border-radius: var(--radius-lg);\r\n  padding: 18px 20px;\r\n  min-height: 88px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n  gap: 4px;\r\n  text-align: left;\r\n  transition: background var(--motion-fast), box-shadow var(--motion-fast);\r\n}\r\n\r\n.lang-row:hover {\r\n  background: var(--pi-gray-100);\r\n}\r\n\r\n.lang-row:active {\r\n  transform: scale(0.99);\r\n}\r\n\r\n.lang-row.on {\r\n  background: var(--pi-blue-pale);\r\n  box-shadow: inset 0 0 0 2px var(--pi-blue);\r\n}\r\n\r\n.lang-row .lang-native {\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: 22px;\r\n  color: var(--pi-ink);\r\n  line-height: 1.1;\r\n}\r\n\r\n.lang-row.on .lang-native {\r\n  color: var(--pi-blue);\r\n}\r\n\r\n.lang-row .lang-english {\r\n  font-family: var(--font-body);\r\n  font-size: 14px;\r\n  color: var(--pi-gray-700);\r\n  font-weight: 400;\r\n  letter-spacing: 0.02em;\r\n}\r\n\r\n/* Google Translate widget polish: the auto-injected top bar is iframe-only\r\n     and breaks our viewport-locked layout — kill it. The hidden combo + its\r\n     parent host stay invisible since we drive translation programmatically. */\r\nbody > .skiptranslate,\r\nbody > iframe.goog-te-banner-frame {\r\n  display: none !important;\r\n}\r\n\r\n/* A spinner that never resolves would sit in the corner of a kiosk left running (AB#9884). */\r\n.goog-te-spinner-pos,\r\n.goog-te-balloon-frame,\r\n#goog-gt-tt,\r\n.goog-tooltip,\r\n.goog-text-highlight {\r\n  display: none !important;\r\n  box-shadow: none !important;\r\n  background: none !important;\r\n}\r\n\r\nbody {\r\n  top: 0 !important;\r\n} /* the widget tries to add `top:40px` for its banner */\r\n#google_translate_element {\r\n  position: absolute !important;\r\n  left: -9999px !important;\r\n  top: 0 !important;\r\n  width: 0;\r\n  height: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.info-body p,\r\n.info-body li {\r\n  font-size: 17px;\r\n  line-height: 1.5;\r\n  color: var(--pi-ink);\r\n}\r\n\r\n.info-body p {\r\n  margin: 0 0 14px;\r\n}\r\n\r\n.info-body ul {\r\n  margin: 0 0 16px;\r\n  padding-left: 20px;\r\n}\r\n\r\n.info-body li {\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.info-body .link-row {\r\n  color: var(--pi-gray-700);\r\n  font-size: 15px;\r\n}\r\n\r\n.info-body a {\r\n  color: var(--pi-blue);\r\n  text-decoration: underline;\r\n  font-weight: 600;\r\n}\r\n\r\n.info-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  margin-top: 8px;\r\n}\r\n\r\n/* ===========================================================\r\n     SCREEN 3 — AGENDA PICKER (the key screen)\r\n     Portrait layout: stacked vertically.\r\n       ┌── search-row ────────────────┐\r\n       ├── filters ───────────────────┤\r\n       ├── list (scrolls) ────────────┤\r\n       └── picks-peek (sticky CTA) ───┘\r\n     Keypad + selections live in bottom-sheets.\r\n     On wide-landscape (≥1100px landscape) the list and chrome\r\n     center at max-width so items don't stretch absurdly wide.\r\n     =========================================================== */\r\n.picker {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  background: var(--pi-white);\r\n  position: relative;\r\n}\r\n\r\n.picker .search-row,\r\n.picker .filters,\r\n.picker .list,\r\n.picker .picks-peek {\r\n  width: 100%;\r\n  max-width: 1100px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.picker .search-row {\r\n  display: flex;\r\n  gap: 14px;\r\n  padding: 24px 32px 12px;\r\n  align-items: center;\r\n}\r\n\r\n.picker .search {\r\n  flex: 1;\r\n  min-width: 0;\r\n  position: relative;\r\n\r\n  /* min-width:0 is critical — without it the flex item refuses to shrink\r\n       below the input's intrinsic width and the .jump-btn gets pushed past\r\n       the right edge of the search-row. See design-review C1. */\r\n}\r\n\r\n.picker .search svg {\r\n  position: absolute;\r\n  left: 22px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  color: var(--pi-gray-500);\r\n}\r\n\r\n.picker .search input {\r\n  width: 100%;\r\n  box-sizing: border-box; /* without this, padding+border push width past 100% and the .jump-btn gets cut off — see C1 */\r\n  font-family: var(--font-body);\r\n  font-size: 26px;\r\n  padding: 22px 22px 22px 64px;\r\n  min-height: 76px;\r\n  border: 1px solid var(--pi-gray-300);\r\n  border-radius: var(--radius-lg);\r\n  background: var(--pi-white);\r\n  color: var(--pi-ink);\r\n}\r\n\r\n.picker .search input::placeholder {\r\n  color: var(--pi-gray-500);\r\n}\r\n\r\n.picker .search input:focus {\r\n  outline: none;\r\n  border-color: var(--pi-blue);\r\n  box-shadow: 0 0 0 4px rgba(3, 149, 255, 0.18);\r\n}\r\n\r\n.picker .search .clear {\r\n  position: absolute;\r\n  right: 14px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  width: 48px;\r\n  height: 48px;\r\n  border-radius: 50%;\r\n  border: 0;\r\n  background: var(--pi-gray-200);\r\n  color: var(--pi-gray-700);\r\n  cursor: pointer;\r\n  font-size: 22px;\r\n  font-weight: 700;\r\n  display: grid;\r\n  place-items: center;\r\n}\r\n\r\n.picker .jump-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 22px 26px;\r\n  min-height: 76px;\r\n  border-radius: var(--radius-lg);\r\n  background: var(--pi-white);\r\n  border: 1px solid var(--pi-gray-300);\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: 20px;\r\n  color: var(--pi-ink);\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n  flex-shrink: 0; /* paired with .picker .search { min-width:0 } — see C1 */\r\n}\r\n\r\n.picker .jump-btn:hover {\r\n  background: var(--pi-gray-100);\r\n}\r\n\r\n.picker .jump-btn svg {\r\n  color: var(--pi-blue);\r\n}\r\n\r\n.picker .filters {\r\n  display: flex;\r\n  gap: 10px;\r\n  padding: 4px 32px 14px;\r\n}\r\n\r\n.picker .filter {\r\n  appearance: none;\r\n  border: 0;\r\n  cursor: pointer;\r\n  padding: 14px 24px;\r\n  min-height: 56px;\r\n  border-radius: var(--radius-pill);\r\n  background: var(--pi-white);\r\n  box-shadow: inset 0 0 0 1px var(--pi-gray-300);\r\n  font-family: var(--font-display);\r\n  font-weight: 600;\r\n  font-size: 17px;\r\n  color: var(--pi-gray-700);\r\n  white-space: nowrap;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.picker .filter .pill {\r\n  background: var(--pi-gray-200);\r\n  color: var(--pi-gray-700);\r\n  border-radius: var(--radius-pill);\r\n  padding: 2px 12px;\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.picker .filter.on {\r\n  background: var(--pi-blue-pale);\r\n  color: var(--pi-blue);\r\n  box-shadow: inset 0 0 0 1px var(--pi-blue);\r\n}\r\n\r\n.picker .filter.on .pill {\r\n  background: var(--pi-blue);\r\n  color: var(--pi-white);\r\n}\r\n\r\n.picker .filter:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* List */\r\n.picker .list {\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow-y: auto;\r\n\r\n  /* `touch-action: pan-y` tells the browser explicitly that this region is a\r\n       vertical pan target. Without it, some embedded WebView kiosks (notably\r\n       the chamber kiosk per LAC 5/18 feedback) drop the native swipe gesture\r\n       in favor of generic touchstart event interception, which forces users\r\n       onto the scrollbar thumb. `pinch-zoom` is kept allowed so accessibility\r\n       gestures still work. */\r\n  touch-action: pan-y pinch-zoom;\r\n  -webkit-overflow-scrolling: touch;\r\n  overscroll-behavior: contain;\r\n  padding: 4px 32px 8px;\r\n  scroll-behavior: smooth;\r\n\r\n  /* position:relative makes this the offsetParent of .item, so the\r\n       Jump-to-# scroll math (el.offsetTop relative to listRef.current)\r\n       resolves to the in-list scroll offset, not the in-.picker offset. */\r\n  position: relative;\r\n}\r\n\r\n/* ---------------------------------------------------------------------------\r\n   Side-rail page-up / page-down buttons (LAC 5/18 ask, Pulido item 2).\r\n   Anchored to the right edge of the picker, vertically centered on the list.\r\n   Hidden on narrow viewports (< 900px) — at phone-width the rail would\r\n   overlap content and the fat scrollbar + native swipe are enough.\r\n   --------------------------------------------------------------------------- */\r\n.picker .list-nav {\r\n  display: none;\r\n}\r\n\r\n@media (min-width: 900px) {\r\n  .picker .list-nav {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 24px;\r\n    position: absolute;\r\n\r\n    /* Anchor below the search-row + filters (~152px combined) so the up arrow\r\n         doesn't crash into the Jump-to-# button. The bottom anchor leaves\r\n         space for the picks-peek strip that overlays the list at the bottom. */\r\n    top: 168px;\r\n    bottom: 120px;\r\n\r\n    /* PR 5 follow-up (5/20): the .picker .list is centered with\r\n         max-width: 1100px, so its scrollbar lives at `50% + 550px` of\r\n         the picker on any viewport wide enough to honor the max-width.\r\n         Anchoring the rail with `right: 24px` of .picker put the buttons\r\n         hundreds of pixels OUTSIDE the scrollbar on wide displays.\r\n         The calc below pins the rail's right edge 12px past the centered\r\n         list's right edge — so the buttons sit just outside the\r\n         scrollbar in a tight visual cluster. On viewports < 1100px the\r\n         calc resolves negative and the `max()` falls back to a flat\r\n         right:16px so we don't push the rail off-screen. */\r\n    right: max(16px, calc(50% - 550px - 12px - 88px));\r\n    justify-content: center;\r\n    pointer-events: none;\r\n    z-index: 4;\r\n  }\r\n\r\n  .picker .list-nav-btn {\r\n    pointer-events: auto;\r\n    width: 88px;\r\n    height: 88px;\r\n    border-radius: 50%;\r\n    border: 2px solid var(--pi-blue);\r\n    background: var(--pi-white);\r\n    color: var(--pi-blue);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);\r\n    transition: background var(--motion-fast), transform var(--motion-fast),\r\n      box-shadow var(--motion-fast), opacity var(--motion-fast);\r\n  }\r\n\r\n  .picker .list-nav-btn:hover {\r\n    background: var(--pi-blue-pale);\r\n  }\r\n\r\n  .picker .list-nav-btn:active {\r\n    transform: scale(0.94);\r\n    background: var(--pi-blue);\r\n    color: var(--pi-white);\r\n  }\r\n\r\n  .picker .list-nav-btn:disabled {\r\n    opacity: 0.35;\r\n    cursor: not-allowed;\r\n    box-shadow: none;\r\n  }\r\n\r\n  .picker .list-nav-btn:focus-visible {\r\n    outline: 3px solid var(--pi-blue);\r\n    outline-offset: 3px;\r\n  }\r\n}\r\n\r\n/* Very wide viewports keep the same scrollbar-hugging anchor — no further\r\n   shift needed since the calc above already tracks the centered list edge.\r\n   This block stays for the slightly bumped button size. */\r\n@media (min-width: 1400px) {\r\n  .picker .list-nav {\r\n    /* Same anchor as above; explicit redeclaration keeps the new 96px\r\n         buttons aligned with the (now wider) calc lookup. */\r\n    right: max(16px, calc(50% - 550px - 12px - 96px));\r\n  }\r\n\r\n  .picker .list-nav-btn {\r\n    width: 96px;\r\n    height: 96px;\r\n  }\r\n}\r\n\r\n/* Fat scrollbar — much easier to grab on a touch display. */\r\n.picker .list::-webkit-scrollbar {\r\n  width: 22px;\r\n}\r\n\r\n.picker .list::-webkit-scrollbar-track {\r\n  background: var(--pi-gray-100);\r\n  border-radius: var(--radius-pill);\r\n}\r\n\r\n.picker .list::-webkit-scrollbar-thumb {\r\n  background: var(--pi-gray-300);\r\n  border-radius: var(--radius-pill);\r\n  border: 4px solid var(--pi-gray-100);\r\n}\r\n\r\n.picker .list::-webkit-scrollbar-thumb:hover {\r\n  background: var(--pi-gray-500);\r\n}\r\n\r\n.group-head {\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: 14px;\r\n  letter-spacing: 0.14em;\r\n  text-transform: uppercase;\r\n  color: var(--pi-gray-700);\r\n  padding: 20px 6px 10px;\r\n  position: sticky;\r\n  top: 0;\r\n  background: linear-gradient(\r\n    to bottom,\r\n    var(--pi-white) 78%,\r\n    rgba(255, 255, 255, 0)\r\n  );\r\n  z-index: 1;\r\n}\r\n\r\n.item {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 20px 22px;\r\n  border-radius: var(--radius-xl);\r\n  background: var(--pi-white);\r\n  border: 1px solid var(--pi-gray-200);\r\n  margin-bottom: 12px;\r\n  transition: background var(--motion-base), border-color var(--motion-base);\r\n}\r\n\r\n.item.flash {\r\n  animation: itemFlash 1.2s ease-out;\r\n}\r\n@keyframes itemFlash {\r\n  0% {\r\n    background: var(--pi-blue-pale);\r\n    border-color: var(--pi-blue);\r\n  }\r\n\r\n  100% {\r\n    background: var(--pi-white);\r\n    border-color: var(--pi-gray-200);\r\n  }\r\n}\r\n\r\n.item.selected.for {\r\n  background: rgba(7, 175, 170, 0.07);\r\n  border-color: #07afaa;\r\n}\r\n\r\n.item.selected.against {\r\n  background: rgba(208, 53, 60, 0.06);\r\n  border-color: #d0353c;\r\n}\r\n\r\n.item.selected.neutral {\r\n  background: var(--pi-gray-100);\r\n  border-color: var(--pi-gray-500);\r\n}\r\n\r\n/* \"Closed for sign-up\" treatment. AgendaItemStatus.AllowSpeakerRegistration=false\r\n     on the server resolves to acceptingSpeakers=false on the item — the row gets\r\n     dimmed, the num cell loses its tint, and stance buttons go non-interactive.\r\n     Title stays readable so the kiosk attendee can see what items are currently\r\n     active / completed without confusion. */\r\n.item.locked {\r\n  background: var(--pi-gray-100);\r\n  border-color: var(--pi-gray-200);\r\n  opacity: 0.78;\r\n}\r\n\r\n.item.locked .num {\r\n  background: var(--pi-gray-200);\r\n  color: var(--pi-gray-500);\r\n}\r\n\r\n.item.locked .title {\r\n  color: var(--pi-gray-700);\r\n}\r\n\r\n/* PR 5: badge moves inside .title-wrap (under the title) and gains a Lock\r\n     icon. The pill is now compact with an inline icon — better scannability\r\n     than the old corner-floated rectangle. */\r\n.locked-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  align-self: flex-start;\r\n  padding: 5px 10px;\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: 11px;\r\n  letter-spacing: 0.08em;\r\n  text-transform: uppercase;\r\n  color: var(--pi-gray-700);\r\n  background: var(--pi-gray-200);\r\n  border-radius: var(--radius-pill);\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Title + closed-badge stack vertically; we don't want the badge collapsing\r\n     to the right of a long title. .item-head is a 2-col grid (num + content)\r\n     and .title-wrap is the right-column flex column. */\r\n.item .title-wrap {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  min-width: 0;\r\n}\r\n\r\n/* PR 5: locked items REPLACE the three stance buttons with this explanatory\r\n     note. Pattern matches the design 5/20 — a dashed border + grey body\r\n     reads as \"informational, not a control\" while still leaving room in the\r\n     card height so adjacent items don't reflow when the lock state flips\r\n     mid-meeting. */\r\n.item .locked-note {\r\n  font-size: 15px;\r\n  color: var(--pi-gray-700);\r\n  background: var(--pi-white);\r\n  border: 1px dashed var(--pi-gray-300);\r\n  border-radius: var(--radius-md);\r\n  padding: 12px 16px;\r\n}\r\n\r\n/* AB#8889: shown under the (disabled) stance buttons when the user is at their\r\n   per-person item limit and this item isn't already selected. */\r\n.item .limit-note {\r\n  margin-top: 8px;\r\n  font-size: 13px;\r\n  color: var(--pi-gray-700);\r\n}\r\n\r\n/* AB#11358: per-section item limit, shown under the section heading. */\r\n.section-limit-note {\r\n  padding: 0 6px 10px;\r\n  font-size: 13px;\r\n  color: var(--pi-gray-700);\r\n}\r\n\r\n/* Disabled stance buttons: greyed out, no hover, cursor change. */\r\n.stance:disabled,\r\n.stance[aria-disabled=\"true\"] {\r\n  cursor: not-allowed;\r\n  opacity: 0.45;\r\n  color: var(--pi-gray-500);\r\n  box-shadow: inset 0 0 0 1.5px var(--pi-gray-200);\r\n  background: var(--pi-white);\r\n}\r\n\r\n.stance:disabled:hover,\r\n.stance[aria-disabled=\"true\"]:hover {\r\n  background: var(--pi-white);\r\n}\r\n\r\n.stance:disabled:active,\r\n.stance[aria-disabled=\"true\"]:active {\r\n  transform: none;\r\n}\r\n\r\n.item .item-head {\r\n  display: grid;\r\n  grid-template-columns: fit-content(140px) 1fr;\r\n  gap: 18px;\r\n  align-items: center;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.item .num {\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: 32px;\r\n  color: var(--pi-ink);\r\n  text-align: center;\r\n  background: var(--pi-gray-100);\r\n  border-radius: var(--radius-md);\r\n  padding: 12px 8px;\r\n  font-variant-numeric: tabular-nums;\r\n  min-width: 56px;\r\n  overflow-wrap: break-word;\r\n}\r\n\r\n.item.selected .num {\r\n  background: var(--pi-white);\r\n  color: var(--pi-blue);\r\n}\r\n\r\n.item .title {\r\n  /* Per source design: 400-weight reads cleaner on long government-motion\r\n       titles at kiosk distance. See P6. */\r\n  font-family: var(--font-body);\r\n  font-weight: 400;\r\n  font-size: 22px;\r\n  line-height: 1.4;\r\n  color: var(--pi-ink);\r\n  margin: 0;\r\n  text-wrap: pretty;\r\n}\r\n\r\n.item .stances {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 10px;\r\n}\r\n\r\n.stance {\r\n  appearance: none;\r\n  border: 0;\r\n  cursor: pointer;\r\n  padding: 16px 12px;\r\n  min-height: 76px;\r\n  border-radius: var(--radius-lg);\r\n  background: var(--pi-white);\r\n  box-shadow: inset 0 0 0 1.5px var(--pi-gray-300);\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: 17px;\r\n  color: var(--pi-ink);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 10px;\r\n  transition: background var(--motion-fast), color var(--motion-fast),\r\n    box-shadow var(--motion-fast), transform var(--motion-fast);\r\n  line-height: 1.1;\r\n}\r\n\r\n.stance:hover {\r\n  background: var(--pi-gray-100);\r\n}\r\n\r\n.stance:active {\r\n  transform: scale(0.98);\r\n}\r\n\r\n.stance .icon {\r\n  display: grid;\r\n  place-items: center;\r\n}\r\n\r\n.stance.on.for {\r\n  /* Darkened from #07afaa to meet WCAG 2.1 AA text contrast — white text on the\r\n     brand teal was ~2.7:1; #0a7d78 is ~5:1. Public-facing government kiosk. */\r\n  background: #0a7d78;\r\n  color: var(--pi-white);\r\n  box-shadow: inset 0 0 0 1.5px #0a7d78;\r\n}\r\n\r\n.stance.on.against {\r\n  background: #d0353c;\r\n  color: var(--pi-white);\r\n  box-shadow: inset 0 0 0 1.5px #d0353c;\r\n}\r\n\r\n.stance.on.neutral {\r\n  background: var(--pi-gray-700);\r\n  color: var(--pi-white);\r\n  box-shadow: inset 0 0 0 1.5px var(--pi-gray-700);\r\n}\r\n\r\n.item .stances.solo {\r\n  grid-template-columns: 1fr;\r\n}\r\n\r\n.stance.signup.on {\r\n  /* Same AA-contrast darkened teal as .stance.on.for — this is the primary\r\n     affirmative control in no-disposition mode, so legibility matters most here. */\r\n  background: #0a7d78;\r\n  color: var(--pi-white);\r\n  box-shadow: inset 0 0 0 1.5px #0a7d78;\r\n}\r\n\r\n/* ---------- Picks peek (sticky bottom of picker list) ---------- */\r\n.picks-peek {\r\n  appearance: none;\r\n  border: 0;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n  padding: 18px 32px;\r\n  background: var(--pi-gray-100);\r\n  border-top: 1px solid var(--pi-gray-200);\r\n  font-family: var(--font-display);\r\n  font-weight: 600;\r\n  font-size: 18px;\r\n  color: var(--pi-gray-700);\r\n  text-align: left;\r\n  min-height: 80px;\r\n}\r\n\r\n.picks-peek:disabled {\r\n  cursor: default;\r\n}\r\n\r\n.picks-peek.active {\r\n  color: var(--pi-ink);\r\n  background: var(--pi-blue-pale);\r\n}\r\n\r\n.picks-peek .label {\r\n  flex: 1;\r\n}\r\n\r\n.picks-peek .dots {\r\n  display: flex;\r\n  gap: 6px;\r\n}\r\n\r\n.picks-peek .dots .dot {\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 50%;\r\n  display: grid;\r\n  place-items: center;\r\n  color: var(--pi-white);\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: 16px;\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.picks-peek .dots .dot.for {\r\n  background: #07afaa;\r\n}\r\n\r\n.picks-peek .dots .dot.against {\r\n  background: #d0353c;\r\n}\r\n\r\n.picks-peek .dots .dot.neutral {\r\n  background: var(--pi-gray-700);\r\n}\r\n\r\n.picks-peek .dots .dot.total {\r\n  background: var(--pi-gray-700);\r\n}\r\n\r\n/* ---------- Bottom sheets ---------- */\r\n.sheet-scrim {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(20, 24, 28, 0.5);\r\n  display: flex;\r\n  align-items: flex-end;\r\n  justify-content: center;\r\n  z-index: 100;\r\n  animation: scrimIn var(--motion-base) ease-out;\r\n}\r\n@keyframes scrimIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.sheet {\r\n  width: 100%;\r\n  background: var(--pi-white);\r\n  border-top-left-radius: 24px;\r\n  border-top-right-radius: 24px;\r\n  padding: 24px 32px 32px;\r\n  box-shadow: 0 -20px 60px rgba(0, 0, 0, 0.2);\r\n  animation: sheetIn 320ms cubic-bezier(0.2, 0.8, 0.2, 1);\r\n  max-height: 85%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n@keyframes sheetIn {\r\n  from {\r\n    transform: translateY(40px);\r\n    opacity: 0.4;\r\n  }\r\n\r\n  to {\r\n    transform: translateY(0);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n/* AB#9443: center the language picker as a modal (only its scrim gets this;\r\n   Help/SMS stay bottom sheets). */\r\n.sheet-scrim-centered {\r\n  align-items: center;\r\n  padding: 24px;\r\n}\r\n\r\n.sheet-scrim-centered .sheet {\r\n  border-radius: 24px;\r\n}\r\n\r\n.sheet-head {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.sheet-head h3 {\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: 26px;\r\n  margin: 0;\r\n  color: var(--pi-ink);\r\n}\r\n\r\n.sheet-close {\r\n  appearance: none;\r\n  border: 0;\r\n  cursor: pointer;\r\n  width: 56px;\r\n  height: 56px;\r\n  border-radius: 50%;\r\n  background: var(--pi-gray-100);\r\n  color: var(--pi-ink);\r\n  font-size: 28px;\r\n  font-weight: 700;\r\n  display: grid;\r\n  place-items: center;\r\n}\r\n\r\n.sheet-sub {\r\n  color: var(--pi-gray-700);\r\n  font-size: 18px;\r\n  margin: 6px 0 18px;\r\n}\r\n\r\n.jump-sheet {\r\n  padding-bottom: 40px;\r\n}\r\n\r\n.jumpdisplay {\r\n  background: var(--pi-gray-100);\r\n  border-radius: var(--radius-lg);\r\n  padding: 22px 18px;\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: 56px;\r\n  color: var(--pi-ink);\r\n  text-align: center;\r\n  margin-bottom: 18px;\r\n  font-variant-numeric: tabular-nums;\r\n  letter-spacing: 0.08em;\r\n}\r\n\r\n.jumpdisplay.empty {\r\n  color: var(--pi-gray-300);\r\n}\r\n\r\n.keypad {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 12px;\r\n}\r\n\r\n.keypad button {\r\n  appearance: none;\r\n  border: 0;\r\n  cursor: pointer;\r\n  min-height: 88px;\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: 32px;\r\n  color: var(--pi-ink);\r\n  background: var(--pi-white);\r\n  border-radius: var(--radius-lg);\r\n  box-shadow: inset 0 0 0 1px var(--pi-gray-300);\r\n}\r\n\r\n.keypad button:hover {\r\n  background: var(--pi-gray-100);\r\n}\r\n\r\n.keypad button:active {\r\n  transform: scale(0.97);\r\n}\r\n\r\n.keypad button.go {\r\n  background: var(--pi-blue);\r\n  color: var(--pi-white);\r\n  box-shadow: none;\r\n  font-size: 22px;\r\n}\r\n\r\n.keypad button.go:disabled {\r\n  background: var(--pi-gray-200);\r\n  color: var(--pi-gray-500);\r\n  cursor: not-allowed;\r\n}\r\n\r\n.keypad button.del {\r\n  color: var(--pi-gray-700);\r\n  font-size: 26px;\r\n}\r\n\r\n/* PR 5: dash key on the number-pad lives in the bottom-left slot (where the\r\n     old \"Go\" lived) so the muscle-memory of \"bottom row = secondary actions\"\r\n     stays consistent across modes. Brand color signals it's a special key\r\n     vs. plain digit. */\r\n.keypad button.keypad-alt {\r\n  font-size: 26px;\r\n  color: var(--pi-blue);\r\n}\r\n\r\n/* 123 / Letters mode toggle. A pill-shaped segmented control above the\r\n     keypad. The active segment gets the brand fill so the current mode is\r\n     unambiguous; the abc-glyph badge gives the Letters segment a visual\r\n     anchor when shrunk on narrow viewports. */\r\n.jump-mode {\r\n  display: flex;\r\n  background: var(--pi-gray-100);\r\n  border-radius: var(--radius-pill);\r\n  padding: 4px;\r\n  margin: 14px auto;\r\n  max-width: 380px;\r\n}\r\n\r\n.jump-mode button {\r\n  appearance: none;\r\n  border: 0;\r\n  cursor: pointer;\r\n  flex: 1;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  padding: 12px 18px;\r\n  min-height: 52px;\r\n  border-radius: var(--radius-pill);\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: 15px;\r\n  color: var(--pi-gray-700);\r\n  background: transparent;\r\n}\r\n\r\n.jump-mode button.on {\r\n  background: var(--pi-blue);\r\n  color: var(--pi-white);\r\n  box-shadow: 0 2px 6px rgba(3, 149, 255, 0.25);\r\n}\r\n\r\n.jump-mode .abc-glyph {\r\n  font-family: var(--font-display);\r\n  font-weight: 800;\r\n  font-size: 12px;\r\n  letter-spacing: 0.04em;\r\n  background: rgba(255, 255, 255, 0.18);\r\n  padding: 2px 6px;\r\n  border-radius: 4px;\r\n}\r\n\r\n.jump-mode button:not(.on) .abc-glyph {\r\n  background: var(--pi-gray-200);\r\n  color: var(--pi-gray-700);\r\n}\r\n\r\n/* Letter keypad — 7-column grid (A-G / H-N / O-U / V-Z + dash + ⌫). Smaller\r\n     buttons than .keypad because there are 28 cells; still ≥48px tall to\r\n     satisfy the kiosk touch-target minimum. */\r\n.keypad-abc {\r\n  display: grid;\r\n  grid-template-columns: repeat(7, 1fr);\r\n  gap: 8px;\r\n}\r\n\r\n.keypad-abc button {\r\n  appearance: none;\r\n  border: 0;\r\n  cursor: pointer;\r\n  min-height: 56px;\r\n  border-radius: var(--radius-md);\r\n  background: var(--pi-white);\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: 20px;\r\n  color: var(--pi-ink);\r\n  box-shadow: inset 0 0 0 1px var(--pi-gray-300);\r\n}\r\n\r\n.keypad-abc button:hover {\r\n  background: var(--pi-gray-100);\r\n}\r\n\r\n.keypad-abc button:active {\r\n  transform: scale(0.96);\r\n}\r\n\r\n.keypad-abc button.del {\r\n  color: var(--pi-gray-700);\r\n  font-size: 20px;\r\n}\r\n\r\n.keypad-abc button.keypad-alt {\r\n  color: var(--pi-blue);\r\n  font-size: 22px;\r\n}\r\n\r\n/* Jump-foot — Clear + Find item buttons. Each .btn flexes equally so the\r\n     two halves balance regardless of label length. The Find item button\r\n     stays disabled until at least one character is typed; visual disabled\r\n     state comes from the existing .btn.primary:disabled cascade. */\r\n.jump-foot {\r\n  display: flex;\r\n  gap: 10px;\r\n  margin-top: 18px;\r\n}\r\n\r\n.jump-foot .btn {\r\n  flex: 1;\r\n  justify-content: center;\r\n}\r\n\r\n.picks-sheet {\r\n  padding-bottom: 24px;\r\n}\r\n\r\n.basket {\r\n  overflow-y: auto;\r\n  margin-top: 8px;\r\n}\r\n\r\n.basket .empty {\r\n  background: var(--pi-gray-100);\r\n  border-radius: var(--radius-lg);\r\n  padding: 28px;\r\n  text-align: center;\r\n  color: var(--pi-gray-700);\r\n  font-size: 17px;\r\n}\r\n\r\n.chip {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 14px;\r\n  padding: 16px 18px;\r\n  background: var(--pi-white);\r\n  border: 1px solid var(--pi-gray-200);\r\n  border-radius: var(--radius-lg);\r\n  margin-bottom: 10px;\r\n  font-size: 17px;\r\n  color: var(--pi-ink);\r\n}\r\n\r\n.chip .n {\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  color: var(--pi-blue);\r\n  min-width: 44px;\r\n  font-size: 18px;\r\n}\r\n\r\n.chip .dot {\r\n  width: 14px;\r\n  height: 14px;\r\n  border-radius: 50%;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.chip .dot.for {\r\n  background: #07afaa;\r\n}\r\n\r\n.chip .dot.against {\r\n  background: #d0353c;\r\n}\r\n\r\n.chip .dot.neutral {\r\n  background: var(--pi-gray-700);\r\n}\r\n\r\n.chip .dot.total {\r\n  background: var(--pi-gray-500);\r\n}\r\n\r\n/* Two-line clamp so long government-motion titles read in the basket\r\n     instead of being cut off mid-word at ~50 chars. See H3. */\r\n.chip .label {\r\n  flex: 1;\r\n  min-width: 0;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n  line-height: 1.35;\r\n}\r\n\r\n.chip .x {\r\n  appearance: none;\r\n  border: 0;\r\n  cursor: pointer;\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 50%;\r\n  background: var(--pi-gray-200);\r\n  color: var(--pi-gray-700);\r\n  font-weight: 700;\r\n  font-size: 20px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Empty / no-results */\r\n.empty-state {\r\n  text-align: center;\r\n  padding: 80px 20px;\r\n  color: var(--pi-gray-700);\r\n}\r\n\r\n.empty-state .big {\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: 24px;\r\n  color: var(--pi-ink);\r\n  margin: 0 0 8px;\r\n}\r\n\r\n/* ===========================================================\r\n     SCREEN 4 — REVIEW\r\n     =========================================================== */\r\n.review {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n\r\n  /* Same halo + dot-grid atmosphere as Welcome/Info so the dead space below\r\n       the items list reads as intentional negative space, not abandoned canvas. */\r\n  background: radial-gradient(\r\n      ellipse 80% 30% at 50% 0%,\r\n      var(--pi-blue-pale) 0%,\r\n      transparent 70%\r\n    ),\r\n    radial-gradient(\r\n      ellipse 80% 30% at 50% 100%,\r\n      rgba(219, 241, 255, 0.45) 0%,\r\n      transparent 65%\r\n    ),\r\n    radial-gradient(\r\n        circle at 1px 1px,\r\n        rgba(3, 149, 255, 0.04) 1px,\r\n        transparent 1px\r\n      )\r\n      0 0 / 32px 32px,\r\n    var(--pi-white);\r\n}\r\n\r\n.review .main {\r\n  padding: 40px 48px 16px;\r\n  overflow: auto;\r\n  flex: 1;\r\n  min-height: 0;\r\n  width: 100%;\r\n  max-width: 1100px;\r\n  margin: 0 auto;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.review h2 {\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: 42px;\r\n  margin: 0 0 10px;\r\n}\r\n\r\n.review .lede {\r\n  font-size: 20px;\r\n  color: var(--pi-gray-700);\r\n  margin: 0 0 28px;\r\n  max-width: 720px;\r\n}\r\n\r\n.review .who {\r\n  background: var(--pi-blue-pale);\r\n  border-radius: var(--radius-xl);\r\n  padding: 22px 26px;\r\n  margin-bottom: 28px;\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  gap: 18px 36px;\r\n}\r\n\r\n.review .who .field-label {\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: 13px;\r\n  letter-spacing: 0.08em;\r\n  text-transform: uppercase;\r\n  color: var(--pi-blue);\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.review .who .field-val {\r\n  font-family: var(--font-display);\r\n  font-weight: 600;\r\n  font-size: 20px;\r\n  color: var(--pi-ink);\r\n}\r\n\r\n/* Masked PII row — the value is PERMANENTLY masked. No reveal toggle, no\r\n     \"tap to show\" button. A kiosk is a public-facing terminal; any unmask\r\n     affordance lets a shoulder-surfer harvest the contact info of whoever\r\n     just hydrated their registration via Lookup. If the legitimate user needs\r\n     to verify or change their address, they tap Back to the Your Info screen\r\n     where the inputs remain editable in clear text. */\r\n.review .who .field-val.masked-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  flex-wrap: nowrap;\r\n}\r\n\r\n.review .who .masked-val {\r\n  /* tabular-nums keeps the bullet-mask + last-4 phone digits aligned */\r\n  font-variant-numeric: tabular-nums;\r\n  word-break: break-all;\r\n  min-width: 0;\r\n}\r\n\r\n/* Summary stat strip — horizontal */\r\n.review .stats {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 12px;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.stat {\r\n  background: var(--pi-white);\r\n  border: 1px solid var(--pi-gray-200);\r\n  border-radius: var(--radius-xl);\r\n  padding: 20px 22px;\r\n}\r\n\r\n.stat .v {\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: 40px;\r\n  line-height: 1;\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.stat .v .of {\r\n  font-size: 20px;\r\n  color: var(--pi-gray-500);\r\n}\r\n\r\n.stat .l {\r\n  font-size: 15px;\r\n  color: var(--pi-gray-700);\r\n  margin-top: 8px;\r\n  font-family: var(--font-display);\r\n  font-weight: 600;\r\n  letter-spacing: 0.04em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.stat.for .v {\r\n  color: #07afaa;\r\n}\r\n\r\n.stat.against .v {\r\n  color: #d0353c;\r\n}\r\n\r\n.stat.neutral .v {\r\n  color: var(--pi-gray-700);\r\n}\r\n\r\n.review .selections h3 {\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: 22px;\r\n  margin: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.review .who-head,\r\n.review .selections-head {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n  margin-bottom: 14px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.review .who-head h3 {\r\n  font-family: var(--font-display);\r\n  font-size: clamp(18px, 1.6vw, 22px);\r\n  color: var(--pi-ink);\r\n  margin: 0;\r\n}\r\n\r\n.edit-step-btn {\r\n  background: var(--pi-white);\r\n  color: var(--pi-blue);\r\n  box-shadow: inset 0 0 0 2px var(--pi-blue);\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: 16px;\r\n  padding: 12px 20px;\r\n  min-height: 52px;\r\n  border-radius: var(--radius-lg);\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  cursor: pointer;\r\n  transition: background var(--motion-base);\r\n}\r\n\r\n.edit-step-btn:hover {\r\n  background: var(--pi-blue-pale);\r\n}\r\n\r\n.edit-step-btn:active {\r\n  transform: translateY(1px);\r\n}\r\n\r\n/* Bigger CTA inside the empty-state when there are no picks yet — gives\r\n     the user an unmissable doorway back into the picker. */\r\n.review .review-empty {\r\n  background: var(--pi-blue-pale);\r\n  border: 1px dashed var(--pi-blue);\r\n  border-radius: var(--radius-xl);\r\n  padding: 28px 24px;\r\n  text-align: center;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.review .review-empty .big {\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: 22px;\r\n  color: var(--pi-ink);\r\n  margin: 0 0 8px;\r\n}\r\n\r\n.review .review-empty p {\r\n  font-size: 16px;\r\n  color: var(--pi-gray-700);\r\n  margin: 0 auto 20px;\r\n  max-width: 520px;\r\n  line-height: 1.5;\r\n}\r\n\r\n.review .review-empty .btn {\r\n  margin: 0 auto;\r\n}\r\n\r\n.review .row {\r\n  display: grid;\r\n  grid-template-columns: fit-content(140px) 1fr auto;\r\n  gap: 18px;\r\n  align-items: center;\r\n  background: var(--pi-white);\r\n  border: 1px solid var(--pi-gray-200);\r\n  border-radius: var(--radius-lg);\r\n  padding: 16px 18px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.review .row .num {\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: 24px;\r\n  text-align: center;\r\n  background: var(--pi-gray-100);\r\n  border-radius: var(--radius-md);\r\n  padding: 8px 6px;\r\n  min-width: 56px;\r\n  overflow-wrap: break-word;\r\n}\r\n\r\n.review .row .title {\r\n  font-size: 18px;\r\n  color: var(--pi-ink);\r\n}\r\n\r\n.review .row .badge {\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: 14px;\r\n  padding: 8px 16px;\r\n  border-radius: var(--radius-pill);\r\n  color: var(--pi-white);\r\n  letter-spacing: 0.04em;\r\n  text-transform: uppercase;\r\n  min-width: 110px;\r\n  text-align: center;\r\n}\r\n\r\n.review .row .badge.for {\r\n  background: #07afaa;\r\n}\r\n\r\n.review .row .badge.against {\r\n  background: #d0353c;\r\n}\r\n\r\n.review .row .badge.neutral {\r\n  background: var(--pi-gray-700);\r\n}\r\n\r\n.review .opt {\r\n  background: var(--pi-gray-100);\r\n  border-radius: var(--radius-xl);\r\n  padding: 18px 22px;\r\n  margin-top: 28px;\r\n}\r\n\r\n/* Settles the review screen when the items list is short. See H4. */\r\n.review-tail {\r\n  margin: 28px 0 64px;\r\n  text-align: center;\r\n  color: var(--pi-gray-700);\r\n  font-size: 15px;\r\n  letter-spacing: 0.04em;\r\n  font-family: var(--font-display);\r\n  font-weight: 500;\r\n}\r\n\r\n.review-tail strong {\r\n  color: var(--pi-blue);\r\n  font-weight: 700;\r\n}\r\n\r\n.review .opt label {\r\n  display: flex;\r\n  gap: 14px;\r\n  align-items: flex-start;\r\n  cursor: pointer;\r\n  font-size: 17px;\r\n  color: var(--pi-ink);\r\n}\r\n\r\n/* .review .opt input[type=\"checkbox\"] is styled by the shared surrogate-checkbox\r\n     rule above (see H5). The duplicate badge rules from a copy-paste have been\r\n     removed — the canonical .review .row .badge.* rules sit a few lines up. */\r\n\r\n.done-translate-bar {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  padding: 8px 24px;\r\n}\r\n\r\n/* ===========================================================\r\n     SCREEN 5 — DONE\r\n     =========================================================== */\r\n.confirmation {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  justify-content: safe center;\r\n  overflow-y: auto;\r\n  text-align: center;\r\n  padding: 48px;\r\n  background: radial-gradient(\r\n    ellipse at 50% 0%,\r\n    var(--pi-blue-pale) 0%,\r\n    transparent 60%\r\n  );\r\n}\r\n\r\n.confirmation .check {\r\n  flex-shrink: 0;\r\n  width: 120px;\r\n  height: 120px;\r\n\r\n  /* flex-shrink:0 — .confirmation is a flex column. Without this, when the\r\n     Done content overflows the stage (long agenda-item lists, or the taller\r\n     wrapped copy of a translated language like Spanish), the flex column\r\n     shrinks this fixed-height circle on the vertical axis while its 120px\r\n     width is preserved on the cross axis — collapsing the circle into a wide\r\n     ellipse. Locking flex-shrink keeps it perfectly round at any content\r\n     height. */\r\n  flex-shrink: 0;\r\n  border-radius: 50%;\r\n  background: #07afaa;\r\n  color: var(--pi-white);\r\n  display: grid;\r\n  place-items: center;\r\n  margin: 0 auto 28px;\r\n  box-shadow: 0 12px 36px rgba(7, 175, 170, 0.3);\r\n}\r\n\r\n.confirmation h1 {\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: 48px;\r\n  margin: 0 0 12px;\r\n}\r\n\r\n.confirmation .number {\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: 22px;\r\n  color: var(--pi-blue);\r\n  margin-bottom: 8px;\r\n  letter-spacing: 0.08em;\r\n}\r\n\r\n.confirmation p {\r\n  font-size: 20px;\r\n  color: var(--pi-gray-700);\r\n  max-width: 640px;\r\n  margin: 0 auto 32px;\r\n}\r\n\r\n/* Race-condition soft notice on Done — items that closed for sign-up between\r\n     Picker render and server processing. Amber tint to read as \"heads up\" not\r\n     \"error\", since the user's other selections all went through. */\r\n.dropped-notice {\r\n  background: #fff7e6;\r\n  border: 1px solid #ff7c1d;\r\n  border-radius: var(--radius-xl);\r\n  padding: 18px 22px;\r\n  margin: 0 auto 28px;\r\n  max-width: 640px;\r\n  text-align: left;\r\n  color: var(--pi-ink);\r\n}\r\n\r\n.dropped-notice .dropped-head {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-bottom: 8px;\r\n  font-family: var(--font-display);\r\n  font-size: 16px;\r\n  color: var(--pi-ink);\r\n}\r\n\r\n.dropped-notice .dropped-head svg {\r\n  color: var(--pi-orange);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.dropped-notice p {\r\n  font-size: 15px;\r\n  color: var(--pi-gray-700);\r\n  margin: 0 0 10px;\r\n  max-width: none;\r\n}\r\n\r\n.dropped-notice ul {\r\n  margin: 0;\r\n  padding-left: 22px;\r\n  font-size: 15px;\r\n  line-height: 1.5;\r\n  color: var(--pi-ink);\r\n}\r\n\r\n.dropped-notice ul li {\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.kiosk-notice {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 12px;\r\n  background: #fff7e6;\r\n  border: 1px solid #ff7c1d;\r\n  border-radius: var(--radius-xl);\r\n  padding: 14px 16px;\r\n  margin: 12px 20px 0;\r\n  color: var(--pi-ink);\r\n}\r\n\r\n.kiosk-notice-body {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 10px;\r\n  flex: 1;\r\n  font-size: 15px;\r\n  line-height: 1.45;\r\n}\r\n\r\n.kiosk-notice-body svg {\r\n  color: var(--pi-orange);\r\n  flex-shrink: 0;\r\n  margin-top: 1px;\r\n}\r\n\r\n.kiosk-notice-close {\r\n  flex-shrink: 0;\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 24px;\r\n  line-height: 1;\r\n  color: var(--pi-gray-700);\r\n  padding: 0 4px;\r\n}\r\n\r\n/* Matches the Review screen's .stat tiles: the count is the headline, the label supports it.\r\n   flex-shrink:0 for the same reason as .check -- .confirmation is a flex column. */\r\n.speaking-summary {\r\n  flex-shrink: 0;\r\n  margin: 0 0 32px;\r\n  padding: 20px 32px;\r\n  min-width: 240px;\r\n  max-width: 100%;\r\n  background: var(--pi-white);\r\n  border: 1px solid var(--pi-gray-200);\r\n  border-radius: var(--radius-xl);\r\n  text-align: center;\r\n}\r\n\r\n.speaking-summary dt {\r\n  font-family: var(--font-display);\r\n  font-weight: 600;\r\n  font-size: 15px;\r\n  letter-spacing: 0.04em;\r\n  text-transform: uppercase;\r\n  color: var(--pi-gray-700);\r\n}\r\n\r\n.speaking-summary dd {\r\n  display: flex;\r\n  align-items: baseline;\r\n  justify-content: center;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n  margin: 8px 0 0;\r\n}\r\n\r\n.speaking-summary .count {\r\n  font-family: var(--font-display);\r\n  font-weight: 700;\r\n  font-size: 40px;\r\n  line-height: 1;\r\n  color: var(--pi-ink);\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.speaking-summary .unit {\r\n  font-family: var(--font-display);\r\n  font-weight: 600;\r\n  font-size: 20px;\r\n  color: var(--pi-gray-700);\r\n}\r\n\r\n/* ---------- Tweaks (font scale) ---------- */\r\nbody.fs-comfortable .picker .item .title {\r\n  font-size: 24px;\r\n}\r\n\r\nbody.fs-comfortable .item .num {\r\n  font-size: 34px;\r\n}\r\n\r\nbody.fs-large .picker .item .title {\r\n  font-size: 26px;\r\n}\r\n\r\nbody.fs-large .item .num {\r\n  font-size: 36px;\r\n}\r\n\r\nbody.fs-large .stance {\r\n  font-size: 19px;\r\n  min-height: 84px;\r\n}\r\n\r\nbody.fs-large .picker .search input {\r\n  font-size: 28px;\r\n}\r\n\r\n/* ===========================================================\r\n     RESPONSIVE — tablet, laptop, narrow phones\r\n     Below 900px wide we tighten chrome paddings and fonts.\r\n     Below 600px (small tablets / phones in portrait) we collapse\r\n     to a phone-friendly density.\r\n     =========================================================== */\r\n@media (max-width: 900px) {\r\n  .topbar {\r\n    padding: 14px 20px;\r\n  }\r\n\r\n  .agency .seal {\r\n    width: 40px;\r\n    height: 40px;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .agency .text .org {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .agency .text .meta {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .topbar .clock {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .topbar .clock .date {\r\n    font-size: 11px;\r\n  }\r\n\r\n  .progress {\r\n    padding: 6px 16px;\r\n    min-height: 52px;\r\n    gap: 8px 10px;\r\n  }\r\n\r\n  .progress .step {\r\n    font-size: 13px;\r\n    padding: 6px 10px;\r\n    gap: 8px;\r\n  }\r\n\r\n  .progress .step .num {\r\n    width: 24px;\r\n    height: 24px;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .progress .help {\r\n    padding: 6px 10px;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .welcome-scroll {\r\n    padding: 32px 24px;\r\n  }\r\n\r\n  .welcome h1 {\r\n    font-size: 36px;\r\n  }\r\n\r\n  .welcome p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .welcome .meeting-card {\r\n    padding: 18px 22px;\r\n  }\r\n\r\n  .welcome .meeting-card .title {\r\n    font-size: 22px;\r\n  }\r\n\r\n  .info {\r\n    padding: 32px 24px;\r\n    gap: 24px;\r\n  }\r\n\r\n  .info .lead h2 {\r\n    font-size: 32px;\r\n  }\r\n\r\n  .info .lead p {\r\n    font-size: 17px;\r\n  }\r\n\r\n  .info .field input {\r\n    font-size: 20px;\r\n    min-height: 60px;\r\n    padding: 16px 18px;\r\n  }\r\n\r\n  .info .attend label {\r\n    font-size: 17px;\r\n    min-height: 60px;\r\n    padding: 16px 18px;\r\n  }\r\n\r\n  .picker .search-row {\r\n    padding: 16px 20px 8px;\r\n  }\r\n\r\n  .picker .filters {\r\n    padding: 4px 20px 10px;\r\n  }\r\n\r\n  .picker .list {\r\n    padding: 4px 20px 8px;\r\n  }\r\n\r\n  .picker .search input {\r\n    font-size: 20px;\r\n    min-height: 60px;\r\n    padding: 16px 16px 16px 52px;\r\n  }\r\n\r\n  .picker .search svg {\r\n    left: 16px;\r\n  }\r\n\r\n  .picker .jump-btn {\r\n    font-size: 16px;\r\n    padding: 16px 18px;\r\n    min-height: 60px;\r\n  }\r\n\r\n  .picker .jump-btn span {\r\n    display: none;\r\n  }\r\n\r\n  .item {\r\n    padding: 16px 16px;\r\n  }\r\n\r\n  .item .item-head {\r\n    grid-template-columns: fit-content(110px) 1fr;\r\n    gap: 14px;\r\n    margin-bottom: 12px;\r\n  }\r\n\r\n  .item .num {\r\n    font-size: 24px;\r\n    padding: 8px 6px;\r\n    min-width: 44px;\r\n  }\r\n\r\n  .item .title {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .stance {\r\n    font-size: 14px;\r\n    min-height: 60px;\r\n    padding: 10px 8px;\r\n    gap: 6px;\r\n  }\r\n\r\n  .picks-peek {\r\n    padding: 14px 20px;\r\n    min-height: 64px;\r\n    font-size: 15px;\r\n  }\r\n\r\n  .picks-peek .dots .dot {\r\n    width: 32px;\r\n    height: 32px;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .actionbar {\r\n    padding: 14px 20px;\r\n    min-height: 80px;\r\n    gap: 10px;\r\n  }\r\n\r\n  .actionbar .summary {\r\n    font-size: 15px;\r\n  }\r\n\r\n  .actionbar .summary .sub {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .btn {\r\n    font-size: 16px;\r\n    padding: 14px 20px;\r\n    min-height: 56px;\r\n  }\r\n\r\n  .btn.lg {\r\n    font-size: 18px;\r\n    padding: 16px 24px;\r\n    min-height: 60px;\r\n  }\r\n\r\n  .btn.xl {\r\n    font-size: 20px;\r\n    padding: 20px 30px;\r\n    min-height: 72px;\r\n  }\r\n\r\n  .review .main {\r\n    padding: 28px 24px 12px;\r\n  }\r\n\r\n  .review h2 {\r\n    font-size: 30px;\r\n  }\r\n\r\n  .review .lede {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .review .who {\r\n    padding: 16px 18px;\r\n    gap: 12px 20px;\r\n  }\r\n\r\n  .review .who .field-val {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .stat .v {\r\n    font-size: 30px;\r\n  }\r\n\r\n  .review .row .num {\r\n    font-size: 20px;\r\n    min-width: 44px;\r\n  }\r\n\r\n  .review .row .title {\r\n    font-size: 15px;\r\n  }\r\n\r\n  .review .row {\r\n    grid-template-columns: fit-content(100px) 1fr auto;\r\n    gap: 12px;\r\n    padding: 12px 14px;\r\n  }\r\n\r\n  .review .row .badge {\r\n    font-size: 11px;\r\n    padding: 6px 12px;\r\n    min-width: 88px;\r\n  }\r\n\r\n  .confirmation {\r\n    padding: 32px 24px;\r\n  }\r\n\r\n  .confirmation h1 {\r\n    font-size: 32px;\r\n  }\r\n\r\n  .confirmation p {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .confirmation .check {\r\n    width: 88px;\r\n    height: 88px;\r\n  }\r\n\r\n  .confirmation .check svg {\r\n    width: 48px;\r\n    height: 48px;\r\n  }\r\n\r\n  .speaking-summary {\r\n    min-width: 0;\r\n    margin-bottom: 24px;\r\n    padding: 16px 24px;\r\n  }\r\n\r\n  .speaking-summary .count {\r\n    font-size: 32px;\r\n  }\r\n\r\n  .speaking-summary .unit {\r\n    font-size: 17px;\r\n  }\r\n\r\n  .sheet {\r\n    padding: 18px 22px 24px;\r\n  }\r\n\r\n  .sheet-head h3 {\r\n    font-size: 22px;\r\n  }\r\n\r\n  .jumpdisplay {\r\n    font-size: 44px;\r\n    padding: 18px 14px;\r\n  }\r\n\r\n  .keypad button {\r\n    font-size: 26px;\r\n    min-height: 72px;\r\n  }\r\n\r\n  .keypad button.go {\r\n    font-size: 18px;\r\n  }\r\n\r\n  /* PR 5: alphabet keypad shrinks to 6 columns on phones so all 28 keys\r\n       still fit without the buttons collapsing below the 48px touch min. */\r\n  .keypad-abc {\r\n    grid-template-columns: repeat(6, 1fr);\r\n  }\r\n\r\n  .keypad-abc button {\r\n    min-height: 48px;\r\n    font-size: 18px;\r\n  }\r\n\r\n  .jump-mode button {\r\n    font-size: 14px;\r\n    min-height: 44px;\r\n  }\r\n}\r\n\r\n/* Progress strip collapses to step-of-N on phones */\r\n@media (max-width: 560px) {\r\n  .progress .step:not(.active) .step-label {\r\n    display: none;\r\n  }\r\n\r\n  .progress .step.active {\r\n    flex: 1 1 auto;\r\n  }\r\n\r\n  .progress .help {\r\n    padding: 6px 8px;\r\n  }\r\n\r\n  .progress .help > span {\r\n    display: none;\r\n  }\r\n\r\n  .info .field-row {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .info .attend {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .item .stances {\r\n    gap: 6px;\r\n  }\r\n\r\n  .stance {\r\n    font-size: 13px;\r\n    padding: 8px 6px;\r\n    min-height: 56px;\r\n  }\r\n\r\n  .stance .icon svg {\r\n    width: 18px;\r\n    height: 18px;\r\n  }\r\n\r\n  .review .who {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .review .row {\r\n    grid-template-columns: 48px 1fr;\r\n    row-gap: 10px;\r\n  }\r\n\r\n  .review .row .badge {\r\n    grid-column: 1 / -1;\r\n    min-width: 0;\r\n    justify-self: start;\r\n  }\r\n}\r\n\r\n/* When the kiosk is short (laptop landscape ≤720px tall),\r\n     reduce vertical padding so the picker list still has room. */\r\n@media (max-height: 720px) {\r\n  .topbar {\r\n    padding: 10px 24px;\r\n  }\r\n\r\n  .progress {\r\n    min-height: 44px;\r\n    padding-block: 4px;\r\n  }\r\n\r\n  /* There is no vertical room to wrap labels here, so the inactive ones become numbers\r\n     rather than being cut in half. */\r\n  .progress .step:not(.active) .step-label {\r\n    display: none;\r\n  }\r\n\r\n  .progress .step.active {\r\n    flex: 1 1 auto;\r\n  }\r\n\r\n  .welcome-scroll {\r\n    padding: 24px;\r\n  }\r\n\r\n  .welcome h1 {\r\n    font-size: 32px;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .welcome p {\r\n    font-size: 16px;\r\n    margin-bottom: 18px;\r\n  }\r\n\r\n  .welcome .meeting-card {\r\n    margin-bottom: 20px;\r\n    padding: 14px 20px;\r\n  }\r\n\r\n  .welcome .lang {\r\n    margin-top: 18px;\r\n  }\r\n\r\n  .info {\r\n    padding: 16px 32px;\r\n    gap: 12px;\r\n  }\r\n\r\n  .info .lead h2 {\r\n    font-size: 28px;\r\n    margin-bottom: 4px;\r\n  }\r\n\r\n  .info .lead p {\r\n    font-size: 15px;\r\n    margin-bottom: 8px;\r\n  }\r\n\r\n  .info .form {\r\n    gap: 10px;\r\n  }\r\n\r\n  .info .field {\r\n    gap: 4px;\r\n  }\r\n\r\n  .info .field label {\r\n    font-size: 15px;\r\n  }\r\n\r\n  .info .field input:not([type=\"checkbox\"]):not([type=\"radio\"]) {\r\n    font-size: 18px;\r\n    min-height: 44px;\r\n    padding: 10px 14px;\r\n  }\r\n\r\n  .info .field .custom-field-select {\r\n    font-size: 18px;\r\n    min-height: 44px;\r\n    padding: 10px 14px;\r\n  }\r\n\r\n  .sms-consent {\r\n    padding: 6px 0;\r\n  }\r\n\r\n  .sms-consent .sms-copy {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .interpreter-section {\r\n    padding: var(--space-3);\r\n    margin-top: var(--space-2);\r\n  }\r\n\r\n  .interpreter-legend {\r\n    font-size: var(--fs-body);\r\n  }\r\n\r\n  .interpreter-option {\r\n    padding: 10px 16px;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .interpreter-toggle {\r\n    margin-top: var(--space-2);\r\n  }\r\n\r\n  .actionbar {\r\n    min-height: 60px;\r\n    padding: 10px 24px;\r\n  }\r\n\r\n  .picker .search-row {\r\n    padding-top: 14px;\r\n    padding-bottom: 8px;\r\n  }\r\n\r\n  .picker .filters {\r\n    padding-bottom: 8px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
